import Draggable from 'vuedraggable';

/**
 * Store Share
 *
 * @since: 2019-10-08
 * @author: kdydesign.kim
 */

var store = {
  __installed: false,
  install: function install ($table, Vue, storeSet) {
    if (this.__installed) {
      return
    }

    this.__installed = true;

    this.set = function (store, model) {
      if ( store === void 0 ) store = void 0;
      if ( model === void 0 ) model = 'ngf';

      $table.store = store;
      $table.model = model.toLowerCase();

      if ($table.store) {
        $table.store = store;
      } else {
        Vue.util.defineReactive($table, 'store', store);
      }
    };

    this.set(storeSet);
  }
};

/**
 * locales
 * ko-kr
 *
 * @since: 2019-10-08
 * @author: kdydesign.kim
 */
var langKr = {
  lang: 'ko-kr',
  label: {
    allView: '모두보기',
    enabled: '활성',
    disabled: '비활성'
  }
};

/**
 * locales
 * en-us
 *
 * @since: 2019-10-08
 * @author: kdydesign.kim
 */
var langEn = {
  lang: 'en-us',
  label: {
    allView: 'All View',
    enabled: 'Enabled',
    disabled: 'Disabled'
  }
};

/**
 * locales
 * ja
 *
 * @since: 2019-10-08
 * @author: kdydesign.kim
 */
var langJa = {
  lang: 'ja',
  label: {
    allView: '皆見',
    enabled: '活性',
    disabled: '非活性'
  }
};

/**
 * i18n
 *
 * @since: 2019-10-08
 * @author: kdydesign.kim
 */

var i18n = {
  install: function install ($table, Vue, lang) {
    var this$1 = this;

    this.set = function (lang) {
      if ( lang === void 0 ) lang = 'ko-kr';

      var langObj = langKr;

      if (lang === 'ko-kr' || lang.indexOf('ko') > -1 || lang.indexOf('kr') > -1) {
        langObj = langKr;
      }

      if (lang === 'en-us' || lang.indexOf('en') > -1 || lang.indexOf('us') > -1) {
        langObj = langEn;
      }

      if (lang === 'ja') {
        langObj = langJa;
      }

      langObj.set = this$1.set;
      langObj.getLocale = this$1.getLocale;
      langObj.rtl = langObj.rtl || false;

      var el = document.documentElement;

      el.setAttribute('dir', langObj.rtl ? 'rtl' : 'ltr');
      el.setAttribute('lang', langObj.lang);

      if ($table.i18n) {
        $table.i18n = langObj;
      } else {
        Vue.util.defineReactive($table, 'i18n', langObj);
      }

      this$1.name = langObj.lang;
      this$1.lang = langObj;
    };

    this.set(lang);
  },
  getLocale: function getLocale () {
    var val =
      navigator.language ||
      navigator.languages[0] ||
      navigator.browserLanguage ||
      navigator.userLanguage ||
      navigator.systemLanguage;

    if (val) {
      return val.toLowerCase()
    }
  }
};

/**
 * column
 *
 * @since 2019-06-18
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

var ColumnSelection = {
  computed: {
    computedCols: function computedCols () {
      var this$1 = this;

      var ref = this.computedPagination;
      var sortBy = ref.sortBy;
      var descending = ref.descending;

      var cols = this.columns.filter(function (col) { return col.required || (col.visible || col.visible === void 0); });

      return cols.map(function (col) {
        col.align = col.align || 'left';
        col.__iconClass = "s-table-sort-icon s-table-sort-icon-" + (col.align);
        col.__thClass = "text-" + (col.align) + (col.sortable && this$1.sortable ? ' sortable' : '') + (col.field === sortBy ? (" sorted " + (descending ? 'sort-desc' : '')) : '');
        col.__tdClass = "text-" + (col.align);
        col.props = col.props || {};

        if (col.props && !col.props.hasOwnProperty('visibled')) {
          col.props = Object.assign(col.props, {
            visibled: true
          });
        }

        if (col.width) {
          col.width = (parseInt(col.width)) + "px";
        } else {
          col.width = '100px';
        }

        return col
      })
    },
    computedColsMap: function computedColsMap () {
      var names = {};

      this.computedCols.forEach(function (col) {
        if (col.sortable === void 0) {
          Object.assign(col, { sortable: true });
        }

        if (col.cellSelection === void 0) {
          Object.assign(col, { cellSelection: true });
        }

        names[col.name] = col;
      });

      return names
    }
  }
};

/**
 * dom
 *
 * @param el
 * @returns {{top: number, left: number}}
 *
 * Quasar 0.17.18
 */
function offset (el) {
  if (!el || el === window) {
    return { top: 0, left: 0 }
  }
  var ref = el.getBoundingClientRect();
  var top = ref.top;
  var left = ref.left;

  return { top: top, left: left }
}

function css (element, css) {
  var style = element.style;

  Object.keys(css).forEach(function (prop) {
    style[prop] = css[prop];
  });
}

var prefix = ['-webkit-', '-moz-', '-ms-', '-o-'];
function cssTransform (val) {
  var o = { transform: val };
  prefix.forEach(function (p) {
    o[p + 'transform'] = val;
  });
  return o
}

var listenOpts = {
  hasPassive: false,
  passiveCapture: true,
  notPassiveCapture: true
};

try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get () {
      Object.assign(listenOpts, {
        hasPassive: true,
        passive: { passive: true },
        notPassive: { passive: false },
        passiveCapture: { passive: true, capture: true },
        notPassiveCapture: { passive: false, capture: true }
      });
    }
  });
  window.addEventListener('qtest', null, opts);
  window.removeEventListener('qtest', null, opts);
} catch (e) {}

function noop () {}

function leftClick (e) {
  return e.button === 0
}

function getEventKey (e) {
  return e.which || e.keyCode
}

function position (e) {
  if (e.touches && e.touches[0]) {
    e = e.touches[0];
  } else if (e.changedTouches && e.changedTouches[0]) {
    e = e.changedTouches[0];
  } else if (e.targetTouches && e.targetTouches[0]) {
    e = e.targetTouches[0];
  }

  return {
    top: e.clientY,
    left: e.clientX
  }
}

function stop (e) {
  e.stopPropagation();
}

function prevent (e) {
  e.cancelable !== false && e.preventDefault();
}

function stopAndPrevent (e) {
  e.cancelable !== false && e.preventDefault();
  e.stopPropagation();
}

function preventDraggable (el, status) {
  if (el === void 0 || (status === true && el.__dragPrevented === true)) {
    return
  }

  var fn = status === true
    ? function (el) {
      el.__dragPrevented = true;
      el.addEventListener('dragstart', prevent, listenOpts.notPassiveCapture);
    }
    : function (el) {
      delete el.__dragPrevented;
      el.removeEventListener('dragstart', prevent, listenOpts.notPassiveCapture);
    };

  el.querySelectorAll('a, img').forEach(fn);
}

function addEvt (ctx, targetName, events) {
  var name = "__q_" + targetName + "_evt";

  ctx[name] = ctx[name] !== void 0
    ? ctx[name].concat(events)
    : events;

  events.forEach(function (evt) {
    evt[0].addEventListener(evt[1], ctx[evt[2]], listenOpts[evt[3]]);
  });
}

function cleanEvt (ctx, targetName) {
  var name = "__q_" + targetName + "_evt";

  if (ctx[name] !== void 0) {
    ctx[name].forEach(function (evt) {
      evt[0].removeEventListener(evt[1], ctx[evt[2]], listenOpts[evt[3]]);
    });
    ctx[name] = void 0;
  }
}

/**
 * Column Resize
 *
 * @since 2019-07-22
 * @author kdydesign.kim
 */

var ColumnResize = {
  props: {
    resizeMode: {
      type: String,
      default: 'percentage'
    }
  },
  data: function data () {
    return {
      colStyle: [],
      handlerPosition: 0,
      targetHeader: void 0,
      duration: 0,
      distance: 0,
      position: 0,
      targetHandler: void 0,
      bodyTarget: [],
      headerList: [],
      headerRow: [],
      headerColList: [],
      bodyColList: [],
      bodyList: [],
      headerTable: void 0,
      bodyTable: void 0,
      headerWrapper: void 0,
      bodyWrapper: void 0,
      bodyScrollWidth: 0,
      isMultiHeader: false
    }
  },
  watch: {
    columns: {
      deep: true,
      handler: function handler () {
        var this$1 = this;

        this.$nextTick(function () {
          this$1.initResize();
        });
      }
    }
    // columns (col) {
    //   this.$nextTick(() => {
    //     this.computedField()
    //   })
    // }
  },
  computed: {
    isOverFlow: function isOverFlow () {
      return this.resizeMode === 'overflow'
    }
  },
  mounted: function mounted () {
    var this$1 = this;

    this.$nextTick(function () {
      this$1.initResize();
    });
  },
  beforeDestroy: function beforeDestroy () {
    if (this.bodyWrapper) {
      this.__removeEventListeners();
    }
  },
  methods: {
    initResize: function initResize () {
      var childIndex = this.windowResize ? 1 : 0;
      var bodyTableIndex = this.isOverFlow ? 1 : 0;

      this.headerWrapper = this.$children[childIndex].$el;
      this.bodyWrapper = this.$children[childIndex + 1].$el;
      this.bodyWrapperScroll = this.bodyWrapper.children[0];
      this.headerTable = this.headerWrapper.children[1];
      this.bodyTable = this.hasVirtScroll
        ? this.$refs.virtScroll.$el.children[bodyTableIndex]
        : this.bodyWrapper.children[bodyTableIndex];
      this.headerRow = this.headerTable.children[1].children;
      this.headerList = this.headerRow[0].children;
      this.headerColList = this.headerTable.children[0].children;
      this.bodyColList = this.bodyTable.children[0].children;
      this.bodyList = this.bodyTable.children[1].children;
      this.isMultiHeader = this.headerRow.length > 1;

      this.__addEventListeners();

      if (this.isMultiHeader) {
        this.initMultiHeader();
        this.__setHandlerStyle();
      } else {
        this.__setHandlerStyle();
        this.initHeader();
      }

      this.__setBodyScrollWidth();
      this.__applyFieldBounds();
    },
    resetResizeHandler: function resetResizeHandler () {
      var this$1 = this;

      this.__removeEventListeners();

      this.$nextTick(function () {
        this$1.initResize();

        this$1.__syncHandler();
      });
    },
    initHeader: function initHeader () {
      for (var i = 0; i < this.headerColList.length; i++) {
        var colWidth = this.colStyle[i].width;

        if (colWidth === 0 || this.isPopup) {
          colWidth = this.computedCols[i].width;
        }

        colWidth = this.__getColSize(colWidth);

        this.headerColList[i].setAttribute('width', colWidth);
        this.bodyColList[i].setAttribute('width', colWidth);
      }
    },
    initMultiHeader: function initMultiHeader () {
      if (this.headerRow.length > 1) {
        var filterHeaderList = [];
        var
          firstTr = this.headerRow[0],
          lastTr = this.headerRow[1],
          firstThList = firstTr.getElementsByTagName('th'),
          lastThList = lastTr.getElementsByTagName('th');

        var colspan = 0;

        for (var i = 0; i < firstThList.length; i++) {
          var firstRowTh = firstThList[i];

          if (firstRowTh.rowSpan > 1 && !firstRowTh.getAttribute('colspan')) {
            firstRowTh.setAttribute('multi-handler-height', firstRowTh.clientHeight);

            filterHeaderList.push(firstRowTh);
          } else {
            for (var j = 0; j < lastThList.length; j++) {
              var lastRowTh = lastThList[j];

              if (!_.some(filterHeaderList, lastRowTh)) {
                if (!lastRowTh.getAttribute('multi-handler-height')) {
                  lastRowTh.setAttribute('multi-handler-height', lastRowTh.clientHeight);
                  lastRowTh.setAttribute('multi-handler-top', lastRowTh.clientHeight);
                }

                filterHeaderList.push(lastRowTh);
              }
            }

            if (firstRowTh.colSpan > 1 && !firstRowTh.getAttribute('rowspan')) {
              colspan += firstRowTh.colSpan;

              lastThList[colspan - 1].setAttribute('multi-handler-height', (firstRowTh.clientHeight * 2) + 1);
              lastThList[colspan - 1].setAttribute('multi-handler-top', 0);
            }
          }
        }

        this.headerList = filterHeaderList;
      }
    },
    computedField: function computedField () {
      var this$1 = this;

      this.$nextTick(function () {
        var loop = function ( i ) {
          var field = this$1.computedCols[i].field;
          var storageColWidthList = JSON.parse(localStorage.getItem(this$1.storageId));
          var colWidth = parseInt(this$1.__getColSize(this$1.computedCols[i].width));

          if (this$1.isOverFlow) {
            // resize-mode가 overflow인 경우에만 저장된 사이즈로 컬럼 변경
            if (storageColWidthList) {
              var storageField = _.find(storageColWidthList, function (storageCol) { return storageCol.field === field; });

              if (storageField) {
                colWidth = storageField.width;
              }
            }
          }

          this$1.headerColList[i].setAttribute('width', colWidth);
          this$1.bodyColList[i].setAttribute('width', colWidth);
        };

        for (var i = 0; i < this$1.headerList.length; i++) loop( i );

        this$1.__applyFieldBounds();
        this$1.__syncHandler();
      });
    },
    __getColSize: function __getColSize (width) {
      return this.isOverFlow
        ? (width + "px")
        : this.__colSizeToPercentCalc(width)
    },
    __removeEventListeners: function __removeEventListeners () {
      this.bodyWrapper.removeEventListener('scroll', this.__bodyHorizontalScroll);
    },
    __addEventListeners: function __addEventListeners () {
      this.bodyWrapper.addEventListener('scroll', this.__bodyHorizontalScroll);
    },
    __bodyHorizontalScroll: function __bodyHorizontalScroll (evt) {
      this.headerWrapper.scrollLeft = evt.target.scrollLeft;
    },
    __colSizeToPercentCalc: function __colSizeToPercentCalc (colSize) {
      var tableWidth = 0;

      if (this.headerTable.clientWidth === 0) {
        tableWidth = this.width;
      } else {
        tableWidth = this.headerTable.clientWidth;
      }

      return ((Number(parseInt(colSize) / tableWidth) * 100) + "%")
    },
    __syncFields: function __syncFields (evt) {
      var movingDistance = 0;
      var
        handlerIdx = this.targetHandler.getAttribute('index'),
        handlerPosition = this.targetHeader.clientWidth,
        minSize = this.targetHeader.children[0].clientWidth + 5;

      this.targetHandler.style.left = handlerPosition + "px";

      if (evt.direction === 'left') {
        movingDistance = this.handlerPosition - evt.distance.x;

        if (movingDistance <= minSize) {
          movingDistance = minSize;
        }

        this.targetHeader.style.width = movingDistance + "px";
        this.distance = 0;
      } else {
        movingDistance = this.handlerPosition + evt.distance.x;

        // 마지막 Handle 이동 시 브라우저 또는 화면 끝으로 이동 시 추가 이동
        var colLen = _.filter(this.columns, function (col) { return col.visible !== false || !_.has(col, 'visible'); }).length - 1;

        if (colLen === Number(handlerIdx)) {
          if (this.duration !== evt.duration) {
            this.duration = evt.duration;

            if (this.position <= evt.distance.x) {
              this.distance = this.distance + 5;
            } else {
              this.distance = this.distance - 5;
            }

            movingDistance = this.handlerPosition + this.distance;

            this.bodyWrapper.scrollLeft = this.bodyWrapper.scrollWidth;
          }
        }

        this.position = evt.distance.x;
        this.targetHeader.style.width = movingDistance + "px";
      }

      this.headerColList[handlerIdx].setAttribute('width', this.__getColSize(movingDistance));
      this.bodyColList[handlerIdx].setAttribute('width', this.__getColSize(movingDistance));
    },
    __syncHandler: function __syncHandler () {
      this.bodyScrollWidth = 0;

      for (var i = 0; i < this.headerList.length; i++) {
        var handlerPosition = offset(this.headerList[i]).left - offset(this.headerTable).left + this.headerList[i].clientWidth + Number(this.headerTable.cellSpacing) / 2;

        this.$refs[("handler-" + i)].style.left = handlerPosition + "px";

        if (this.isOverFlow) {
          this.bodyScrollWidth += this.headerList[i].clientWidth;
          this.bodyWrapperScroll.style.width = (this.bodyScrollWidth + 1) + "px";
        }
      }
    },
    __setHandlerStyle: function __setHandlerStyle () {
      for (var i = 0; i < this.headerList.length; i++) {
        var header = this.headerList[i];
        var handlerPosition = offset(header).left - offset(this.headerTable).left + header.clientWidth + Number(this.headerTable.cellSpacing) / 2;

        var height = this.headerList[i].offsetHeight;
        var top = 0;

        if (this.isMultiHeader) {
          height = Number(header.getAttribute('multi-handler-height'));
          top = Number(header.getAttribute('multi-handler-top'));
        }

        this.colStyle.splice(i, 1, {
          left: handlerPosition,
          width: parseInt(this.headerList[i].getBoundingClientRect().width),
          height: height,
          top: top
        });
      }
    },
    __applyFieldBounds: function __applyFieldBounds () {
      this.__setHandlerStyle();

      for (var i = 0; i < this.headerColList.length; i++) {
        this.headerColList[i].setAttribute('width', this.__getColSize(this.colStyle[i].width));
        this.bodyColList[i].setAttribute('width', this.__getColSize(this.colStyle[i].width));
      }

      if (this.targetHeader) {
        this.handlerPosition = this.targetHeader.clientWidth;
      }
    },
    __setBodyScrollWidth: function __setBodyScrollWidth () {
      if (this.isOverFlow) {
        this.bodyScrollWidth = 0;

        for (var i = 0; i < this.headerList.length; i++) {
          this.bodyScrollWidth += this.headerList[i].clientWidth;
        }

        this.bodyWrapperScroll.style.width = (this.bodyScrollWidth + 1) + "px";
      }
    },
    __pan: function __pan (event) {
      if (event.isFinal) {
        this.__dragStop(event);
      } else if (event.isFirst) {
        this.__dragStart(event.evt);
      } else {
        this.__dragMove(event);
      }
    },
    __dragInit: function __dragInit (evt) {
      stopAndPrevent(evt);

      var handlerIdx = evt.target.getAttribute('index');

      this.targetHandler = this.$refs[("handler-" + handlerIdx)];
      this.targetHeader = this.headerList[handlerIdx];
      this.handlerPosition = this.targetHeader.clientWidth;

      // this.__applyFieldBounds()
      // this.__syncHandler()
    },
    __dragStop: function __dragStop (evt) {
      stopAndPrevent(evt.evt);

      this.__syncFields(evt);
      this.__applyFieldBounds();
      this.__syncHandler();

      this.distance = 0;

      if (this.isUsedStorage) {
        var storageColWidthList = JSON.parse(localStorage.getItem(this.storageId));
        var headerColList = Array.from(this.headerColList);

        var colList = JSON.stringify(_.map(this.columns, function (col) {
          var colEl = _.find(headerColList, function (headerCol) { return headerCol.getAttribute('field') === col.field; });
          var width = col.width;

          if (colEl) {
            width = colEl.width;
          } else {
            if (storageColWidthList) {
              width = _.find(storageColWidthList, function (storageCol) { return storageCol.field === col.field; }).width;
            }
          }

          return {
            field: col.field,
            width: width
          }
        }));

        localStorage.setItem(this.storageId, colList);
      }
    },
    __dragStart: function __dragStart (evt) {
      stopAndPrevent(evt);
    },
    __dragMove: function __dragMove (evt) {
      stopAndPrevent(evt.evt);

      this.__syncFields(evt);
      this.__syncHandler();
    },
    getResizeHandler: function getResizeHandler (h) {
      var this$1 = this;

      return this.computedCols.map(function (col, i) {
        return h('div', {
          attrs: {
            index: i
          },
          ref: ("handler-" + i),
          directives: [
            {
              name: 'touch-move-pan',
              modifiers: {
                horizontal: true,
                mouse: true,
                mightPrevent: true,
                prevent: true,
                stop: true
              },
              value: this$1.__pan
            }
          ],
          on: {
            mousedown: function (evt) { return this$1.__dragInit(evt); }
          },
          style: {
            left: ((this$1.colStyle[i]
              ? this$1.colStyle[i].left
              : 0) + "px"),
            height: ((this$1.colStyle[i]
              ? this$1.colStyle[i].height
              : 0) + "px"),
            top: ((this$1.colStyle[i]
              ? this$1.colStyle[i].top
              : 0) + "px")
          }
        })
      })
    }
  }
};

/**
 * table-pagination
 *
 * @param oldPag
 * @param newPag
 * @returns {boolean}
 *
 * Quasar 0.17.18
 */

function fixPagination (p) {
  if (p.page < 1) {
    p.page = 1;
  }
  if (p.rowsPerPage !== void 0 && p.rowsPerPage < 1) {
    p.rowsPerPage = 0;
  }
  return p
}

var Pagination = {
  props: {
    pagination: Object,
    pageSize: {
      type: Number,
      default: 30
    },
    rowsPerPageOptions: {
      type: Array,
      default: function () { return [3, 5, 7, 10, 15, 20, 25, 50, 0]; }
    }
  },
  data: function data () {
    return {
      // vsEndPoint: 0,
      innerPagination: {
        sortBy: null,
        descending: false,
        page: 1,
        rowsPerPage: this.pageSize
      }
    }
  },
  computed: {
    computedPagination: function computedPagination () {
      return fixPagination(Object.assign({}, this.innerPagination, this.pagination))
    },
    firstRowIndex: function firstRowIndex () {
      var ref = this.computedPagination;
      var page = ref.page;
      var rowsPerPage = ref.rowsPerPage;

      return (page - 1) * rowsPerPage
    },
    lastRowIndex: function lastRowIndex () {
      var ref = this.computedPagination;
      var page = ref.page;
      var rowsPerPage = ref.rowsPerPage;

      return page * rowsPerPage
    },
    isFirstPage: function isFirstPage () {
      return this.computedPagination.page === 1
    },
    pagesNumber: function pagesNumber () {
      return Math.max(
        1,
        Math.ceil(this.computedRowsNumber / this.computedPagination.rowsPerPage)
      )
    },
    isLastPage: function isLastPage () {
      if (this.lastRowIndex === 0) {
        return true
      }
      return this.computedPagination.page >= this.pagesNumber
    },
    computedRowsPerPageOptions: function computedRowsPerPageOptions () {
      var this$1 = this;

      return this.rowsPerPageOptions.map(function (count) { return ({
        label: count === 0 ? this$1.$table.i18n.table.allRows : '' + count,
        value: count
      }); })
    },
    getMaxPageNumber: function getMaxPageNumber () {
      return this.pagesNumber
    },
    getCurrentPageNumber: function getCurrentPageNumber () {
      return this.computedPagination.page
    }
  },
  watch: {
    pagesNumber: function pagesNumber (lastPage, oldLastPage) {
      if (lastPage === oldLastPage) {
        return
      }

      var currentPage = this.computedPagination.page;
      if (lastPage && !currentPage) {
        this.setPagination({ page: 1 });
      } else if (lastPage < currentPage) {
        this.setPagination({ page: lastPage });
      }

      if (this.pageVirtualScroll) {
        this.$refs.tableBody.$el.scrollTop = 0;

        // this.$nextTick(() => {
        //   this.$refs.tableBody.__onScroll({ target: this.$refs.tableBody.$el, refresh: true })
        // })
      }
    },
    pageSize: function pageSize (page) {
      this.innerPagination.rowsPerPage = page;
    }
  },
  methods: {
    __sendServerRequest: function __sendServerRequest (pagination) {
      this.requestServerInteraction({
        pagination: pagination,
        filter: this.filter
      });
    },
    setPagination: function setPagination (val, forceServerRequest) {
      var this$1 = this;

      var newPagination = fixPagination(Object.assign({}, this.computedPagination, val));

      if (this.pagination) {
        this.$emit('update:pagination', newPagination);
      } else {
        this.innerPagination = newPagination;
      }

      if (this.pageVirtualScroll) {
        this.$refs.tableBody.$el.scrollTop = 0;

        this.$nextTick(function () {
          this$1.$refs.tableBody.__onScroll({ target: this$1.$refs.tableBody.$el, refresh: true });
        });
      }
    },
    prevPage: function prevPage () {
      var ref = this.computedPagination;
      var page = ref.page;
      if (page > 1) {
        this.setPagination({ page: page - 1 });
      }
    },
    nextPage: function nextPage () {
      var ref = this.computedPagination;
      var page = ref.page;
      var rowsPerPage = ref.rowsPerPage;
      if (this.lastRowIndex > 0 && page * rowsPerPage < this.computedRowsNumber) {
        this.setPagination({ page: page + 1 });
      }
    },
    firstPage: function firstPage () {
      this.setPagination({ page: 1 });
    },
    lastPage: function lastPage () {
      this.setPagination({ page: this.pagesNumber });
    }
  },
  created: function created () {
    this.$emit('update:pagination', Object.assign({}, this.computedPagination));
  }
};

/**
 * checkbox
 *
 * @since 2019-06-28
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

var CheckboxMixin = {
  props: {
    val: {},
    trueValue: { default: true },
    falseValue: { default: false }
  },
  computed: {
    isTrue: function isTrue () {
      return this.modelIsArray
        ? this.index > -1
        : this.value === this.trueValue
    },
    isFalse: function isFalse () {
      return this.modelIsArray
        ? this.index === -1
        : this.value === this.falseValue
    },
    index: function index () {
      if (this.modelIsArray) {
        return this.value.indexOf(this.val)
      }
    },
    modelIsArray: function modelIsArray () {
      return Array.isArray(this.value)
    }
  },
  methods: {
    toggle: function toggle (evt, blur) {
      if ( blur === void 0 ) blur = true;

      if (this.isDisabled || this.readonly) {
        return
      }
      evt && stopAndPrevent(evt);
      blur && this.$el.blur();

      var val;

      if (this.modelIsArray) {
        if (this.isTrue) {
          val = this.value.slice();
          val.splice(this.index, 1);
        } else {
          val = this.value.concat(this.val);
        }
      } else if (this.isTrue) {
        val = this.toggleIndeterminate ? this.indeterminateValue : this.falseValue;
      } else if (this.isFalse) {
        val = this.trueValue;
      } else {
        val = this.falseValue;
      }

      this.__update(val);
    }
  }
};

/**
 * option
 *
 * @since 2019-06-28
 * @author kdydesign.kim
 *
 * Quasar 0.15.7
 */

var OptionMixin = {
  props: {
    value: {
      required: true
    },
    label: String,
    leftLabel: Boolean,
    color: {
      type: String,
      default: 'primary'
    },
    // 추가
    iconClass: String,
    keepColor: Boolean,
    dark: Boolean,
    disable: Boolean,
    readonly: Boolean,
    noFocus: Boolean,
    checkedIcon: String,
    uncheckedIcon: String
  },
  computed: {
    classes: function classes () {
      return [
        this.__kebabTag,
        {
          disabled: this.isDisabled,
          reverse: this.leftLabel,
          's-focusable': this.focusable
        }
      ]
    },
    innerClasses: function innerClasses () {
      if (this.isTrue || this.isIndeterminate) {
        return ['active', ("text-" + (this.color))]
      } else {
        var color = this.keepColor
          ? this.color
          : (this.dark ? 'light' : 'faded');

        return ("text-" + color)
      }
    },
    focusable: function focusable () {
      return !this.noFocus && !this.isDisabled && !this.readonly
    },
    tabindex: function tabindex () {
      return this.focusable ? 0 : -1
    }
  },
  methods: {
    __update: function __update (value) {
      var this$1 = this;

      var ref = this.$refs.ripple;
      if (ref) {
        ref.classList.add('active');
        setTimeout(function () {
          ref.classList.remove('active');
        }, 10);
      }

      this.$emit('update:value', value);
      this.$emit('input', value);

      this.$nextTick(function () {
        if (JSON.stringify(value) !== JSON.stringify(this$1.value)) {
          this$1.$emit('change', value);
        }
      });
    },
    __handleKeyDown: function __handleKeyDown (e) {
      if ([13, 32].includes(getEventKey(e))) {
        this.toggle(e, false);
      }
    }
  },
  render: function render (h) {
    var this$1 = this;

    return h('div', {
      staticClass: 's-option cursor-pointer no-outline row inline no-wrap items-center',
      'class': this.classes,
      attrs: { tabindex: this.tabindex },
      on: {
        click: this.toggle,
        focus: function () { this$1.$emit('focus'); },
        blur: function () { this$1.$emit('blur'); },
        keydown: this.__handleKeyDown
      },
      directives: this.__kebabTag === 's-toggle' && !this.isDisabled && !this.readonly
        ? [
          {
            name: 'touch-swipe',
            modifiers: { horizontal: true },
            value: this.__swipe
          }]
        : null
    }, [
      h('div', {
        staticClass: 's-option-inner relative-position',
        'class': this.innerClasses
      }, [
        h('input', {
          attrs: { type: 'checkbox' },
          on: { change: this.toggle }
        }),
        h('div', {
          staticClass: 's-focus-helper',
          'class': this.__kebabTag === 's-radio' ? 's-focus-helper-round' : 's-focus-helper-rounded'
        }),
        this.__getContent(h)
      ]),

      /**
       * iconClass 추가
       * @author kdydesign.kim
       * @since 2018-07-02
       */
      this.iconClass
        ? h('span', {
          staticClass: this.iconClass
        })
        : null,

      this.label
        ? h('span', {
          staticClass: 's-option-label',
          domProps: { innerHTML: this.label }
        })
        : null,

      this.$slots.default
    ])
  }
};

/**
 * icon
 *
 * @since 2019-06-25
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */
var prefix$1 = 'mat';

var Icon = {
  name: 'Icon',
  props: {
    name: String,
    size: String,
    color: String,
    childValue: String,
    customStyle: {
      type: Object,
      default: null
    }
  },
  computed: {
    classes: function classes () {
      var cls;
      var icon = this.name;

      if (!icon) {
        return ''
      } else if (/^fa[s|r|l|b]{0,1} /.test(icon) || icon.startsWith('icon-')) {
        cls = icon;
      } else if (icon.startsWith('bt-')) {
        cls = "bt " + icon;
      } else if (/^ion-(md|ios|logo)/.test(icon)) {
        cls = "ionicons " + icon;
      } else if (icon.startsWith('ion-')) {
        cls = "ionicons ion-" + prefix$1 + (icon.substr(3));
      } else if (icon.startsWith('mdi-')) {
        cls = "mdi " + icon;
      } else {
        cls = 'material-icons';
      }

      return this.color
        ? (cls + " text-" + (this.color))
        : cls
    },
    content: function content () {
      return this.classes.startsWith('material-icons')
        ? this.name.replace(/ /g, '_')
        : ' '
    },
    margeStyle: function margeStyle () {
      var margeStyle = this.customStyle;

      if (margeStyle) {
        if (this.size) {
          margeStyle.fontSize = this.size;
        }

        return margeStyle
      }

      return {}
    }
  },
  render: function render (h) {
    var tagParams = [
      this.content,
      this.$slots.default
    ];

    if (this.childValue) {
      tagParams.push(this.childValue);
    }

    return h('i', {
      staticClass: 's-icon',
      // 'class': [this.classes, 'icon-object-type icon-object-host-o'],
      'class': this.classes,
      style: this.margeStyle,
      attrs: { 'aria-hidden': true }
    }, tagParams)
  }
};

/**
 * BlueMax 관리자 권한별 입력 컨트롤 제어 mixin
 * HA 구성 포함
 *
 * @since: 2018-11-09
 * @author: kdydesign.kim
 */
var AuthDisabledMixin = {
  props: {
    authForce: {
      type: Boolean,
      default: false
    },
    haForce: {
      type: Boolean,
      default: false
    }
  },
  data: function data () {
    return {
      authDisable: this.disable,
      isHa: false
    }
  },
  watch: {
    haForce: function haForce (v) {
      // 방어 코드
      if (!v) {
        if (this.$table.store) {
          var blueMaxUiData = this.$table.store.state.common.common.uiData;

          if (blueMaxUiData) {
            var haMode = blueMaxUiData.ha.mode.toLowerCase(); // blueMaxUiData.ha.mode 'Active-Standby'.replace('-').toLowerCase() // blueMaxUiData.ha.mode

            // HA 권한제어 (임시)
            if (haMode !== 'stand-alone') {
              var
                haMember = blueMaxUiData.ha.mmbr,
                uuid = blueMaxUiData.system.host_uuid, // 'NGF-580399637050', // blueMaxUiData.system.host_uuid
                haState = haMember.find(function (mmbr) { return mmbr.mmbr_uuid === uuid; }).state;

              if (haState.toLowerCase() === 'backup') {
                this.authDisable = true;
                this.isHa = true;
              }
            }
          }
        }
      }
    }
  },
  created: function created () {
    if (this.$table.store) {
      var
        blueMaxUiData = this.$table.store.state.common.common.uiData,
        isDRSlave = this.$table.model === 'ngf'
          ? this.$table.store.state.securityPolicy.firewall.firewallPolicySettings.fwRules.isDRSlave
          : false;

      if (blueMaxUiData) {
        var
          authLevel = blueMaxUiData.user.level,
          haMode = blueMaxUiData.ha.mode.toLowerCase(); // blueMaxUiData.ha.mode // 'Active-Standby'.replace('-').toLowerCase() // blueMaxUiData.ha.mode

        // HA 권한 제어 (임시)
        if (haMode !== 'stand-alone') {
          var
            haMember = blueMaxUiData.ha.mmbr,
            uuid = blueMaxUiData.system.host_uuid,
            haState = haMember.find(function (mmbr) { return mmbr.mmbr_uuid === uuid; }).state;

          if (haState.toLowerCase() === 'backup' && !this.haForce) {
            this.authDisable = true;
            this.isHa = true;
          }
        } else {
          // Stand-ALone
          if (authLevel >= 2) {
            this.authDisable = false;

            // 방화벽 DR 설정에 따른 비활성화
            if (isDRSlave) {
              this.authDisable = true;
            }
          } else {
            this.authDisable = true;
          }
        }
      }
    }
  },
  computed: {
    isDisabled: function isDisabled () {
      var isDRSlave = false;

      if (this.$table.store) {
        var blueMaxUiData = this.$table.store.state.common.common.uiData;

        isDRSlave = this.$q.model === 'ngf'
          ? this.$q.store.state.securityPolicy.firewall.firewallPolicySettings.fwRules.isDRSlave
          : false;

        var authLevel = 3;

        if (blueMaxUiData) {
          authLevel = blueMaxUiData.user.level;
        }

        if (!this.isHa) {
          // ha back-up이 아닌 경우 dr 설정 체크 루틴 수행
          if (authLevel >= 2) {
            this.authDisable = false;

            // 방화벽 DR 설정에 따른 비활성화
            if (isDRSlave) {
              this.authDisable = true;
            }
          } else {
            this.authDisable = true;
          }
        }

        if (this.authForce || this.haForce) {
          if (this.disable) {
            return this.disable
          }

          if (this.authForce) {
            return !this.authForce
          }

          if (this.haForce) {
            if (authLevel < 2) {
              return true
            }

            return !this.haForce
          }
        }
      }

      return this.authDisable || this.disable || isDRSlave
    }
  }
};

/**
 * checkbox
 *
 * @since 2019-06-28
 * @author kdydesign.kim
 *
 * Quasar 0.15.7
 */

var CheckBox = {
  name: 'check-box',
  mixins: [CheckboxMixin, OptionMixin, AuthDisabledMixin],
  props: {
    toggleIndeterminate: Boolean,
    indeterminateValue: { default: null },
    indeterminateIcon: String
  },
  computed: {
    isIndeterminate: function isIndeterminate () {
      return this.value === void 0 || this.value === this.indeterminateValue
    },
    checkedStyle: function checkedStyle () {
      return this.isTrue
        ? {
          transition: 'opacity 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, transform 800ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
          opacity: 1,
          transform: 'scale(1)'
        }
        : {
          transition: 'opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, transform 0ms cubic-bezier(0.23, 1, 0.32, 1) 450ms',
          opacity: 0,
          transform: 'scale(0)'
        }
    },
    indeterminateStyle: function indeterminateStyle () {
      return this.isIndeterminate
        ? {
          transition: 'opacity 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, transform 800ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
          opacity: 1,
          transform: 'scale(1)'
        }
        : {
          transition: 'opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, transform 0ms cubic-bezier(0.23, 1, 0.32, 1) 450ms',
          opacity: 0,
          transform: 'scale(0)'
        }
    },
    uncheckedStyle: function uncheckedStyle () {
      return this.isFalse
        ? { opacity: 1 }
        : { transition: 'opacity 650ms cubic-bezier(0.23, 1, 0.32, 1) 150ms', opacity: 0 }
    }
  },
  methods: {
    __getContent: function __getContent (h) {
      return [
        h(Icon, {
          staticClass: 's-checkbox-icon cursor-pointer',
          props: { name: this.uncheckedIcon || this.$table.icon.checkbox.unchecked.mat },
          style: this.uncheckedStyle
        }),
        h(Icon, {
          staticClass: 's-checkbox-icon cursor-pointer absolute-full',
          props: { name: this.indeterminateIcon || this.$table.icon.checkbox.indeterminate.mat },
          style: this.indeterminateStyle
        }),
        h(Icon, {
          staticClass: 's-checkbox-icon cursor-pointer absolute-full',
          props: { name: this.checkedIcon || this.$table.icon.checkbox.checked.mat },
          style: this.checkedStyle
        }),
        h('div', { ref: 'ripple', staticClass: 's-radial-ripple' })
      ]
    }
  },
  beforeCreate: function beforeCreate () {
    this.__kebabTag = 'checkbox';
  }
};

/**
 * align
 *
 * @since 2019-06-27
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */
var
  alignMap = {
    left: 'start',
    center: 'center',
    right: 'end',
    between: 'between',
    around: 'around'
  },
  alignValues = Object.keys(alignMap);

var AlignMixin = {
  props: {
    align: {
      type: String,
      default: 'center',
      validator: function (v) { return alignValues.includes(v); }
    }
  },
  computed: {
    alignClass: function alignClass () {
      return ("justify-" + (alignMap[this.align]))
    }
  }
};

/**
 * input-frame
 *
 * @since 2019-06-27
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

var marginal = {
  type: Array,
  validator: function (v) { return v.every(function (i) { return 'icon' in i; }); }
};

var FrameMixin = {
  mixins: [AlignMixin],
  props: {
    prefix: String,
    suffix: String,
    stackLabel: String,
    floatLabel: String,
    placeholder: String,
    error: Boolean,
    warning: Boolean,
    disable: Boolean,
    readonly: Boolean,
    clearable: Boolean,
    color: {
      type: String,
      default: 'primary'
    },
    align: {
      default: 'left'
    },
    dark: Boolean,
    before: marginal,
    after: marginal,
    inverted: Boolean,
    invertedLight: Boolean,
    hideUnderline: Boolean,
    clearValue: {},
    noParentField: Boolean
  },
  computed: {
    inputPlaceholder: function inputPlaceholder () {
      if ((!this.floatLabel && !this.stackLabel) || this.labelIsAbove) {
        return this.placeholder
      }
    },
    isInverted: function isInverted () {
      return this.inverted || this.invertedLight
    },
    isInvertedLight: function isInvertedLight () {
      return this.isInverted && ((this.invertedLight && !this.hasError) || (this.inverted && this.hasWarning))
    },
    isStandard: function isStandard () {
      return !this.isInverted
    },
    isHideUnderline: function isHideUnderline () {
      return this.isStandard && this.hideUnderline
    },
    labelIsAbove: function labelIsAbove () {
      return this.focused || this.length || this.additionalLength || this.stackLabel
    },
    hasContent: function hasContent () {
      return this.length > 0 || this.additionalLength > 0 || this.placeholder || this.placeholder === 0
    },
    editable: function editable () {
      return !this.disable && !this.readonly
    },
    computedClearValue: function computedClearValue () {
      return this.clearValue === void 0 ? null : this.clearValue
    },
    isClearable: function isClearable () {
      return this.editable && this.clearable && this.computedClearValue !== this.model
    },
    hasError: function hasError () {
      return !!((!this.noParentField && this.field && this.field.error) || this.error)
    },
    hasWarning: function hasWarning () {
      // error is the higher priority
      return !!(!this.hasError && ((!this.noParentField && this.field && this.field.warning) || this.warning))
    },
    fakeInputValue: function fakeInputValue () {
      return this.actualValue || this.actualValue === 0
        ? this.actualValue
        : (
          this.placeholder || this.placeholder === 0
            ? this.placeholder
            : ''
        )
    },
    fakeInputClasses: function fakeInputClasses () {
      var hasValue = this.actualValue || this.actualValue === 0;
      return [
        this.alignClass, {
          invisible: (this.stackLabel || this.floatLabel) && !this.labelIsAbove && !hasValue,
          's-input-target-placeholder': !hasValue && this.inputPlaceholder
        }]
    }
  },
  methods: {
    clear: function clear (evt) {
      if (!this.editable) {
        return
      }
      evt && stopAndPrevent(evt);
      var val = this.computedClearValue;
      if (this.__setModel) {
        this.__setModel(val, true);
      }
      this.$emit('clear', val);
    }
  }
};

/**
 * input
 *
 * @since 2019-06-27
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */
var InputMixin = {
  props: {
    autofocus: [Boolean, String],
    maxHeight: Number,
    loading: Boolean
  },
  data: function data () {
    return {
      focused: false,
      timer: null,
      isNumberError: false,
      isNegZero: false
    }
  },
  methods: {
    focus: function focus () {
      if (!this.disable) {
        this.$refs.input.focus();
      }
    },
    blur: function blur () {
      this.$refs.input && this.$refs.input.blur();
    },
    select: function select () {
      this.$refs.input.select();
    },
    __onFocus: function __onFocus (e) {
      clearTimeout(this.timer);

      if (this.focused) {
        return
      }

      this.focused = true;
      this.$refs.input && this.$refs.input.focus();
      this.$emit('focus', e);
    },
    __onInputBlur: function __onInputBlur (e) {
      var this$1 = this;

      clearTimeout(this.timer);

      this.timer = setTimeout(function () {
        this$1.__onBlur(e);
      }, 200);
    },
    __onBlur: function __onBlur (e, destroy) {
      if (this.focused) {
        this.focused = false;
        this.$emit('blur', e);
      }

      this.__emit(destroy);
    },
    __emit: function __emit (destroy) {
      var this$1 = this;

      var isNumberError = this.isNumber && this.isNumberError;
      var value = isNumberError ? (this.isNegZero ? -0 : null) : this.model;

      if (this.isNumber) {
        this.model = this.value;
      }

      if (isNumberError) {
        this.$emit('input', value);
      }

      var emit = function () {
        if (this$1.isNumber) {
          value = parseFloat(value);

          if (Number.isInteger(this$1.decimals)) {
            value = parseFloat(value.toFixed(this$1.decimals));
          }

          if (String(1 / value) !== String(1 / this$1.value)) {
            this$1.$emit('change', value);
          }
        } else if (JSON.stringify(value) !== JSON.stringify(this$1.value)) {
          this$1.$emit('change', value);
        }
      };

      destroy ? emit() : this.$nextTick(emit);
    },
    __onKeydown: function __onKeydown (e) {
      if (e.keyCode === 13) {
        if (this.type === 'textarea') {
          e.stopPropagation();
        } else {
          this.__emit();
        }
      }

      this.$emit('keydown', e);
    },
    __onKeyup: function __onKeyup (e) {
      this.$emit('keyup', e);
    },
    __onClick: function __onClick (e) {
      this.focus();
      this.$emit('click', e);
    },
    __onPaste: function __onPaste (e) {
      this.$emit('paste', e);
    }
  },
  mounted: function mounted () {
    var this$1 = this;

    this.$nextTick(function () {
      var input = this$1.$refs.input;

      if (this$1.autofocus && input) {
        input.focus();
        if (this$1.autofocus === 'select') {
          input.select();
        }
      }
    });
  },
  beforeDestroy: function beforeDestroy () {
    clearTimeout(this.timer);

    this.focused && this.__onBlur(void 0, true);
  }
};

/**
 * input-types
 *
 * @since 2019-06-27
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */
var InputTypes = [
  'text', 'textarea', 'email', 'search',
  'tel', 'file', 'number',
  'password', 'url', 'time', 'date'
];

/**
 * frame-debounce
 *
 * @since 2019-06-27
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */
function frameDebounce (fn) {
  var wait = false, frame;

  function debounced () {
    var this$1 = this;
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (wait) { return }

    wait = true;
    frame = requestAnimationFrame(function () {
      fn.apply(this$1, args);
      wait = false;
    });
  }

  debounced.cancel = function () {
    window.cancelAnimationFrame(frame);
    wait = false;
  };

  return debounced
}

/**
 * format
 *
 * @since 2019-06-27
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

function between (v, min, max) {
  if (max <= min) {
    return min
  }
  return Math.min(max, Math.max(min, v))
}

function normalizeToInterval (v, min, max) {
  if (max <= min) {
    return min
  }

  var size = (max - min + 1);

  var index = min + (v - min) % size;
  if (index < min) {
    index = size + index;
  }

  return index === 0 ? 0 : index // fix for (-a % a) => -0
}

function toLowerCamelCase (name) {
  return name.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); })
}

/**
 * parent-field
 *
 * @since 2019-06-27
 * @author kdydesign.kim
 *
 * Quasar 0.15.7
 */
var ParentFieldMixin = {
  inject: {
    field: {
      from: '__field',
      default: null
    }
  },
  props: {
    noParentField: Boolean
  },
  watch: {
    noParentField: function noParentField (val) {
      if (!this.field) {
        return
      }
      this.field[val ? '__registerInput' : '__unregisterInput'](this);
    }
  },
  beforeMount: function beforeMount () {
    if (!this.noParentField && this.field) {
      this.field.__registerInput(this);
    }
  },
  beforeDestroy: function beforeDestroy () {
    if (!this.noParentField && this.field) {
      this.field.__unregisterInput(this);
    }
  }
};

/**
 * input-frame
 *
 * @since 2019-06-27
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

var InputFrame = {
  name: 'input-frame',
  mixins: [FrameMixin, ParentFieldMixin],
  props: {
    focused: Boolean,
    length: Number,
    focusable: Boolean,
    additionalLength: Boolean
  },
  computed: {
    hasStackLabel: function hasStackLabel () {
      return typeof this.stackLabel === 'string' && this.stackLabel.length > 0
    },
    hasLabel: function hasLabel () {
      return this.hasStackLabel || (typeof this.floatLabel === 'string' && this.floatLabel.length > 0)
    },
    label: function label () {
      return this.hasStackLabel ? this.stackLabel : this.floatLabel
    },
    addonClass: function addonClass () {
      return {
        's-if-addon-visible': !this.hasLabel || this.labelIsAbove
      }
    },
    classes: function classes () {
      var cls = [
        {
          's-if-has-label': this.label,
          's-if-focused': this.focused,
          's-if-error': this.hasError,
          's-if-warning': this.hasWarning,
          's-if-disabled': this.disable,
          's-if-readonly': this.readonly,
          's-if-focusable': this.focusable && !this.disable,
          's-if-inverted': this.isInverted,
          's-if-inverted-light': this.isInvertedLight,
          's-if-light-color': this.lightColor,
          's-if-dark': this.dark,
          's-if-hide-underline': this.isHideUnderline,
          's-if-standard': this.isStandard,
          's-if-has-content': this.hasContent
        }];

      var color = this.hasError ? 'negative' : (this.hasWarning ? 'warning' : this.color);

      if (this.isInverted) {
        cls.push(("bg-" + color));
        cls.push(("text-" + (this.isInvertedLight ? 'black' : 'white')));
      } else if (color) {
        cls.push(("text-" + color));
      }

      return cls
    }
  },
  methods: {
    __onClick: function __onClick (e) {
      this.$emit('click', e);
    },
    __onMouseDown: function __onMouseDown (e) {
      var this$1 = this;

      !this.disable && this.$nextTick(function () { return this$1.$emit('focus', e); });
    },
    __additionalHidden: function __additionalHidden (item, hasError, hasWarning, length) {
      if (item.condition !== void 0) {
        return item.condition === false
      }
      return (
        (item.content !== void 0 && !item.content === (length > 0)) ||
        (item.error !== void 0 && !item.error === hasError) ||
        (item.warning !== void 0 && !item.warning === hasWarning)
      )
    },
    __baHandler: function __baHandler (evt, item) {
      if (!item.allowPropagation) {
        evt.stopPropagation();
      }
      if (item.handler) {
        item.handler(evt);
      }
    }
  },

  render: function render (h) {
    var this$1 = this;

    return h('div', {
      staticClass: 's-if row no-wrap relative-position',
      'class': this.classes,
      attrs: { tabindex: this.focusable && !this.disable ? 0 : -1 },
      on: { click: this.__onClick }
    }, [
      (this.before && this.before.map(function (item) {
        return h(Icon, {
          key: ("b" + (item.icon)),
          staticClass: 's-if-control s-if-control-before',
          'class': [
            item.class, {
              hidden: this$1.__additionalHidden(item, this$1.hasError, this$1.hasWarning, this$1.length)
            }],
          props: {
            name: item.icon
          },
          nativeOn: {
            mousedown: this$1.__onMouseDown,
            touchstart: this$1.__onMouseDown,
            click: function (e) { this$1.__baHandler(e, item); }
          }
        })
      })) || void 0,

      h('div', {
        staticClass: 's-if-inner col column'
      }, [
        h('div', { staticClass: 'row no-wrap relative-position' }, [
          (this.prefix && h('span', {
            staticClass: 's-if-addon s-if-addon-left',
            'class': this.addonClass,
            domProps: {
              innerHTML: this.prefix
            }
          })) || void 0,

          (this.hasLabel && h('div', {
            staticClass: 's-if-label',
            'class': { 's-if-label-above': this.labelIsAbove }
          }, [
            h('div', {
              staticClass: 's-if-label-inner ellipsis',
              domProps: { innerHTML: this.label }
            })
          ])) || void 0
        ].concat(this.$slots.default).concat([
          (this.suffix && h('span', {
            staticClass: 's-if-addon s-if-addon-right',
            'class': this.addonClass,
            domProps: {
              innerHTML: this.suffix
            }
          })) || void 0
        ])),
        (this.hasLabel && h('div', {
          staticClass: 's-if-label-spacer',
          domProps: {
            innerHTML: this.label
          }
        })) || void 0
      ]),

      (this.after && this.after.map(function (item) {
        return h(Icon, {
          key: ("a" + (item.icon)),
          staticClass: 's-if-control',
          'class': [
            item.class, {
              hidden: this$1.__additionalHidden(item, this$1.hasError, this$1.hasWarning, this$1.length)
            }],
          props: {
            name: item.icon
          },
          nativeOn: {
            mousedown: this$1.__onMouseDown,
            touchstart: this$1.__onMouseDown,
            click: function (e) { this$1.__baHandler(e, item); }
          }
        })
      })) || void 0
    ].concat(this.$slots.after))
  }
};

/**
 * input
 *
 * @since 2019-06-27
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

var InputBox = {
  name: 'input-box',
  mixins: [FrameMixin, InputMixin, AuthDisabledMixin],
  props: {
    value: { required: true },
    type: {
      type: String,
      default: 'text',
      validator: function (t) { return InputTypes.includes(t); }
    },
    align: {
      type: String,
      validator: function (v) { return ['left', 'center', 'right'].includes(v); }
    },
    noPassToggle: Boolean,
    numericKeyboardToggle: Boolean,
    readonly: Boolean,

    decimals: Number,
    step: Number,
    upperCase: Boolean,
    lowerCase: Boolean,
    initialShowPassword: Boolean,

    customClass: String
  },
  data: function data () {
    var this$1 = this;

    return {
      showPass: this.initialShowPassword,
      showNumber: true,
      model: this.value,
      watcher: null,
      autofilled: false,
      shadow: {
        val: this.model,
        set: this.__set,
        setNav: this.__set,
        loading: false,
        watched: 0,
        isEditable: function () { return this$1.editable; },
        isDark: function () { return this$1.dark; },
        hasFocus: function () { return document.activeElement === this$1.$refs.input; },
        register: function () {
          this$1.shadow.watched += 1;
          this$1.__watcherRegister();
        },
        unregister: function () {
          this$1.shadow.watched = Math.max(0, this$1.shadow.watched - 1);
          this$1.__watcherUnregister();
        },
        getEl: function () { return this$1.$refs.input; }
      }
    }
  },
  watch: {
    value: function value (v) {
      var
        vOldNum = parseFloat(this.model),
        vNewNum = parseFloat(v);
      if (!this.isNumber || this.isNumberError || isNaN(vOldNum) || isNaN(vNewNum) || vOldNum !== vNewNum) {
        this.model = v;
      }
      this.isNumberError = false;
      this.isNegZero = false;
    }
  },
  provide: function provide () {
    return {
      __input: this.shadow
    }
  },
  computed: {
    isNumber: function isNumber () {
      return this.type === 'number'
    },
    isPassword: function isPassword () {
      return this.type === 'password'
    },
    keyboardToggle: function keyboardToggle () {
      return this.isNumber &&
        this.numericKeyboardToggle
    },
    inputType: function inputType () {
      if (this.isPassword) {
        return this.showPass && this.editable ? 'text' : 'password'
      }
      return this.isNumber
        ? (this.showNumber || !this.editable ? 'number' : 'text')
        : this.type
    },
    inputClasses: function inputClasses () {
      var classes = [];
      this.align && classes.push(("text-" + (this.align)));
      this.autofilled && classes.push('s-input-autofill');
      return classes
    },
    length: function length () {
      return this.model !== null && this.model !== undefined
        ? ('' + this.model).length
        : 0
    },
    computedClearValue: function computedClearValue () {
      return this.clearValue === void 0 ? (this.isNumber ? null : '') : this.clearValue
    },
    computedStep: function computedStep () {
      return this.step || (this.decimals ? Math.pow( 10, -this.decimals ) : 'any')
    },

    frameProps: function frameProps () {
      return {
        prefix: this.prefix,
        suffix: this.suffix,
        stackLabel: this.stackLabel,
        floatLabel: this.floatLabel,
        placeholder: this.placeholder,
        error: this.error,
        warning: this.warning,
        disable: this.isDisabled,
        readonly: this.readonly,
        inverted: this.inverted,
        invertedLight: this.invertedLight,
        dark: this.dark,
        hideUnderline: this.hideUnderline,
        before: this.before,
        after: this.after,
        color: this.color,
        noParentField: this.noParentField,
        focused: this.focused,
        length: this.autofilled + this.length
      }
    }
  },
  methods: {
    togglePass: function togglePass () {
      this.showPass = !this.showPass;
      clearTimeout(this.timer);
      this.focus();
    },
    toggleNumber: function toggleNumber () {
      this.showNumber = !this.showNumber;
      clearTimeout(this.timer);
      this.focus();
    },

    __clearTimer: function __clearTimer () {
      var this$1 = this;

      this.$nextTick(function () { return clearTimeout(this$1.timer); });
    },

    __onAnimationStart: function __onAnimationStart (e) {
      if (e.animationName.indexOf('webkit-autofill-') === 0) {
        var value = e.animationName === 'webkit-autofill-on';
        if (value !== this.autofilled) {
          e.value = this.autofilled = value;
          e.el = this;
          return this.$emit('autofill', e)
        }
      }
    },

    __setModel: function __setModel (val) {
      clearTimeout(this.timer);
      this.focus();
      this.__set(
        this.isNumber && val === 0
          ? val
          : val || (this.isNumber ? null : ''),
        true
      );
    },
    __set: function __set (e, forceUpdate) {
      var this$1 = this;

      var val = e && e.target ? e.target.value : e;

      if (this.isNumber) {
        this.isNegZero = (1 / val) === -Infinity;
        var forcedValue = this.isNegZero ? -0 : val;

        this.model = val;

        val = parseFloat(val);
        if (isNaN(val) || this.isNegZero) {
          this.isNumberError = true;
          if (forceUpdate) {
            this.$emit('input', forcedValue);
            this.$nextTick(function () {
              if (String(1 / forcedValue) !== String(1 / this$1.value)) {
                this$1.$emit('change', forcedValue);
              }
            });
          }
          return
        }
        this.isNumberError = false;
        if (Number.isInteger(this.decimals)) {
          val = parseFloat(val.toFixed(this.decimals));
        }
      } else {
        if (this.lowerCase) {
          val = val.toLowerCase();
        } else if (this.upperCase) {
          val = val.toUpperCase();
        }

        this.model = val;
      }

      this.$emit('update:value', val);
      this.$emit('input', val);

      if (forceUpdate) {
        this.$nextTick(function () {
          if (JSON.stringify(val) !== JSON.stringify(this$1.value)) {
            this$1.$emit('change', val);
          }
        });
      }
    },
    __updateArea: function __updateArea () {
      var
        shadow = this.$refs.shadow,
        input = this.$refs.input;
      if (shadow && input) {
        var
          sH = shadow.scrollHeight,
          h = between(sH, shadow.offsetHeight, this.maxHeight || sH);
        input.style.height = h + "px";
        input.style.overflowY = this.maxHeight && h < sH ? 'scroll' : 'hidden';
      }
    },
    __watcher: function __watcher (value) {
      if (this.shadow.watched) {
        this.shadow.val = value;
      }
    },
    __watcherRegister: function __watcherRegister () {
      if (!this.watcher) {
        this.watcher = this.$watch('model', this.__watcher);
      }
    },
    __watcherUnregister: function __watcherUnregister (forceUnregister) {
      if (
        this.watcher &&
        (forceUnregister || (!this.shadow.watched))
      ) {
        this.watcher();
        this.watcher = null;
      }
    },

    __getInput: function __getInput (h) {
      return h('input', {
        ref: 'input',
        staticClass: 'col s-input-target s-no-input-spinner ellipsis',
        'class': this.inputClasses,
        attrs: Object.assign({}, this.$attrs, {
          autocomplete: 'new-password',
          type: this.inputType,
          placeholder: this.inputPlaceholder,
          disabled: this.isDisabled,
          readonly: this.readonly,
          step: this.computedStep
        }),
        domProps: { value: this.model },
        on: {
          input: this.__set,
          focus: this.__onFocus,
          blur: this.__onInputBlur,
          keydown: this.__onKeydown,
          keyup: this.__onKeyup,
          paste: this.__onPaste,
          animationstart: this.__onAnimationStart
        }
      })
    }
  },
  mounted: function mounted () {
    this.__updateArea = frameDebounce(this.__updateArea);
  },
  beforeDestroy: function beforeDestroy () {
    this.__watcherUnregister(true);

    // 하위 엘레멘트 제거
    for (var i = 0, l = this.$el.childElementCount; i < l; i++) {
      var node = this.$el.children[i];
      for (var j = 0, k = node.childElementCount; j < k; j++) {
        node.children[0].remove();
      }
    }
  },

  render: function render (h) {
    return h(InputFrame, {
        staticClass: ("s-input s-" + (this.inputType) + "-form"),
        props: this.frameProps,
        on: {
          click: this.__onClick,
          focus: this.__onFocus,
          paste: this.__onPaste
        }
      },
      [].concat(this.$slots.before).concat([
        this.__getInput(h),

        (!this.isDisabled && this.isPassword && !this.noPassToggle && (this.initialShowPassword || this.length) && h(Icon, {
          slot: 'after',
          staticClass: 's-if-control',
          props: {
            name: this.$table.icon.input[this.showPass ? 'showPass' : 'hidePass']
          },
          nativeOn: {
            mousedown: this.__clearTimer,
            touchstart: this.__clearTimer,
            click: this.togglePass
          }
        })) || void 0,

        (this.editable && this.keyboardToggle && h(Icon, {
          slot: 'after',
          staticClass: 's-if-control',
          props: {
            name: this.$table.icon.input[this.showNumber ? 'showNumber' : 'hideNumber']
          },
          nativeOn: {
            mousedown: this.__clearTimer,
            touchstart: this.__clearTimer,
            click: this.toggleNumber
          }
        })) || void 0,

        (this.isClearable && h(Icon, {
          slot: 'after',
          staticClass: 's-if-control',
          props: {
            name: this.$table.icon.input[("clear" + (this.isInverted ? 'Inverted' : ''))]
          },
          nativeOn: {
            mousedown: this.__clearTimer,
            touchstart: this.__clearTimer,
            click: this.clear
          }
        })) || void 0,

        void 0
      ]).concat(this.$slots.after).concat(this.$slots.default
        ? h('div', { staticClass: 'absolute-full no-pointer-events', slot: 'after' }, this.$slots.default)
        : void 0
      ))
  }
};

/**
 * search
 *
 * @since 2019-06-28
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

var Search = {
  name: 'search',
  mixins: [FrameMixin, InputMixin, AuthDisabledMixin],
  props: {
    value: { required: true },
    type: {
      type: String,
      default: 'search'
    },
    debounce: {
      type: Number,
      default: 300
    },
    icon: String,
    noIcon: Boolean,
    upperCase: Boolean,
    lowerCase: Boolean
  },
  data: function data () {
    return {
      model: this.value,
      childDebounce: false
    }
  },
  provide: function provide () {
    var this$1 = this;

    var set = function (val) {
      if (this$1.model !== val) {
        this$1.model = val;
      }
    };
    return {
      __inputDebounce: {
        set: set,
        setNav: set,
        setChildDebounce: function (v) {
          this$1.childDebounce = v;
        }
      }
    }
  },
  watch: {
    value: function value (v) {
      this.model = v;
    },
    model: function model (val) {
      var this$1 = this;

      clearTimeout(this.timer);
      if (this.value === val) {
        return
      }
      if (!val && val !== 0) {
        this.model = this.type === 'number' ? null : '';
      }
      this.timer = setTimeout(function () {
        this$1.$emit('input', this$1.model);
      }, this.debounceValue);
    }
  },
  computed: {
    debounceValue: function debounceValue () {
      return this.childDebounce
        ? 0
        : this.debounce
    },
    computedClearValue: function computedClearValue () {
      return this.isNumber && this.clearValue === 0
        ? this.clearValue
        : this.clearValue || (this.type === 'number' ? null : '')
    },
    controlBefore: function controlBefore () {
      var before = (this.before || []).slice();
      if (!this.noIcon) {
        before.unshift({
          icon: this.icon || this.$table.icon.search.icon,
          handler: this.focus
        });
      }
      return before
    },
    controlAfter: function controlAfter () {
      var after = (this.after || []).slice();
      if (this.isClearable) {
        after.push({
          icon: this.$table.icon.search[("clear" + (this.isInverted ? 'Inverted' : ''))],
          handler: this.clear
        });
      }
      return after
    }
  },
  methods: {
    clear: function clear (evt) {
      this.$refs.input.clear(evt);
    }
  },
  render: function render (h) {
    var this$1 = this;

    return h(InputBox, {
      ref: 'input',
      staticClass: 's-search',
      props: {
        authForce: this.authForce,
        haForce: this.haForce,
        value: this.model,
        type: this.type,
        autofocus: this.autofocus,
        placeholder: this.placeholder || this.$table.i18n.label.search,
        disable: this.isDisabled,
        readonly: this.readonly,
        error: this.error,
        warning: this.warning,
        align: this.align,
        noParentField: this.noParentField,
        floatLabel: this.floatLabel,
        stackLabel: this.stackLabel,
        prefix: this.prefix,
        suffix: this.suffix,
        inverted: this.inverted,
        invertedLight: this.invertedLight,
        dark: this.dark,
        hideUnderline: this.hideUnderline,
        color: this.color,
        rows: this.rows,
        before: this.controlBefore,
        after: this.controlAfter,
        clearValue: this.clearValue,
        upperCase: this.upperCase,
        lowerCase: this.lowerCase
      },
      attrs: this.$attrs,
      on: {
        input: function (v) { this$1.model = v; },
        focus: this.__onFocus,
        blur: this.__onBlur,
        keyup: this.__onKeyup,
        keydown: this.__onKeydown,
        click: this.__onClick,
        paste: this.__onPaste,
        clear: function (val) {
          this$1.$emit('clear', val);
          this$1.__emit();
        }
      }
    }, this.$slots.default)
  }
};

/**
 * scroll
 *
 * @since 2019-06-28
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

var scrollTargets = [null, document, document.body, document.scrollingElement, document.documentElement];

function getScrollTarget (el, target) {
  if (typeof target === 'string') {
    try {
      target = document.querySelector(target);
    } catch (err) {
      target = void 0;
    }
  }

  if (target === void 0 || target === null) {
    target = el.closest('.scroll,.scroll-y,.overflow-auto');
  } else if (target._isVue === true && target.$el !== void 0) {
    target = target.$el;
  }

  return scrollTargets.includes(target)
    ? window
    : target
}

function getScrollPosition (scrollTarget) {
  if (scrollTarget === window) {
    return window.pageYOffset || window.scrollY || document.body.scrollTop || 0
  }
  return scrollTarget.scrollTop
}

function animScrollTo (el, to, duration) {
  if (duration <= 0) {
    return
  }

  var pos = getScrollPosition(el);

  requestAnimationFrame(function () {
    setScroll(el, pos + (to - pos) / Math.max(16, duration) * 16);
    if (el.scrollTop !== to) {
      animScrollTo(el, to, duration - 16);
    }
  });
}

function setScroll (scrollTarget, offset) {
  if (scrollTarget === window) {
    document.documentElement.scrollTop = offset;
    document.body.scrollTop = offset;
    return
  }
  scrollTarget.scrollTop = offset;
}

function setScrollPosition (scrollTarget, offset, duration) {
  if (duration) {
    animScrollTo(scrollTarget, offset, duration);
    return
  }
  setScroll(scrollTarget, offset);
}

var size;
function getScrollbarWidth () {
  if (size !== undefined) {
    return size
  }

  var
    inner = document.createElement('p'),
    outer = document.createElement('div');

  css(inner, {
    width: '100%',
    height: '200px'
  });
  css(outer, {
    position: 'absolute',
    top: '0px',
    left: '0px',
    visibility: 'hidden',
    width: '200px',
    height: '150px',
    overflow: 'hidden'
  });

  outer.appendChild(inner);

  document.body.appendChild(outer);

  var w1 = inner.offsetWidth;
  outer.style.overflow = 'scroll';
  var w2 = inner.offsetWidth;

  if (w1 === w2) {
    w2 = outer.clientWidth;
  }

  outer.remove();
  size = w1 - w2;

  return size
}

/**
 * popup
 *
 * @since 2019-06-28
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

function getAnchorPosition (el, offset) {
  var ref = el.getBoundingClientRect();
  var top = ref.top;
  var left = ref.left;
  var right = ref.right;
  var bottom = ref.bottom;
  var a = {
    top: top,
    left: left,
    width: el.offsetWidth,
    height: el.offsetHeight
  };

  if (offset) {
    a.top -= offset[1];
    a.left -= offset[0];
    if (bottom) {
      bottom += offset[1];
    }
    if (right) {
      right += offset[0];
    }
    a.width += offset[0];
    a.height += offset[1];
  }

  a.right = right || a.left + a.width;
  a.bottom = bottom || a.top + a.height;
  a.middle = a.left + ((a.right - a.left) / 2);
  a.center = a.top + ((a.bottom - a.top) / 2);

  return a
}

function getTargetPosition (el) {
  return {
    top: 0,
    center: el.offsetHeight / 2,
    bottom: el.offsetHeight,
    left: 0,
    middle: el.offsetWidth / 2,
    right: el.offsetWidth
  }
}

function repositionIfNeeded (anchor, target, selfOrigin, anchorOrigin, targetPosition, cover) {
  var margin = getScrollbarWidth();
  var innerHeight = window.innerHeight;
  var innerWidth = window.innerWidth;
  // don't go bellow scrollbars
  innerHeight -= margin;
  innerWidth -= margin;

  if (targetPosition.top < 0 || targetPosition.top + target.bottom > innerHeight) {
    if (selfOrigin.vertical === 'center') {
      targetPosition.top = anchor[selfOrigin.vertical] > innerHeight / 2 ? innerHeight - target.bottom : 0;
      targetPosition.maxHeight = Math.min(target.bottom, innerHeight);
    } else if (anchor[selfOrigin.vertical] > innerHeight / 2) {
      var anchorY = Math.min(innerHeight, anchorOrigin.vertical === 'center' ? anchor.center : (anchorOrigin.vertical === selfOrigin.vertical ? anchor.bottom : anchor.top));
      targetPosition.maxHeight = Math.min(target.bottom, anchorY);
      targetPosition.top = Math.max(0, anchorY - targetPosition.maxHeight);
    } else {
      targetPosition.top = anchorOrigin.vertical === 'center' ? anchor.center : (anchorOrigin.vertical === selfOrigin.vertical ? anchor.top : anchor.bottom);
      targetPosition.maxHeight = Math.min(target.bottom, innerHeight - targetPosition.top);
    }
  }

  if (targetPosition.left < 0 || targetPosition.left + target.right > innerWidth) {
    targetPosition.maxWidth = Math.min(target.right, innerWidth);
    if (selfOrigin.horizontal === 'middle') {
      targetPosition.left = anchor[selfOrigin.horizontal] > innerWidth / 2 ? innerWidth - target.right : 0;
    } else if (cover) {
      targetPosition.left = targetPosition.left < 0 ? 0 : innerWidth - target.right;
    } else if (anchor[selfOrigin.horizontal] > innerWidth / 2) {
      var anchorY$1 = Math.min(innerWidth, anchorOrigin.horizontal === 'middle' ? anchor.center : (anchorOrigin.horizontal === selfOrigin.horizontal ? anchor.right : anchor.left));
      targetPosition.maxWidth = Math.min(target.right, anchorY$1);
      targetPosition.left = Math.max(0, anchorY$1 - targetPosition.maxWidth);
    } else {
      targetPosition.left = anchorOrigin.horizontal === 'middle' ? anchor.center : (anchorOrigin.horizontal === selfOrigin.horizontal ? anchor.left : anchor.right);
      targetPosition.maxWidth = Math.min(target.right, innerWidth - targetPosition.left);
    }
  }

  return targetPosition
}

function setPosition (ref) {
  var el = ref.el;
  var animate = ref.animate;
  var anchorEl = ref.anchorEl;
  var anchorOrigin = ref.anchorOrigin;
  var selfOrigin = ref.selfOrigin;
  var maxHeight = ref.maxHeight;
  var event = ref.event;
  var anchorClick = ref.anchorClick;
  var touchPosition = ref.touchPosition;
  var offset = ref.offset;
  var touchOffset = ref.touchOffset;
  var cover = ref.cover;

  var anchor;
  el.style.maxHeight = maxHeight || '65vh';
  el.style.maxWidth = '100vw';

  if (event && (!anchorClick || touchPosition)) {
    var ref$1 = position(event);
    var top = ref$1.top;
    var left = ref$1.left;
    anchor = { top: top, left: left, width: 1, height: 1, right: left + 1, center: top, middle: left, bottom: top + 1 };
  } else {
    if (touchOffset) {
      var ref$2 = anchorEl.getBoundingClientRect();
      var anchorTop = ref$2.top;
      var anchorLeft = ref$2.left;
      var top$1 = anchorTop + touchOffset.top,
        left$1 = anchorLeft + touchOffset.left;
      anchor = { top: top$1, left: left$1, width: 1, height: 1, right: left$1 + 1, center: top$1, middle: left$1, bottom: top$1 + 1 };
    } else {
      anchor = getAnchorPosition(anchorEl, offset);
    }
  }

  var target = getTargetPosition(el);
  var targetPosition = {
    top: anchor[anchorOrigin.vertical] - target[selfOrigin.vertical],
    left: anchor[anchorOrigin.horizontal] - target[selfOrigin.horizontal]
  };

  targetPosition = repositionIfNeeded(anchor, target, selfOrigin, anchorOrigin, targetPosition, cover);

  el.style.top = Math.max(0, targetPosition.top) + 'px';
  el.style.left = Math.max(0, targetPosition.left) + 'px';
  if (targetPosition.maxHeight) {
    el.style.maxHeight = (targetPosition.maxHeight) + "px";
  }
  if (targetPosition.maxWidth) {
    el.style.maxWidth = (targetPosition.maxWidth) + "px";
  }

  if (animate) {
    var directions = targetPosition.top < anchor.top ? ['up', 'down'] : ['down', 'up'];
    el.classList.add(("animate-popup-" + (directions[0])));
    el.classList.remove(("animate-popup-" + (directions[1])));
  }
}

function positionValidator (pos) {
  var parts = pos.split(' ');
  if (parts.length !== 2) {
    return false
  }
  if (!['top', 'center', 'bottom'].includes(parts[0])) {
    console.error('Anchor/Self position must start with one of top/center/bottom');
    return false
  }
  if (!['left', 'middle', 'right'].includes(parts[1])) {
    console.error('Anchor/Self position must end with one of left/middle/right');
    return false
  }
  return true
}

function offsetValidator (val) {
  if (!val) { return true }
  if (val.length !== 2) { return false }
  if (typeof val[0] !== 'number' || typeof val[1] !== 'number') {
    return false
  }
  return true
}

function parsePosition (pos) {
  var parts = pos.split(' ');
  return { vertical: parts[0], horizontal: parts[1] }
}

/**
 * escape-key
 *
 * @since 2019-06-28
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */
var handlers = [];

var EscapeKey = {
  __installed: false,
  __install: function __install () {
    this.__installed = true;
    window.addEventListener('keyup', function (evt) {
      if (handlers.length === 0) {
        return
      }

      if (evt.which === 27 || evt.keyCode === 27) {
        handlers[handlers.length - 1]();
      }
    });
  },

  register: function register (handler) {
    if (!this.__installed) {
      this.__install();
    }

    handlers.push(handler);
  },

  pop: function pop () {
    handlers.pop();
  }
};

/**
 * history
 *
 * @since 2019-06-28
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */
var History = {
  __history: [],
  add: function () {},
  remove: function () {},

  install: function install ($table, cfg) {
    var this$1 = this;

    this.add = function (definition) {
      this$1.__history.push(definition);
    };
    this.remove = function (definition) {
      var index = this$1.__history.indexOf(definition);
      if (index >= 0) {
        this$1.__history.splice(index, 1);
      }
    };

    var exit = cfg.cordova === void 0 || cfg.cordova.backButtonExit !== false;

    document.addEventListener('deviceready', function () {
      document.addEventListener('backbutton', function () {
        if (this$1.__history.length) {
          this$1.__history.pop().handler();
        } else if (exit && window.location.hash === '#/') {
          navigator.app.exitApp();
        } else {
          window.history.back();
        }
      }, false);
    });
  }
};

/**
 * model-toggle
 *
 * @since 2019-06-28
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

var ModelToggleMixin = {
  props: {
    value: Boolean
  },
  data: function data () {
    return {
      showing: false
    }
  },
  watch: {
    value: function value (val) {
      var this$1 = this;

      if (this.disable && val) {
        this.$emit('input', false);
        return
      }

      this.$nextTick(function () {
        if (this$1.value !== this$1.showing) {
          this$1[val ? 'show' : 'hide']();
        }
      });
    }
  },
  methods: {
    toggle: function toggle (evt) {
      return this[this.showing ? 'hide' : 'show'](evt)
    },
    show: function show (evt) {
      var this$1 = this;

      if (this.disable || this.showing) {
        return this.showPromise || Promise.resolve(evt)
      }

      this.hidePromise && this.hidePromiseReject();

      this.showing = true;
      if (this.value === false) {
        this.$emit('input', true);
      }

      if (this.$options.modelToggle === void 0 || this.$options.modelToggle.history) {
        this.__historyEntry = {
          handler: this.hide
        };
        History.add(this.__historyEntry);
      }

      if (!this.__show) {
        this.$emit('show', evt);
        return Promise.resolve(evt)
      }

      this.showPromise = new Promise(function (resolve, reject) {
        this$1.showPromiseResolve = function () {
          this$1.showPromise = null;
          this$1.$emit('show', evt);
          resolve(evt);
        };
        this$1.showPromiseReject = function () {
          this$1.showPromise.catch(function () {});
          this$1.showPromise = null;
          reject(null); // eslint prefer-promise-reject-errors: 0
        };
      });

      this.__show(evt);
      return this.showPromise || Promise.resolve(evt)
    },
    hide: function hide (evt) {
      var this$1 = this;

      if (this.disable || !this.showing) {
        return this.hidePromise || Promise.resolve(evt)
      }

      this.showPromise && this.showPromiseReject();

      this.showing = false;
      if (this.value === true) {
        this.$emit('input', false);
      }

      this.__removeHistory();

      if (!this.__hide) {
        this.$emit('hide', evt);
        return Promise.resolve()
      }

      this.hidePromise = new Promise(function (resolve, reject) {
        this$1.hidePromiseResolve = function () {
          this$1.hidePromise = null;
          this$1.$emit('hide', evt);
          resolve();
        };
        this$1.hidePromiseReject = function () {
          this$1.hidePromise.catch(function () {});
          this$1.hidePromise = null;
          reject(null);
        };
      });

      this.__hide(evt);
      return this.hidePromise || Promise.resolve(evt)
    },

    __removeHistory: function __removeHistory () {
      if (this.__historyEntry) {
        History.remove(this.__historyEntry);
        this.__historyEntry = null;
      }
    }
  },
  beforeDestroy: function beforeDestroy () {
    if (this.showing) {
      this.showPromise && this.showPromiseReject();
      this.hidePromise && this.hidePromiseReject();
      this.__removeHistory();
    }
  }
};

/**
 * can-render
 *
 * @since 2019-06-28
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */
// using it to manage SSR rendering with best performance
var CanRenderMixinMixin = {
  data: function data () {
    return {
      canRender: true
    }
  },
  mounted: function mounted () {
    this.canRender === false && (this.canRender = true);
  }
};

/**
 * popover
 *
 * @since 2019-06-28
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

var PopOver = {
  name: 'popover',
  mixins: [ModelToggleMixin, CanRenderMixinMixin],
  props: {
    anchor: {
      type: String,
      validator: positionValidator
    },
    self: {
      type: String,
      validator: positionValidator
    },
    fit: Boolean,
    cover: Boolean,
    persistent: Boolean,
    keepOnScreen: Boolean,
    maxHeight: String,
    touchPosition: Boolean,
    anchorClick: {
      /*
        for handling anchor outside of Popover
        example: context menu component
      */
      type: Boolean,
      default: true
    },
    offset: {
      type: Array,
      validator: offsetValidator
    },
    noFocus: Boolean,
    noRefocus: Boolean,
    disable: Boolean
  },
  watch: {
    $route: function $route () {
      this.hide();
    }
  },
  computed: {
    horizSide: function horizSide () {
      // return this.$table.i18n.rtl ? 'right' : 'left'
      return 'left'
    },
    anchorOrigin: function anchorOrigin () {
      return parsePosition(
        this.cover
          ? ("top " + (this.horizSide))
          : this.anchor || ("bottom " + (this.horizSide))
      )
    },
    selfOrigin: function selfOrigin () {
      return parsePosition(this.self || ("top " + (this.horizSide)))
    }
  },
  render: function render (h) {
    if (!this.canRender) { return }

    return h('div', {
      staticClass: 's-popover scroll',
      ref: 'content',
      attrs: { tabindex: -1 },
      on: {
        click: function click (e) { e.stopPropagation(); }
      }
    }, this.$slots.default)
  },
  mounted: function mounted () {
    var this$1 = this;

    this.__updatePosition = frameDebounce(function (_, event, animate) { return this$1.reposition(event, animate); });
    this.$nextTick(function () {
      this$1.anchorEl = this$1.$el.parentNode;
      this$1.anchorEl.removeChild(this$1.$el);

      if (
        this$1.anchorEl.classList.contains('s-btn-inner') ||
        this$1.anchorEl.classList.contains('s-if-inner') ||
        this$1.anchorEl.classList.contains('no-pointer-events')
      ) {
        this$1.anchorEl = this$1.anchorEl.parentNode;
      }

      if (this$1.anchorClick) {
        this$1.anchorEl.classList.add('cursor-pointer');
        this$1.anchorEl.addEventListener('click', this$1.toggle);
        this$1.anchorEl.addEventListener('keyup', this$1.__toggleKey);
      }
    });

    this.value && this.show();
  },
  beforeDestroy: function beforeDestroy () {
    this.showing && this.__cleanup();
    if (this.anchorClick && this.anchorEl) {
      this.anchorEl.removeEventListener('click', this.toggle);
      this.anchorEl.removeEventListener('keyup', this.__toggleKey);
    }
  },
  methods: {
    __show: function __show (evt) {
      var this$1 = this;

      if (!this.noRefocus) {
        this.__refocusTarget = (this.anchorClick && this.anchorEl) || document.activeElement;
      }
      document.body.appendChild(this.$el);
      EscapeKey.register(function () {
        this$1.$emit('escape-key');
        this$1.hide();
      });
      this.scrollTarget = getScrollTarget(this.anchorEl);
      this.scrollTarget.addEventListener('scroll', this.__updatePosition, listenOpts.passive);
      if (this.scrollTarget !== window) {
        window.addEventListener('scroll', this.__updatePosition, listenOpts.passive);
      }
      window.addEventListener('resize', this.__updatePosition, listenOpts.passive);
      this.__updatePosition(0, evt, true);

      clearTimeout(this.timer);
      if (!this.noFocus && this.$refs.content) {
        this.$refs.content.focus();
      }
      this.timer = setTimeout(function () {
        document.body.addEventListener('mousedown', this$1.__bodyHide, true);
        document.body.addEventListener('touchstart', this$1.__bodyHide, true);
        this$1.showPromise && this$1.showPromiseResolve();
      }, 0);
    },
    __toggleKey: function __toggleKey (evt) {
      if (evt.keyCode === 13) {
        this.toggle(evt);
      }
    },
    __bodyHide: function __bodyHide (evt) {
      if (
        this.persistent || (
          evt && evt.target &&
          (this.$el.contains(evt.target) || this.anchorEl.contains(evt.target))
        )
      ) {
        return
      }

      this.hide(evt);
    },
    __hide: function __hide () {
      this.__cleanup();
      this.hidePromise && this.hidePromiseResolve();
      if (!this.noRefocus && this.__refocusTarget) {
        this.__refocusTarget.focus();
        !this.__refocusTarget.classList.contains('s-if') && this.__refocusTarget.blur();
      }
    },
    __cleanup: function __cleanup () {
      clearTimeout(this.timer);

      document.body.removeEventListener('mousedown', this.__bodyHide, true);
      document.body.removeEventListener('touchstart', this.__bodyHide, true);
      this.scrollTarget.removeEventListener('scroll', this.__updatePosition, listenOpts.passive);
      if (this.scrollTarget !== window) {
        window.removeEventListener('scroll', this.__updatePosition, listenOpts.passive);
      }
      window.removeEventListener('resize', this.__updatePosition, listenOpts.passive);
      EscapeKey.pop();

      this.$el.remove();
    },
    reposition: function reposition (event, animate) {
      var ref = this.anchorEl.getBoundingClientRect();
      var top = ref.top;
      var bottom = ref.bottom;
      var left = ref.left;
      var right = ref.right;

      if (
        !this.keepOnScreen &&
        (bottom < 0 || top > window.innerHeight || right < 0 || left > window.innerWidth)
      ) {
        return this.hide()
      }

      if (this.fit || this.cover) {
        var style = window.getComputedStyle(this.anchorEl);
        this.$el.style.minWidth = style.getPropertyValue('width');
        if (this.cover) {
          this.$el.style.minHeight = style.getPropertyValue('height');
        }
      }

      if (animate) {
        if (this.touchPosition) {
          var ref$1 = position(event);
          var eventTop = ref$1.top;
          var eventLeft = ref$1.left;
          this.touchOffset = { left: eventLeft - left, top: eventTop - top };
        } else {
          delete this.touchOffset;
        }
      }

      setPosition({
        event: event,
        animate: animate,
        el: this.$el,
        offset: this.offset,
        anchorEl: this.anchorEl,
        anchorOrigin: this.anchorOrigin,
        selfOrigin: this.selfOrigin,
        maxHeight: this.maxHeight,
        anchorClick: this.anchorClick,
        touchPosition: this.touchPosition,
        touchOffset: this.touchOffset,
        cover: this.cover
      });
    }
  }
};

/**
 * list
 *
 * @since 2019-06-28
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */
var List = {
  name: 'list',
  props: {
    noBorder: Boolean,
    dark: Boolean,
    dense: Boolean,
    sparse: Boolean,
    striped: Boolean,
    stripedOdd: Boolean,
    separator: Boolean,
    insetSeparator: Boolean,
    multiline: Boolean,
    highlight: Boolean,
    link: Boolean
  },
  computed: {
    classes: function classes () {
      return {
        'no-border': this.noBorder,
        's-list-dark': this.dark,
        's-list-dense': this.dense,
        's-list-sparse': this.sparse,
        's-list-striped': this.striped,
        's-list-striped-odd': this.stripedOdd,
        's-list-separator': this.separator,
        's-list-inset-separator': this.insetSeparator,
        's-list-multiline': this.multiline,
        's-list-highlight': this.highlight,
        's-list-link': this.link
      }
    }
  },
  render: function render (h) {
    return h('div', {
      staticClass: 's-list',
      'class': this.classes
    }, this.$slots.default)
  }
};

/**
 * router-link
 *
 * @since 2019-06-28
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */
var routerLinkEventName = 'qrouterlinkclick';

var evt = null;

try {
  evt = new Event(routerLinkEventName);
} catch (e) {
  // IE doesn't support `new Event()`, so...`
  evt = document.createEvent('Event');
  evt.initEvent(routerLinkEventName, true, false);
}

var routerLinkProps = {
  to: [String, Object],
  exact: Boolean,
  append: Boolean,
  replace: Boolean,
  event: [String, Array],
  activeClass: String,
  exactActiveClass: String
};

/**
 * item
 *
 * @since 2019-06-28
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

function textStyle (n) {
  return n === void 0 || n < 2
    ? {}
    : { overflow: 'hidden', display: '-webkit-box', '-webkit-box-orient': 'vertical', '-webkit-line-clamp': n }
}

var ItemMixin = {
  mixins: [{ props: routerLinkProps }],
  props: {
    dark: Boolean,

    link: Boolean,
    dense: Boolean,
    sparse: Boolean,
    separator: Boolean,
    insetSeparator: Boolean,
    multiline: Boolean,
    highlight: Boolean,

    tag: {
      type: String,
      default: 'div'
    }
  },
  computed: {
    itemClasses: function itemClasses () {
      return {
        's-item': true,
        's-item-division': true,
        'relative-position': true,
        's-item-dark': this.dark,
        's-item-dense': this.dense,
        's-item-sparse': this.sparse,
        's-item-separator': this.separator,
        's-item-inset-separator': this.insetSeparator,
        's-item-multiline': this.multiline,
        's-item-highlight': this.highlight,
        's-item-link': this.to || this.link
      }
    }
  }
};

/**
 * item
 *
 * @since 2019-06-28
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

var Item = {
  name: 'item',
  mixins: [ItemMixin],
  props: {
    active: Boolean,
    link: Boolean
  },
  computed: {
    classes: function classes () {
      return [
        this.to !== void 0
          ? 's-link'
          : { active: this.active },
        this.itemClasses
      ]
    }
  },
  render: function render (h) {
    if (this.to !== void 0) {
      return h('router-link', {
        props: Object.assign({}, this.$props, { tag: 'a' }),
        'class': this.classes
      }, this.$slots.default)
    }

    return h(
      this.tag,
      { 'class': this.classes },
      this.$slots.default
    )
  }
};

/**
 * item-main
 *
 * @since 2019-06-28
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

function text (h, name, val, n) {
  n = parseInt(n, 10);
  return h('div', {
    staticClass: ("s-item-" + name + (n === 1 ? ' ellipsis' : '')),
    style: textStyle(n),
    domProps: {
      innerHTML: val
    }
  })
}

var ItemMain = {
  name: 'item-main',
  props: {
    label: String,
    labelLines: [String, Number],
    sublabel: String,
    sublabelLines: [String, Number],
    inset: Boolean,
    tag: {
      type: String,
      default: 'div'
    }
  },
  render: function render (h) {
    return h(this.tag, {
      staticClass: 's-item-main s-item-section',
      'class': {
        's-item-main-inset': this.inset
      }
    }, [
      this.label ? text(h, 'label', this.label, this.labelLines) : null,
      this.sublabel ? text(h, 'sublabel', this.sublabel, this.sublabelLines) : null,
      this.$slots.default
    ])
  }
};

/**
 * item-side
 *
 * @since 2019-06-28
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

var ItemSide = {
  name: 'item-side',
  props: {
    right: Boolean,

    icon: String,
    letter: {
      type: String,
      validator: function (v) { return v.length === 1; }
    },
    inverted: Boolean, // for icon and letter only

    avatar: String,
    image: String,
    stamp: String,

    color: String,
    textColor: String // only for inverted icon/letter
  },
  computed: {
    type: function type () {
      var this$1 = this;

      return ['icon', 'image', 'avatar', 'letter', 'stamp'].find(function (type) { return this$1[type]; })
    },
    classes: function classes () {
      var cls = [("s-item-side-" + (this.right ? 'right' : 'left'))];

      if (this.color && (!this.icon && !this.letter)) {
        cls.push(("text-" + (this.color)));
      }

      return cls
    },
    typeClasses: function typeClasses () {
      var cls = [("s-item-" + (this.type))];

      if (this.color) {
        if (this.inverted && (this.icon || this.letter)) {
          cls.push(("bg-" + (this.color)));
        } else if (!this.textColor) {
          cls.push(("text-" + (this.color)));
        }
      }
      this.textColor && cls.push(("text-" + (this.textColor)));

      if (this.inverted && (this.icon || this.letter)) {
        cls.push('s-item-inverted');
        cls.push('flex');
        cls.push('flex-center');
      }

      return cls
    },
    imagePath: function imagePath () {
      return this.image || this.avatar
    }
  },
  render: function render (h) {
    var child;

    if (this.type) {
      if (this.icon) {
        child = h(Icon, {
          'class': this.inverted ? null : this.typeClasses,
          props: { name: this.icon }
        });

        if (this.inverted) {
          child = h('div', {
            'class': this.typeClasses
          }, [child]);
        }
      } else if (this.imagePath) {
        child = h('img', {
          'class': this.typeClasses,
          attrs: { src: this.imagePath }
        });
      } else {
        child = h('div', { 'class': this.typeClasses }, [this.stamp || this.letter]);
      }
    }

    return h('div', {
      staticClass: 's-item-side s-item-section',
      'class': this.classes
    }, [
      child,
      this.$slots.default
    ])
  }
};

/**
 * item-wrapper
 *
 * @since 2019-06-28
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

function push (child, h, name, slot, replace, conf) {
  var defaultProps = { props: { right: conf.right } };

  if (slot && replace) {
    child.push(h(name, defaultProps, slot));
    return
  }

  var v = false;
  for (var p in conf) {
    if (conf.hasOwnProperty(p)) {
      v = conf[p];
      if (v !== void 0 && v !== true) {
        child.push(h(name, { props: conf }));
        break
      }
    }
  }

  slot && child.push(h(name, defaultProps, slot));
}

var ItemWrapper = {
  name: 'ItemWrapper',
  props: {
    cfg: {
      type: Object,
      default: function () { return ({}); }
    },
    slotReplace: Boolean
  },
  render: function render (h) {
    var
      cfg = this.cfg,
      replace = this.slotReplace,
      child = [];

    push(child, h, ItemSide, this.$slots.left, replace, {
      icon: cfg.icon,
      color: cfg.leftColor,
      avatar: cfg.avatar,
      letter: cfg.letter,
      image: cfg.image,
      inverted: cfg.leftInverted,
      textColor: cfg.leftTextColor
    });

    push(child, h, ItemMain, this.$slots.main, replace, {
      label: cfg.label,
      sublabel: cfg.sublabel,
      labelLines: cfg.labelLines,
      sublabelLines: cfg.sublabelLines,
      inset: cfg.inset
    });

    push(child, h, ItemSide, this.$slots.right, replace, {
      right: true,
      icon: cfg.rightIcon,
      color: cfg.rightColor,
      avatar: cfg.rightAvatar,
      letter: cfg.rightLetter,
      image: cfg.rightImage,
      stamp: cfg.stamp,
      inverted: cfg.rightInverted,
      textColor: cfg.rightTextColor
    });

    child.push(this.$slots.default);

    return h(Item, {
      attrs: this.$attrs,
      on: this.$listeners,
      props: cfg
    }, child)
  }
};

/**
 * radio
 *
 * @since 2019-06-28
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

var Radio = {
  name: 'radio',
  mixins: [OptionMixin],
  props: {
    val: {
      required: true
    }
  },
  computed: {
    isTrue: function isTrue () {
      return this.value === this.val
    }
  },
  methods: {
    toggle: function toggle (evt, blur) {
      if ( blur === void 0 ) blur = true;

      if (this.disable || this.readonly) {
        return
      }
      evt && stopAndPrevent(evt);
      blur && this.$el.blur();

      if (!this.isTrue) {
        this.__update(this.val);
      }
    },
    __getContent: function __getContent (h) {
      return [
        h(Icon, {
          staticClass: 's-radio-unchecked cursor-pointer absolute-full',
          props: {
            name: this.uncheckedIcon || this.$table.icon.radio.unchecked.mat
          }
        }),
        h(Icon, {
          staticClass: 's-radio-checked cursor-pointer absolute-full',
          props: {
            name: this.checkedIcon || this.$table.icon.radio.checked.mat
          }
        }),
        h('div', { ref: 'ripple', staticClass: 's-radial-ripple' })
      ]
    }
  },
  beforeCreate: function beforeCreate () {
    this.__kebabTag = 'radio';
  }
};

/**
 * toggle
 *
 * @since 2019-06-28
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

var Toggle = {
  name: 'toggle',
  mixins: [CheckboxMixin, OptionMixin],
  props: {
    icon: String
  },
  computed: {
    currentIcon: function currentIcon () {
      return (this.isTrue ? this.checkedIcon : this.uncheckedIcon) || this.icon
    },
    iconColor: function iconColor () {
      return (this.isTrue ? 'white' : 'dark')
    },
    baseClass: function baseClass () {
      return void 0
    }
  },
  methods: {
    __swipe: function __swipe (evt) {
      if (evt.direction === 'left') {
        if (this.isTrue) {
          this.toggle();
        }
      } else if (evt.direction === 'right') {
        if (this.isFalse) {
          this.toggle();
        }
      }
    },
    __getContent: function __getContent (h) {
      return [
        h('div', { staticClass: 's-toggle-base', 'class': this.baseClass }),
        h('div', { staticClass: 's-toggle-handle row flex-center' }, [
          this.currentIcon
            ? h(Icon, {
              staticClass: 's-toggle-icon',
              props: { name: this.currentIcon, color: this.iconColor }
            })
            : null,
          h('div', { ref: 'ripple', staticClass: 's-radial-ripple' })
        ])
      ]
    }
  },
  beforeCreate: function beforeCreate () {
    this.__kebabTag = 'toggle';
  }
};

/**
 * chip
 *
 * @since 2019-06-28
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

var Chip = {
  name: 'chip',
  props: {
    small: Boolean,
    dense: Boolean,
    tag: Boolean,
    square: Boolean,
    floating: Boolean,
    pointing: {
      type: String,
      validator: function (v) { return ['up', 'right', 'down', 'left'].includes(v); }
    },
    color: String,
    textColor: String,
    icon: String,
    iconRight: String,
    avatar: String,
    closable: Boolean,
    detail: Boolean
  },
  computed: {
    classes: function classes () {
      var this$1 = this;

      var cls = [];

      this.pointing && cls.push(("s-chip-pointing-" + (this.pointing)))
      ;['tag', 'square', 'floating', 'pointing', 'small', 'dense'].forEach(function (prop) {
        this$1[prop] && cls.push(("s-chip-" + prop));
      });
      if (this.floating) {
        !this.dense && cls.push('s-chip-dense');
        !this.square && cls.push('s-chip-square');
      }

      if (this.color) {
        cls.push(("bg-" + (this.color)));
        !this.textColor && cls.push('text-white');
      }
      if (this.textColor) {
        cls.push(("text-" + (this.textColor)));
      }

      return cls
    }
  },
  methods: {
    __onClick: function __onClick (e) {
      this.$emit('click', e);
    },
    __onMouseDown: function __onMouseDown (e) {
      this.$emit('focus', e);
    },
    __handleKeyDown: function __handleKeyDown (e) {
      if (this.closable && [8, 13, 32].includes(getEventKey(e))) {
        stopAndPrevent(e);
        this.$emit('hide');
      }
    }
  },
  render: function render (h) {
    var this$1 = this;

    return h('div', {
      staticClass: 's-chip row no-wrap inline items-center',
      'class': this.classes,
      on: {
        mousedown: this.__onMouseDown,
        touchstart: this.__onMouseDown,
        click: this.__onClick,
        keydown: this.__handleKeyDown
      }
    }, [
      this.icon || this.avatar
        ? h('div', {
          staticClass: 's-chip-side s-chip-left row flex-center',
          'class': { 's-chip-detail': this.detail }
        }, [
          this.icon
            ? h(Icon, { staticClass: 's-chip-icon', props: { name: this.icon } })
            : (this.avatar ? h('img', { attrs: { src: this.avatar } }) : null)
        ])
        : null,

      h('div', { staticClass: 's-chip-main ellipsis' }, this.$slots.default),

      this.iconRight
        ? h(Icon, {
          props: { name: this.iconRight },
          'class': this.closable ? 'on-right s-chip-icon' : 's-chip-side s-chip-right'
        })
        : null,

      this.closable
        ? h('div', { staticClass: 's-chip-side s-chip-close s-chip-right row flex-center' }, [
          h(Icon, {
            props: { name: this.$table.icon.chip.close },
            staticClass: 'cursor-pointer',
            nativeOn: {
              click: function (e) {
                e && e.stopPropagation();
                this$1.$emit('hide');
              }
            }
          })
        ])
        : null
    ])
  }
};

/**
 * keyboard-selection
 *
 * @since 2019-06-28
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

var KeyboardSelectionMixin = {
  data: function () { return ({
    keyboardIndex: 0,
    keyboardMoveDirection: false,
    keyboardMoveTimer: false
  }); },
  watch: {
    keyboardIndex: function keyboardIndex (val) {
      var this$1 = this;

      if (this.$refs.popover && this.$refs.popover.showing && this.keyboardMoveDirection && val > -1) {
        this.$nextTick(function () {
          if (!this$1.$refs.popover) {
            return
          }
          var selected = this$1.$refs.popover.$el.querySelector('.s-select-highlight');
          if (selected && selected.scrollIntoView) {
            if (selected.scrollIntoViewIfNeeded) {
              return selected.scrollIntoViewIfNeeded(false)
            }
            selected.scrollIntoView(this$1.keyboardMoveDirection < 0);
          }
        });
      }
    }
  },
  methods: {
    __keyboardShow: function __keyboardShow (index) {
      if ( index === void 0 ) index = 0;

      if (this.keyboardIndex !== index) {
        this.keyboardIndex = index;
      }
    },
    __keyboardSetCurrentSelection: function __keyboardSetCurrentSelection (navigation) {
      if (this.keyboardIndex >= 0 && this.keyboardIndex <= this.keyboardMaxIndex) {
        this.__keyboardSetSelection(this.keyboardIndex, navigation);
      }
    },
    __keyboardHandleKey: function __keyboardHandleKey (e) {
      var key = getEventKey(e);

      switch (key) {
        case 38: // UP key
          this.__keyboardMoveCursor(-1, e);
          break
        case 40: // DOWN key
          this.__keyboardMoveCursor(1, e);
          break
        case 13: // ENTER key
          if (this.$refs.popover.showing) {
            stopAndPrevent(e);
            this.__keyboardSetCurrentSelection();
            return
          }
          break
        case 9: // TAB key
          this.hide();
          break
      }

      this.__keyboardCustomKeyHandle(key, e);
    },
    __keyboardMoveCursor: function __keyboardMoveCursor (offset, e) {
      var this$1 = this;

      stopAndPrevent(e);

      if (this.$refs.popover.showing) {
        clearTimeout(this.keyboardMoveTimer);
        var index = this.keyboardIndex;
        var valid = this.__keyboardIsSelectableIndex || (function () { return true; });

        do {
          index = normalizeToInterval(
            index + offset,
            -1,
            this.keyboardMaxIndex
          );
        }
        while (index !== this.keyboardIndex && !valid(index))

        this.keyboardMoveDirection = index > this.keyboardIndex ? 1 : -1;
        this.keyboardMoveTimer = setTimeout(function () { this$1.keyboardMoveDirection = false; }, 500);
        this.keyboardIndex = index;
        return
      }

      this.__keyboardShowTrigger();
    }
  }
};

/**
 * selectbox
 *
 * @since 2019-06-28
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

function defaultFilterFn (terms, obj) {
  return obj.label.toLowerCase().indexOf(terms) > -1
}

var SelectBox = {
  name: 'select-box',
  mixins: [FrameMixin, KeyboardSelectionMixin, AuthDisabledMixin],
  props: {
    filter: [Function, Boolean],
    filterPlaceholder: String,
    radio: Boolean,
    placeholder: String,
    separator: Boolean,
    value: { required: true },
    multiple: Boolean,
    toggle: Boolean,
    chips: Boolean,
    options: {
      type: [Array, Function]
    },
    chipsColor: String,
    chipsBgColor: String,
    displayValue: String,
    popupMaxHeight: String,
    popupCover: {
      type: Boolean,
      default: true
    },

    row: Object
  },
  data: function data () {
    return {
      model: this.multiple && Array.isArray(this.value)
        ? this.value.slice()
        : this.value,
      terms: '',
      focused: false
    }
  },
  watch: {
    value: function value (val) {
      this.model = this.multiple && Array.isArray(val)
        ? val.slice()
        : val;
    },
    visibleOptions: function visibleOptions () {
      this.__keyboardCalcIndex();
    }
  },
  computed: {
    getOptions: function getOptions () {
      if (typeof this.options === 'function') {
        return this.options(this.row)
      }

      return this.options
    },
    optModel: function optModel () {
      var this$1 = this;

      if (this.multiple) {
        return this.model.length > 0
          ? this.getOptions.map(function (opt) { return this$1.model.includes(opt.value); })
          : this.getOptions.map(function (opt) { return false; })
      }
    },
    visibleOptions: function visibleOptions () {
      var this$1 = this;

      var opts = this.getOptions.map(function (opt, index) { return Object.assign({}, opt, { index: index }); });

      if (this.filter && this.terms.length) {
        var lowerTerms = this.terms.toLowerCase();
        opts = opts.filter(function (opt) { return this$1.filterFn(lowerTerms, opt); });
      }
      return opts
    },
    keyboardMaxIndex: function keyboardMaxIndex () {
      return this.visibleOptions.length - 1
    },
    filterFn: function filterFn () {
      return typeof this.filter === 'boolean'
        ? defaultFilterFn
        : this.filter
    },
    actualValue: function actualValue () {
      var this$1 = this;

      if (this.displayValue) {
        return this.displayValue
      }
      if (!this.multiple) {
        var opt$1 = this.getOptions.find(function (opt) { return opt.value === this$1.model; });
        return opt$1 ? opt$1.label : ''
      }

      var opt = this.selectedOptions.map(function (opt) { return opt.label; });
      return opt.length ? opt.join(', ') : ''
    },
    computedClearValue: function computedClearValue () {
      return this.clearValue === void 0 ? (this.multiple ? [] : null) : this.clearValue
    },
    isClearable: function isClearable () {
      return !this.isDisabled && this.clearable && JSON.stringify(this.computedClearValue) !== JSON.stringify(this.model)
    },
    selectedOptions: function selectedOptions () {
      var this$1 = this;

      if (this.multiple) {
        return this.length > 0
          ? this.getOptions.filter(function (opt) { return this$1.model.includes(opt.value); })
          : []
      }
    },
    hasChips: function hasChips () {
      return this.multiple && this.chips && this.length > 0
    },
    length: function length () {
      return this.multiple
        ? this.model.length
        : ([null, undefined, ''].includes(this.model) ? 0 : 1)
    },
    additionalLength: function additionalLength () {
      return this.displayValue && this.displayValue.length > 0
    }
  },
  methods: {
    togglePopup: function togglePopup () {
      this.$refs.popover && this[this.$refs.popover.showing ? 'hide' : 'show']();
    },
    show: function show () {
      this.__keyboardCalcIndex();
      if (this.$refs.popover) {
        return this.$refs.popover.show()
      }
    },
    hide: function hide () {
      return this.$refs.popover ? this.$refs.popover.hide() : Promise.resolve()
    },
    reposition: function reposition () {
      var popover = this.$refs.popover;
      if (popover && popover.showing) {
        this.$nextTick(function () { return popover && popover.reposition(); });
      }
    },

    __keyboardCalcIndex: function __keyboardCalcIndex () {
      var this$1 = this;

      this.keyboardIndex = -1;
      var sel = this.multiple ? this.selectedOptions.map(function (o) { return o.value; }) : [this.model];
      this.$nextTick(function () {
        var index = sel === void 0 ? -1 : Math.max(-1, this$1.visibleOptions.findIndex(function (opt) { return sel.includes(opt.value); }));
        if (index > -1) {
          this$1.keyboardMoveDirection = true;
          setTimeout(function () { this$1.keyboardMoveDirection = false; }, 500);
          this$1.__keyboardShow(index);
        }
      });
    },
    __keyboardCustomKeyHandle: function __keyboardCustomKeyHandle (key, e) {
      switch (key) {
        case 27: // ESCAPE
          if (this.$refs.popover.showing) {
            this.hide();
          }
          break
        case 13: // ENTER key
        case 32: // SPACE key
          if (!this.$refs.popover.showing) {
            this.show();
          }
          break
      }
    },
    __keyboardShowTrigger: function __keyboardShowTrigger () {
      this.show();
    },
    __keyboardSetSelection: function __keyboardSetSelection (index) {
      var opt = this.visibleOptions[index];

      if (this.multiple) {
        this.__toggleMultiple(opt.value, opt.disable);
      } else {
        this.__singleSelect(opt.value, opt.disable);
      }
    },
    __keyboardIsSelectableIndex: function __keyboardIsSelectableIndex (index) {
      return index > -1 && index < this.visibleOptions.length && !this.visibleOptions[index].disable
    },
    __mouseEnterHandler: function __mouseEnterHandler (e, index) {
      if (!this.keyboardMoveDirection) {
        this.keyboardIndex = index;
      }
    },
    __onFocus: function __onFocus () {
      if (this.isDisabled || this.focused) {
        return
      }
      this.focused = true;
      this.$emit('focus', this.model);
    },
    __onShow: function __onShow () {
      if (this.isDisabled) {
        return
      }
      this.__onFocus();
      if (this.filter && this.$refs.filter) {
        this.$refs.filter.focus();
        this.reposition();
      }
    },
    __onBlur: function __onBlur (e) {
      var this$1 = this;

      if (!this.focused) {
        return
      }
      setTimeout(function () {
        var el = document.activeElement;
        if (
          !this$1.$refs.popover ||
          !this$1.$refs.popover.showing ||
          (el !== document.body && !this$1.$refs.popover.$el.contains(el))
        ) {
          this$1.__onClose();
          this$1.hide();
        }
      }, 1);
    },
    __onClose: function __onClose (keepFocus) {
      var this$1 = this;

      this.$nextTick(function () {
        if (JSON.stringify(this$1.model) !== JSON.stringify(this$1.value)) {
          this$1.$emit('change', this$1.model);
        }
      });
      this.terms = '';
      if (!this.focused) {
        return
      }
      if (keepFocus) {
        this.$refs.input && this.$refs.input.$el && this.$refs.input.$el.focus();
        return
      }
      this.focused = false;
      this.$emit('blur');
    },
    __singleSelect: function __singleSelect (val, disable) {
      if (disable) {
        return
      }
      this.__emit(val);
      this.hide();
    },
    __toggleMultiple: function __toggleMultiple (value, disable) {
      if (disable) {
        return
      }
      var
        model = this.model,
        index = model.indexOf(value);

      if (index > -1) {
        this.$emit('remove', { index: index, value: model.splice(index, 1) });
      } else {
        this.$emit('add', { index: model.length, value: value });
        model.push(value);
      }

      this.$emit('input', model);
    },
    __emit: function __emit (value) {
      var this$1 = this;

      this.$emit('update:value', value);
      this.$emit('input', value);

      this.$nextTick(function () {
        if (JSON.stringify(value) !== JSON.stringify(this$1.value)) {
          this$1.$emit('change', value);
        }
      });
    },
    __setModel: function __setModel (val, forceUpdate) {
      this.model = val || (this.multiple ? [] : null);
      this.$emit('input', this.model);
      if (forceUpdate || !this.$refs.popover || !this.$refs.popover.showing) {
        this.__onClose(forceUpdate);
      }
    },
    __getChipTextColor: function __getChipTextColor (optColor) {
      if (this.chipsColor) {
        return this.chipsColor
      }
      if (this.isInvertedLight) {
        return this.invertedLight ? optColor || this.color : 'white'
      }
      if (this.isInverted) {
        return optColor || (this.invertedLight ? 'grey-10' : this.color)
      }
      return this.dark
        ? optColor || this.color
        : 'white'
    },
    __getChipBgColor: function __getChipBgColor (optColor) {
      if (this.chipsBgColor) {
        return this.chipsBgColor
      }
      if (this.isInvertedLight) {
        return this.invertedLight ? 'grey-10' : optColor || this.color
      }
      if (this.isInverted) {
        return this.invertedLight ? this.color : 'white'
      }
      return this.dark
        ? 'white'
        : optColor || this.color
    }
  },

  render: function render (h) {
    var this$1 = this;

    var child = [];

    if (this.hasChips) {
      var el = h('div', {
        staticClass: 'col row items-center s-input-chips',
        'class': this.alignClass
      }, this.selectedOptions.map(function (opt, index) {
        return h(Chip, {
          key: index,
          props: {
            small: true,
            closable: this$1.editable && !opt.isDisabled,
            color: this$1.__getChipBgColor(opt.color),
            textColor: this$1.__getChipTextColor(opt.color),
            icon: opt.icon,
            iconRight: opt.rightIcon,
            avatar: opt.avatar
          },
          on: {
            hide: function () { this$1.__toggleMultiple(opt.value, this$1.isDisabled || opt.disable); }
          },
          nativeOn: {
            click: function (e) { e.stopPropagation(); }
          }
        }, [
          h('div', { domProps: { innerHTML: opt.label } })
        ])
      }));
      child.push(el);
    } else {
      var el$1 = h('div', {
        staticClass: 'col s-input-target ellipsis',
        'class': this.fakeInputClasses,
        domProps: { innerHTML: this.fakeInputValue }
      });
      child.push(el$1);
    }

    child.push(h(PopOver, {
      ref: 'popover',
      staticClass: 'column no-wrap',
      'class': this.dark ? 'bg-dark' : null,
      props: {
        cover: this.popupCover,
        keepOnScreen: true,
        disable: this.isDisabled,
        anchorClick: false,
        maxHeight: this.popupMaxHeight
      },
      slot: 'after',
      on: {
        show: this.__onShow,
        hide: function () { this$1.__onClose(true); }
      },
      nativeOn: {
        keydown: this.__keyboardHandleKey
      }
    }, [
      (this.filter && h(Search, {
        ref: 'filter',
        staticClass: 'col-auto',
        style: 'margin-top: 5px',
        props: {
          authForce: this.authForce,
          haForce: this.haForce,
          value: this.terms,
          placeholder: this.filterPlaceholder || 'Filter',
          debounce: 100,
          color: this.color,
          dark: this.dark,
          noParentField: true,
          noIcon: true
        },
        on: {
          input: function (val) {
            this$1.terms = val;
            this$1.reposition();
          }
        }
      })) || void 0,

      (this.visibleOptions.length && h(List, {
        staticClass: 'no-border scroll',
        props: {
          separator: this.separator,
          dark: this.dark
        }
      }, this.visibleOptions.map(function (opt, index) {
        return h(ItemWrapper, {
          key: index,
          'class': [
            opt.disable ? 'text-faded' : 'cursor-pointer',
            index === this$1.keyboardIndex ? 's-select-highlight' : '',
            opt.disable ? '' : 'cursor-pointer',
            opt.className || ''
          ],
          props: {
            cfg: opt,
            slotReplace: true,
            active: this$1.multiple ? void 0 : this$1.value === opt.value
          },
          nativeOn: {
            '!click': function () {
              var action = this$1.multiple ? '__toggleMultiple' : '__singleSelect';
              this$1[action](opt.value, opt.disable);
            },
            mouseenter: function (e) {
              !opt.disable && this$1.__mouseEnterHandler(e, index);
            }
          }
        }, [
          this$1.multiple
            ? h(this$1.toggle ? Toggle : CheckBox, {
              slot: this$1.toggle ? 'right' : 'left',
              props: {
                authForce: this$1.authForce,
                haForce: this$1.haForce,
                keepColor: true,
                color: opt.color || this$1.color,
                dark: this$1.dark,
                value: this$1.optModel[opt.index],
                disable: opt.isDisabled,
                noFocus: true
              }
            })
            : (this$1.radio && h(Radio, {
            slot: 'left',
            props: {
              keepColor: true,
              color: opt.color || this$1.color,
              dark: this$1.dark,
              value: this$1.value,
              val: opt.value,
              disable: opt.isDisabled,
              noFocus: true
            }
          })) || void 0
        ])
      }))) || void 0
    ]));

    if (this.isClearable) {
      child.push(h(Icon, {
        slot: 'after',
        staticClass: 's-if-control',
        props: { name: this.$table.icon.input[("clear" + (this.isInverted ? 'Inverted' : ''))] },
        nativeOn: {
          click: this.clear
        }
      }));
    }

    child.push(
      h(Icon, this.readonly ? { slot: 'after' } : {
        slot: 'after',
        staticClass: 's-if-control',
        props: { name: this.$table.icon.input.dropdown }
      })
    );

    return h(InputFrame, {
      ref: 'input',
      staticClass: 's-select s-table-comp s-table-select',
      props: {
        prefix: this.prefix,
        suffix: this.suffix,
        stackLabel: this.stackLabel,
        floatLabel: this.floatLabel,
        error: this.error,
        warning: this.warning,
        disable: this.isDisabled,
        readonly: this.readonly,
        inverted: this.inverted,
        invertedLight: this.invertedLight,
        dark: this.dark,
        hideUnderline: this.hideUnderline,
        before: this.before,
        after: this.after,
        color: this.color,
        noParentField: this.noParentField,
        focused: this.focused,
        focusable: true,
        length: this.length,
        additionalLength: this.additionalLength
      },
      nativeOn: {
        click: this.togglePopup,
        focus: this.__onFocus,
        blur: this.__onBlur,
        keydown: this.__keyboardHandleKey,
        dblclick: function (e) { return stopAndPrevent(e); }
      }
    }, child)
  }
};

/**
 * ripple
 *
 * @since 2019-07-09
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

function showRipple (evt, el, stopPropagation) {
  if (stopPropagation) {
    evt.stopPropagation();
  }

  var container = document.createElement('span');
  var animNode = document.createElement('span');

  container.appendChild(animNode);
  container.className = 's-ripple-container';

  var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
  size = (size * 2) + "px";
  animNode.className = 's-ripple-animation';
  css(animNode, { width: size, height: size });

  el.appendChild(container);

  var offset = el.getBoundingClientRect();
  var pos = position(evt);
  var x = pos.left - offset.left;
  var y = pos.top - offset.top;

  animNode.classList.add('s-ripple-animation-enter', 's-ripple-animation-visible');
  css(animNode, cssTransform(("translate(-50%, -50%) translate(" + x + "px, " + y + "px) scale(.001)")));

  setTimeout(function () {
    animNode.classList.remove('s-ripple-animation-enter');
    css(animNode, cssTransform(("translate(-50%, -50%) translate(" + x + "px, " + y + "px)")));
    setTimeout(function () {
      animNode.classList.remove('s-ripple-animation-visible');
      setTimeout(function () {
        animNode.parentNode.remove();
      }, 300);
    }, 400);
  }, 25);
}

function shouldAbort (ref) {
  var mat = ref.mat;
  var ios = ref.ios;

  return void 0
}

var Ripple = {
  name: 'ripple',
  inserted: function inserted (el, ref) {
    var value = ref.value;
    var modifiers = ref.modifiers;

    if (shouldAbort(modifiers)) ;

    var ctx = {
      enabled: value !== false,
      click: function click (evt) {
        if (ctx.enabled) {
          showRipple(evt, el, modifiers.stop);
        }
      }
    };

    el.__qripple = ctx;
    el.addEventListener('click', ctx.click, false);
  },
  update: function update (el, ref) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    if (el.__qripple && value !== oldValue) {
      el.__qripple.enabled = value !== false;
    }
  },
  unbind: function unbind (el, ref) {
    var modifiers = ref.modifiers;

    var ctx = el.__qripple;
    if (!ctx || shouldAbort(modifiers)) {
      return
    }

    el.removeEventListener('click', ctx.click, false);
    delete el.__qripple;
  }
};

/**
 * button-mixin
 *
 * @since 2019-06-28
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

var sizes = {
  xs: 8,
  sm: 10,
  md: 14,
  lg: 20,
  xl: 24,
  form: 12.446,
  'form-label': 17.11,
  'form-hide-underline': 9.335,
  'form-label-hide-underline': 14,
  'form-inverted': 15.555,
  'form-label-inverted': 20.22
};

var BtnMixin = {
  mixins: [AlignMixin],
  components: {
    Icon: Icon
  },
  directives: {
    Ripple: Ripple
  },
  props: {
    authForce: {
      type: Boolean,
      default: false
    },
    haForce: {
      type: Boolean,
      default: false
    },
    loading: Boolean,
    disable: Boolean,
    label: [Number, String],
    noCaps: Boolean,
    noWrap: Boolean,
    icon: String,
    iconRight: String,
    round: Boolean,
    outline: Boolean,
    flat: Boolean,
    rounded: Boolean,
    push: Boolean,
    size: String,
    fab: Boolean,
    fabMini: Boolean,
    color: String,
    textColor: String,
    glossy: Boolean,
    dense: Boolean,
    noRipple: Boolean,
    tabindex: Number
  },
  data: function data () {
    return {
      authDisable: false,
      isHa: false
    }
  },
  watch: {
    haForce: function haForce (v) {
      // 방어 코드
      if (!v) {
        if (this.$table.store) {
          var blueMaxUiData = this.$table.store.state.common.common.uiData;

          if (blueMaxUiData) {
            var haMode = blueMaxUiData.ha.mode.toLowerCase(); // blueMaxUiData.ha.mode 'Active-Standby'.replace('-').toLowerCase() // blueMaxUiData.ha.mode

            // HA 권한제어 (임시)
            if (haMode !== 'stand-alone') {
              var
                haMember = blueMaxUiData.ha.mmbr,
                uuid = blueMaxUiData.system.host_uuid, // 'NGF-580399637050', // blueMaxUiData.system.host_uuid
                haState = haMember.find(function (mmbr) { return mmbr.mmbr_uuid === uuid; }).state;

              if (haState.toLowerCase() === 'backup') {
                this.authDisable = true;
                this.isHa = true;
              }
            }
          }
        }
      }
    }
  },
  beforeMount: function beforeMount () {
    /**
     * 관리자 권한 별 입력 컨트롤 제어
     *
     * @since: 2018-11-09
     * @author: kdydesign.kim
     */
    if (this.$table.store) {
      var
        blueMaxUiData = this.$table.store.state.common.common.uiData,
        isDRSlave = this.$table.model === 'ngf'
          ? this.$table.store.state.securityPolicy.firewall.firewallPolicySettings.fwRules.isDRSlave
          : false;

      if (blueMaxUiData) {
        var
          authLevel = blueMaxUiData.user.level,
          haMode = blueMaxUiData.ha.mode.toLowerCase(); // blueMaxUiData.ha.mode 'Active-Standby'.replace('-').toLowerCase() // blueMaxUiData.ha.mode

        // HA 권한제어 (임시)
        if (haMode !== 'stand-alone') {
          var
            haMember = blueMaxUiData.ha.mmbr,
            uuid = blueMaxUiData.system.host_uuid,
            haState = haMember.find(function (mmbr) { return mmbr.mmbr_uuid === uuid; }).state;

          if (haState.toLowerCase() === 'backup' && !this.haForce) {
            this.authDisable = true;
            this.isHa = true;
          }
        } else {
          // Stand-ALone
          if (authLevel >= 2) {
            this.authDisable = false;

            // 방화벽 DR 설정에 따른 비활성화
            if (isDRSlave) {
              this.authDisable = true;
            }
          } else {
            this.authDisable = true;
          }
        }
      }
    }
  },
  computed: {
    style: function style () {
      if (this.size && !this.fab && !this.fabMini) {
        return {
          fontSize: this.size in sizes ? ((sizes[this.size]) + "px") : this.size
        }
      }
    },
    isRectangle: function isRectangle () {
      return !this.isRound
    },
    isRound: function isRound () {
      return this.round || this.fab || this.fabMini
    },
    shape: function shape () {
      return ("s-btn-" + (this.isRound ? 'round' : 'rectangle'))
    },
    isDisabled: function isDisabled () {
      var isDRSlave = false;

      if (this.$table.store) {
        var blueMaxUiData = this.$table.store.state.common.common.uiData;

        isDRSlave = this.$q.model === 'ngf'
          ? this.$q.store.state.securityPolicy.firewall.firewallPolicySettings.fwRules.isDRSlave
          : false;

        var authLevel = 3;

        if (blueMaxUiData) {
          authLevel = blueMaxUiData.user.level;
        }

        if (!this.isHa) {
          // ha back-up이 아닌 경우 dr 설정 체크 루틴 수행
          if (authLevel >= 2) {
            this.authDisable = false;

            // 방화벽 DR 설정에 따른 비활성화
            if (isDRSlave) {
              this.authDisable = true;
            }
          } else {
            this.authDisable = true;
          }
        }

        if (this.authForce || this.haForce) {
          if (this.disable) {
            return this.disable
          }

          if (this.authForce) {
            return !this.authForce
          }

          if (this.haForce) {
            if (authLevel < 2) {
              return true
            }

            return !this.haForce
          }
        }
      }

      return this.authDisable || this.disable || this.loading || isDRSlave
    },
    hasRipple: function hasRipple () {
      return !this.noRipple
    },
    computedTabIndex: function computedTabIndex () {
      return this.isDisabled ? -1 : this.tabindex || 0
    },
    classes: function classes () {
      var cls = [this.shape];

      if (this.fab) {
        cls.push('s-btn-fab');
      } else if (this.fabMini) {
        cls.push('s-btn-fab-mini');
      }

      if (this.flat) {
        cls.push('s-btn-flat');
      } else if (this.outline) {
        cls.push('s-btn-outline');
      } else if (this.push) {
        cls.push('s-btn-push');
      }

      if (this.isDisabled) {
        cls.push('disabled');
      } else {
        cls.push('s-focusable s-hoverable');
      }

      if (this.color) {
        if (this.flat || this.outline) {
          cls.push(("text-" + (this.textColor || this.color)));
        } else {
          cls.push(("bg-" + (this.color)));
          cls.push(("text-" + (this.textColor || 'white')));
        }
      } else if (this.textColor) {
        cls.push(("text-" + (this.textColor)));
      }

      cls.push({
        's-btn-no-uppercase': this.noCaps,
        's-btn-rounded': this.rounded,
        's-btn-dense': this.dense,
        'glossy': this.glossy
      });

      return cls
    },
    innerClasses: function innerClasses () {
      var classes = [this.alignClass];
      this.noWrap && classes.push('no-wrap', 'text-no-wrap');
      this.repeating && classes.push('non-selectable');
      return classes
    }
  }
};

/**
 * Button
 *
 * @since 2019-06-28
 * @author kdydesign.kim
 *
 * Quasar 0.15.7
 */

var Button = {
  name: 'btn',
  mixins: [BtnMixin],
  props: {
    percentage: Number,
    darkPercentage: Boolean,
    waitForRipple: Boolean,
    repeatTimeout: [Number, Function],
    customClass: String,
    iconCustomClass: String
  },
  computed: {
    hasPercentage: function hasPercentage () {
      return this.percentage !== void 0
    },
    width: function width () {
      return ((between(this.percentage, 0, 100)) + "%")
    },
    events: function events () {
      return this.isDisabled || !this.repeatTimeout
        ? { click: this.click }
        : {
          mousedown: this.__startRepeat,
          touchstart: this.__startRepeat,

          mouseup: this.__endRepeat,
          touchend: this.__endRepeat,

          mouseleave: this.__abortRepeat,
          touchmove: this.__abortRepeat
        }
    }
  },
  data: function data () {
    return {
      repeating: false,
      processingClick: false
    }
  },
  methods: {
    click: function click (e) {
      var this$1 = this;

      if (this.processingClick) {
        return
      }

      if (!this.processingClick) {
        this.__cleanup();

        var trigger = function () {
          if (this$1.isDisabled) {
            return
          }

          this$1.$emit('click', e);
        };

        if (this.waitForRipple && this.hasRipple) {
          this.timer = setTimeout(trigger, 300);
        } else {
          trigger();
        }

        // @author: kdydesign.kim
        // @since: 2018-10-13
        // enter 키 이벤트 제거를 위해 focus out
        this.$el.blur();
      }

      this.processingClick = !this.processingClick;

      setTimeout(function () {
        this$1.processingClick = !this$1.processingClick;
      }, 1000);
    },
    __cleanup: function __cleanup () {
      clearTimeout(this.timer);
    },
    __startRepeat: function __startRepeat (e) {
      var this$1 = this;

      var setTimer = function () {
        this$1.timer = setTimeout(
          trigger,
          typeof this$1.repeatTimeout === 'function'
            ? this$1.repeatTimeout(this$1.repeatCount)
            : this$1.repeatTimeout
        );
      };
      var trigger = function () {
        if (this$1.isDisabled) {
          return
        }
        this$1.repeatCount += 1;
        e.repeatCount = this$1.repeatCount;
        this$1.$emit('click', e);
        setTimer();
      };

      this.repeatCount = 0;
      this.repeating = true;
      setTimer();
    },
    __abortRepeat: function __abortRepeat () {
      this.repeating = false;
      this.__cleanup();
    },
    __endRepeat: function __endRepeat (e) {
      if (!this.repeating) {
        return
      }

      if (this.repeatCount) {
        this.repeatCount = 0;
      } else if (e.detail) {
        this.repeating = false;
        e.repeatCount = 0;
        this.$emit('click', e);
      }

      this.__cleanup();
    }
  },
  beforeDestroy: function beforeDestroy () {
    this.__cleanup();
  },
  render: function render (h) {
    return h('button', {
      staticClass: 's-btn inline relative-position s-btn-item non-selectable',
      'class': this.classes.concat(this.customClass),
      style: this.style,
      attrs: { tabindex: this.computedTabIndex },
      on: this.events,
      directives: this.hasRipple
        ? [
          {
            name: 'ripple',
            value: true
          }]
        : null
    }, [
      h('div', { staticClass: 's-focus-helper' }),

      this.loading && this.hasPercentage
        ? h('div', {
          staticClass: 's-btn-progress absolute-full',
          'class': { 's-btn-dark-progress': this.darkPercentage },
          style: { width: this.width }
        })
        : null,

      h('div', {
          staticClass: 's-btn-inner row col items-center',
          'class': this.innerClasses
        },
        this.loading
          ? [this.$slots.loading]
          : [
            this.icon || this.iconCustomClass
              ? h('Icon', {
                'class': [
                  { 'on-left': this.label && this.isRectangle },
                  this.iconCustomClass
                ],
                props: { name: this.icon }
              })
              : null,

            this.label && this.isRectangle ? h('div', [this.label]) : null,

            this.$slots.default,

            this.iconRight && this.isRectangle
              ? h('Icon', {
                staticClass: 'on-right',
                props: { name: this.iconRight }
              })
              : null
          ]
      )
    ])
  }
};

/**
 * button group
 *
 * @since 2019-07-11
 * @author kdydesign.kim
 *
 * Quasar 0.15.7
 */
var ButtonGroup = {
  name: 'btn-group',
  props: {
    outline: Boolean,
    flat: Boolean,
    rounded: Boolean,
    push: Boolean
  },
  computed: {
    classes: function classes () {
      var this$1 = this;

      return ['outline', 'flat', 'rounded', 'push']
        .filter(function (t) { return this$1[t]; })
        .map(function (t) { return ("s-btn-group-" + t); }).join(' ')
    }
  },
  render: function render (h) {
    return h('div', {
      staticClass: 's-btn-group row no-wrap inline',
      'class': this.classes
    }, [
      this.$slots.default
    ])
  }
};

/**
 * button dropdown
 *
 * @since 2019-07-11
 * @author kdydesign.kim
 *
 * Quasar 0.15.7
 */

var ButtonDropDown = {
  name: 'btn-dropdown',
  mixins: [BtnMixin],
  props: {
    value: Boolean,
    split: Boolean,
    contentClass: [Array, String, Object],
    contentStyle: [Array, String, Object]
  },
  data: function data () {
    return {
      showing: this.value
    }
  },
  watch: {
    value: function value (val) {
      this.$refs.popover[val ? 'show' : 'hide']();
    }
  },
  render: function render (h) {
    var this$1 = this;

    var
      PopoverComp = h(
        PopOver,
        {
          ref: 'popover',
          props: {
            disable: this.isDisabled,
            fit: true,
            anchorClick: !this.split,
            anchor: 'bottom right',
            self: 'top right'
          },
          'class': ("column no-wrap " + (this.contentClass)),
          style: this.contentStyle,
          on: {
            show: function (e) {
              // 클래스 추가
              if (this$1.$refs.qbtndd) {
                this$1.$refs.qbtndd.$el.classList.add('s-if-focused');
              }

              // 팝오버 객체
              var popOver = this$1.$refs.popover;

              // 팝오버 객체가 있으면 다음단계 진행
              if (popOver) {
                // 팝오버 객체가 있으면 DOM 객체 추가
                popOver = popOver.$el;

                // 자식노드 추가
                var popoverBefore = document.createElement('div');

                // DIV 생성
                popoverBefore.style.left = 'auto';
                popoverBefore.style.width = (this$1.$el.clientWidth) + "px";
                popoverBefore.className = 'popover-before';

                // 자식노드를 첫번째에 추가
                popOver.insertBefore(popoverBefore, popOver.childNodes[0]);
              }

              this$1.showing = true;
              this$1.$emit('show', e);
              this$1.$emit('input', true);
            },
            hide: function (e) {
              // 클래스 제거
              if (this$1.$refs.qbtndd) {
                this$1.$refs.qbtndd.$el.classList.remove('s-if-focused');
              }

              // 팝오버 객체
              var popOver = this$1.$refs.popover;

              // 팝오버 객체가 있으면 다음단계 진행
              if (popOver) {
                // 팝오버 객체가 있으면 DOM 객체 추가
                popOver = popOver.$el;

                // 제거확인 플래그
                var deleteBeforeNode = false;

                // 팝오버 객체의 자식노드 검색
                for (var i = 0; i < popOver.childNodes.length; i++) {
                  // 순차적으로 자식노드 검색
                  var childNode = popOver.childNodes[i];

                  // 자식노드 클래스 가져오기
                  var childNodeClass = childNode.classList || [];

                  // 자식노드 클래스가 있는 경우에만 조회
                  if (childNodeClass.length > 0) {
                    // 자식 노드 클래스를 순차적으로 조회
                    for (var j = 0, max = childNodeClass.length; j < max; j++) {
                      // 클래스 목록에 'popover-before' 찾기
                      if (childNodeClass[j] === 'popover-before') {
                        // 노드 제거
                        popOver.removeChild(childNode);

                        // 제거확인 플래그 설정
                        deleteBeforeNode = true;

                        // 반복문 종료
                        break
                      }
                    }

                    // 제거확인 플래그가 True 이면 반복문 종료
                    if (deleteBeforeNode) {
                      break
                    }
                  }
                }
              }

              this$1.showing = false;
              this$1.$emit('hide', e);
              this$1.$emit('input', false);
            }
          }
        },
        [this.$slots.default]
      ),
      IconComp = h(
        'Icon',
        {
          props: {
            name: this.$table.icon.input.dropdown,
            authForce: this.authForce,
            haForce: this.haForce,
            disable: this.isDisabled
          },
          staticClass: 'transition-generic',
          'class': {
            'rotate-180': this.showing,
            'on-right': !this.split,
            's-btn-dropdown-arrow': !this.split
          }
        }
      ),
      ButtonComp = h(Button, {
        ref: 'qbtndd',
        props: {
          authForce: this.authForce,
          haForce: this.haForce,
          loading: this.loading,
          disable: this.isDisabled,
          noCaps: this.noCaps,
          noWrap: this.noWrap,
          icon: this.icon,
          label: this.label,
          iconRight: this.split ? this.iconRight : null,
          outline: this.outline,
          flat: this.flat,
          rounded: this.rounded,
          push: this.push,
          size: this.size,
          color: this.color,
          textColor: this.textColor,
          glossy: this.glossy,
          dense: this.dense,
          noRipple: this.noRipple,
          waitForRipple: this.waitForRipple
        },
        'class': this.split
          ? ['s-btn-dropdown-current', 'header-btn-dropdown']
          : ['s-btn-dropdown s-btn-dropdown-simple', 'header-btn-dropdown'],
        on: {
          click: function (e) {
            this$1.split && this$1.hide();
            if (!this$1.disable) {
              this$1.$emit('click', e);
            }
          }
        }
      }, this.split ? null : [IconComp, PopoverComp]);

    if (!this.split) {
      return ButtonComp
    }

    return h(
      ButtonGroup,
      {
        props: {
          outline: this.outline,
          flat: this.flat,
          rounded: this.rounded,
          push: this.push
        },
        staticClass: 's-btn-dropdown s-btn-dropdown-split no-wrap s-btn-item'
      },
      [
        ButtonComp,
        h(
          ButtonComp,
          {
            props: {
              disable: this.isDisabled,
              outline: this.outline,
              flat: this.flat,
              rounded: this.rounded,
              push: this.push,
              size: this.size,
              color: this.color,
              textColor: this.textColor,
              dense: this.dense,
              glossy: this.glossy,
              noRipple: this.noRipple,
              waitForRipple: this.waitForRipple
            },
            staticClass: 's-btn-dropdown-arrow',
            on: { click: function () { this$1.toggle(); } }
          },
          [IconComp]
        ),
        [PopoverComp]
      ]
    )
  },
  methods: {
    toggle: function toggle () {
      return this.$refs.popover.toggle()
    },
    show: function show () {
      return this.$refs.popover.show()
    },
    hide: function hide () {
      return this.$refs.popover.hide()
    }
  },
  mounted: function mounted () {
    var this$1 = this;

    this.$nextTick(function () {
      if (this$1.value) {
        this$1.$refs.popover.show();
      }
    });
  }
};

/**
 * virtual List
 *
 * @since: 2019-10-02
 * @author: kdydesign.kim
 */

var VirtualList = {
  name: 'virtual-list',
  props: {
    col: Object,
    row: Object,
    isTAMS: Boolean,
    refTooltip: Object,
    cleanTooltip: Function,
    onMouseEnterHandler: Function,
    onMouseLeaveHandler: Function,
    rowDragAndDrop: [Object, String],
    viewCount: {
      type: Number,
      default: 5
    },
    dataKey: {
      type: String,
      default: void 0
    },
    iconTemplate: {
      type: Function,
      default: void 0
    },
    defaultData: {
      type: Object,
      default: function () {}
    },
    parseData: {
      type: Function,
      default: void 0
    },
    listData: {
      type: [Array, Object],
      default: function () { return []; }
    },
    fullList: Boolean
  },
  data: function data () {
    return {
      virlContainer: void 0,
      isVlShow: {},
      screenItemsLen: 0,
      endPosition: 0,
      from: 0,
      final: 0,
      width: '100%',
      align: 'left',
      rowHeight: 26,
      height: 'calc(100% - 19px)',
      dbClick: this.listDbClick,
      initTooltip: this.cleanTooltip,
      tooltipInstance: this.refTooltip,
      onMouseEnterCallback: this.onMouseEnterHandler,
      onMouseLeaveCallback: this.onMouseLeaveHandler
    }
  },
  beforeMount: function beforeMount () {
    if (!this.refTooltip) {
      this.tooltipInstance = this.$parent.$parent.$parent.$parent.$refs.tooltip;
    }

    if (!this.cleanTooltip) {
      this.initTooltip = this.$parent.__cleanTooltip;
    }

    if (!this.onMouseEnterHandler) {
      this.onMouseEnterCallback = this.$parent.onMouseEnterHandler;
    }

    if (!this.onMouseLeaveHandler) {
      this.onMouseLeaveCallback = this.$parent.onMouseLeaveHandler;
    }
  },
  mounted: function mounted () {
    var this$1 = this;

    if (this.fullList) {
      this.$nextTick(function () {
        this$1.virlContainer = this$1.$refs.virtualScrollListContainer;

        if (this$1.virlContainer && this$1.virlContainer._isVue) {
          this$1.virlContainer = this$1.$refs.virtualScrollListContainer.$el;
        }

        this$1.virlContainer.addEventListener('scroll', this$1.__onVirtualListScroll);
      });
    }
  },
  beforeDestroy: function beforeDestroy () {
    if (this.fullList && this.virlContainer) {
      this.virlContainer.removeEventListener('scroll', this.__onVirtualListScroll);
      this.virlContainer = void 0;
    }
  },
  computed: {
    isVLOpen: function isVLOpen () {
      return this.isVlShow[this.row.__index] === void 0 || this.isVlShow[this.row.__index]
    },
    computedVirtualListData: function computedVirtualListData () {
      var cloneData = this.listData.slice();

      var list = cloneData.map(function (data, index) {
        if (!_.has(data, '__index')) {
          data = _.assign(data, { __index: index });
        }

        return data
      });

      var start = this.from;
      var end = this.final;

      if (start === 0 && end === 0) {
        end = this.endPosition;
      }

      return list.slice(start, end)
    },
    computedContainerHeight: function computedContainerHeight () {
      var height = (this.rowHeight * this.viewCount) + "px";

      if (this.fullList) {
        if (this.listData.length < this.viewCount) {
          height = 'auto';
        }

        return {
          width: this.width,
          height: height
        }
      }

      if (this.height !== 0) {
        height = this.height;
      }

      if (this.listData.length <= 5) {
        height = 'auto';
      }

      return {
        width: this.width,
        height: height
      }
    },
    __getDraggableDisabled: function __getDraggableDisabled () {
      if (_.isArray(this.rowDragAndDrop.field)) {
        return !_.includes(this.rowDragAndDrop.field, this.col.field)
      } else {
        return this.col.field !== this.rowDragAndDrop.field
      }
    }
  },
  methods: {
    getViewItemRow: function getViewItemRow (h) {
      var this$1 = this;

      var viewItemRow = [];
      var viewData = this.listData.slice(0, this.viewCount);

      viewData.forEach(function (item) {
        var value = item;

        if (_.isPlainObject(item)) {
          value = this$1.__pickVLData(value);
        }

        viewItemRow.push(this$1.createVLItem(h, { value: value, item: item }));
      });

      if (this.listData.length > this.viewCount) {
        viewItemRow.push(this.createVLItem(h, { type: 'more' }));
      }

      return viewItemRow
    },
    createVLContainer: function createVLContainer (h) {
      this.totalRows = this.listData.length;
      this.screenItemsLen = Math.ceil(this.rowHeight * this.viewCount / this.rowHeight) + 1;
      this.endPosition =
        this.totalRows >= this.screenItemsLen
          ? this.screenItemsLen
          : this.totalRows;

      var props = {
        ref: 'virtualScrollListContainer',
        staticClass: 'virtual-scroll-list-container',
        style: {
          width: this.computedContainerHeight.width,
          height: this.computedContainerHeight.height,
          textAlign: 'left'
        }
      };

      if (this.listData.length <= 5) {
        props.style = Object.assign(props.style, {
          overflow: 'hidden'
        });
      }

      var srcContainerHeight = this.rowHeight * this.totalRows;
      var child = [
        h('div', {
          style: {
            opacity: 0,
            position: 'absolute',
            top: '0px',
            left: '0px',
            width: '1px',
            height: (srcContainerHeight + "px")
          }
        }),

        h('div', {
          ref: 'virtual-list-margin-area',
          style: {
            marginTop: '0px'
          }
        }),
        this.__createVLNode(h)
      ];

      if (this.fullList) {
        if (this.rowDragAndDrop && !this.isTAMS) {
          if (this.rowDragAndDrop.targetType === 'virtualList') {
            return this.createDraggable(h, props, child)
          }
        }
      }

      return h('ul', props, child)
    },
    createVLMoreBtn: function createVLMoreBtn (h) {
      var this$1 = this;

      var
        type = this.isVLOpen ? 'open' : 'close',
        text = this.isVLOpen ? void 0 : this.$table.i18n.label.allView;

      return h('span', {
        staticClass: ("virtual-list-more virtual-list-more-" + type),
        on: {
          click: function (evt) {
            if (this$1.isVLOpen) {
              this$1.$set(this$1.isVlShow, this$1.row.__index, false);

              this$1.$nextTick(function () {
                this$1.$refs.virtualScrollListContainer.addEventListener('scroll', this$1.__onVirtualListScroll);
              });
            } else {
              this$1.$set(this$1.isVlShow, this$1.row.__index, true);

              this$1.$refs.virtualScrollListContainer.removeEventListener('scroll', this$1.__onVirtualListScroll);

              this$1.from = 0;
              this$1.final = 0;
            }
          }
        }
      }, text)
    },
    createVLTextBox: function createVLTextBox (h, ref) {
      var value = ref.value;
      var style = ref.style;

      return h('span', {
        staticClass: 'text-box',
        style: style
      }, value)
    },
    createVLItem: function createVLItem (h, ref) {
      var this$1 = this;
      if ( ref === void 0 ) ref = { type: 'text' };
      var value = ref.value;
      var type = ref.type;
      var item = ref.item;

      var
        child = void 0,
        iconClass = void 0,
        style = void 0,
        text = value;

      if (this.iconTemplate && type !== 'more') {
        var templateResult = this.iconTemplate({
          value: value,
          item: item,
          row: this.row
        });

        if (_.isPlainObject(templateResult)) {
          iconClass = templateResult.icon;

          if (templateResult.style) {
            style = templateResult.style;
          }

          if (templateResult.text) {
            text = templateResult.text;
          }
        } else {
          iconClass = templateResult;
        }

        child = this.createVLTextBox(h, { value: text, style: style });
      } else if (!this.iconTemplate && type !== 'more') {
        if (this.$scopedSlots.virlSlot) {
          child = this.$scopedSlots.virlSlot({
            item: item,
            row: this.row,
            col: this.col
          });
        } else {
          child = this.createVLTextBox(h, { value: value });
        }
      } else {
        child = this.createVLMoreBtn(h);
      }

      var childList = [
        iconClass
          ? h('div', {
            staticClass: 'virtual-list-icon-template',
            'class': iconClass
          })
          : void 0,
        child
      ];

      return h('li', {
        'class': type === 'more' ? 'virtual-list-more-row' : '',
        staticClass: 'virtual-list-view-row',
        on: {
          mouseenter: function (evt) { return this$1.onMouseEnterCallback({ h: h, col: this$1.col, row: this$1.row, evt: evt, type: type, item: item, value: value, tooltip: this$1.tooltipInstance }); },
          mouseleave: function (evt) { return this$1.onMouseLeaveCallback({ col: this$1.col, tooltip: this$1.tooltipInstance }); },
          contextmenu: function (evt) {
            if (type !== 'more') {
              this$1.$emit('virtualListEmitter', item);
            }
          }
        }
      }, childList)
    },
    __onVirtualListScroll: function __onVirtualListScroll (evt) {
      this.initTooltip(this.tooltipInstance);

      var target = evt.target || evt.srcElement; // ie
      var scrollTop = target.scrollTop;

      if (!this.lastRepaintY || Math.abs(scrollTop - this.lastRepaintY)) {
        var first = Math.floor(scrollTop / this.rowHeight);

        first = first < 0 ? 0 : first;

        this.__renderVLNode(first);

        this.lastRepaintY = scrollTop;
      }

      evt.preventDefault && evt.preventDefault();
    },
    __createVLNode: function __createVLNode (h) {
      var this$1 = this;

      var child = this.computedVirtualListData.map(function (value) {
        var item = value;

        if (_.isPlainObject(value)) {
          value = this$1.__pickVLData(value);
        }

        return this$1.createVLItem(h, { value: value, item: item })
      });

      return child
    },
    __renderVLNode: function __renderVLNode (from) {
      var virtualListMarginArea = this.$refs['virtual-list-margin-area'];
      var finalItem = from + this.screenItemsLen;

      if (finalItem > this.totalRows) {
        finalItem = this.totalRows;
      }

      virtualListMarginArea.style.marginTop = (from * this.rowHeight) + "px";

      this.from = from;
      this.final = finalItem;
    },
    __pickVLData: function __pickVLData (value) {
      var
        data = value,
        dataKey = this.dataKey;

      if (dataKey.indexOf('.') > -1) {
        dataKey = dataKey.split('.');

        dataKey.forEach(function (idx, key) {
          data = data[key];
        });

        return data
      }

      return data[dataKey]
    },
    createDraggable: function createDraggable (h, props, child) {
      var this$1 = this;

      return h('draggable', Object.assign({}, props,
        {props: {
          tag: 'ul',
          value: this.listData,
          move: function (evt, a) {
            return false
          }
        },
        attrs: {
          class: 'virtual-scroll-list-container',
          animation: 200,
          disabled: this.__getDraggableDisabled,
          sort: false,
          dragoverBubble: false,
          handle: void 0,
          group: this.rowDragAndDrop
        },
        on: {
          change: function (evt) {},
          add: function (evt) {
            if (!_.has(this$1.rowDragAndDrop, 'parentType')) {
              // clone 대상이 treeView가 아닌 경우
              this$1.$emit('dragAndDropChange', {
                dragItem: evt.item.rowItem,
                cell: this$1.row[this$1.col.field],
                row: this$1.row,
                col: this$1.col
              });
            } else {
              // clone 대상이 treeView인 경우
              this$1.$emit('dragAndDropChange', {
                dragItem: evt.item.rowItem,
                row: this$1.row,
                cell: this$1.row[this$1.col.field],
                col: this$1.col
              });
            }
          },
          update: function (evt) { },
          stop: function (e, ui) { }
        }}), child)
    },
    getViewItemContainer: function getViewItemContainer (h) {
      var container = h('ul', this.getViewItemRow(h));

      if (this.rowDragAndDrop && !this.isTAMS) {
        if (this.rowDragAndDrop.targetType === 'virtualList') {
          container = this.createDraggable(h, void 0, this.getViewItemRow(h));
        }
      }

      return container
    },
    getVirtualListContainer: function getVirtualListContainer (h) {
      var child = [this.createVLContainer(h)];
      var props = {
        staticClass: 'virtual-list-container'
      };

      if (this.fullList) {
        props.staticClass = 'virtual-list-container-full';
      } else {
        if (!this.isVLOpen) {
          child.push(this.createVLMoreBtn(h));
        } else {
          return void 0
        }
      }

      return h('div', props, child)
    },
    getVirtualList: function getVirtualList (h) {
      var child = [this.getVirtualListContainer(h)];

      if (!this.fullList) {
        child.push(this.getViewItemContainer(h));
      }

      return child
    }
  },
  render: function render (h) {
    return h('div', {
      staticClass: 'virtual-cell-container',
      style: {
        textAlign: 'left' // 옵션으로 처리
      }
    }, this.getVirtualList(h))
  }
};

var RenderTooltip = {
  data: function data () {
    return {
      isTooltipLock: false,
      vlToolTipTimer: void 0
    }
  },
  computed: {
    tooltipInstance: function tooltipInstance () {
      if (this.$refs.tooltip) {
        return this.$refs.tooltip
      }

      if (this.props && this.props.refTooltip) {
        return this.props.refTooltip
      }

      return null
    }
  },
  destroyed: function destroyed () {
    this.__cleanTooltip();
  },
  methods: {
    createToolTip: function createToolTip (h, ref) {
      var col = ref.col;
      var row = ref.row;
      var value = ref.value;
      var item = ref.item;
      var target = ref.target;
      var textValue = ref.textValue;
      var customToolTip = ref.customToolTip;

      if (typeof col.tooltip === 'object' || customToolTip) {
        var props = _.has(col, 'tooltip')
          ? _.cloneDeep(col.tooltip.props)
          : { message: void 0 };

        if (_.has(props, 'message') || customToolTip) {
          if (typeof props.message === 'function' || customToolTip) {
            var opts = void 0;

            if (target === 'basic') {
              opts = {
                value: row[col.field],
                col: col,
                row: row
              };
            } else {
              opts = {
                value: value,
                item: item,
                col: col,
                row: row
              };
            }

            var callBackResult = typeof props.message === 'function'
              ? props.message(opts)
              : customToolTip(opts);

            if (callBackResult === void 0 || callBackResult === null) {
              return void 0
            }

            if (typeof callBackResult === 'object' && typeof callBackResult.then === 'function') {
              return callBackResult
            } else {
              if (callBackResult) {
                props.message = this.__parseToolTipMessage(h, { message: callBackResult, props: props, col: col, row: row });
              }
            }
          }
        }

        return {
          message: target === 'basic'
            ? textValue
            : void 0,
          props: props
        }
      } else {
        if (col.tooltip || col.tooltip === void 0) {
          return {
            message: target === 'basic'
              ? textValue
              : value
          }
        }
      }

      return void 0
    },
    __parseToolTipMessage: function __parseToolTipMessage (h, ref) {
      var message = ref.message;
      var props = ref.props;
      var col = ref.col;
      var row = ref.row;

      var
        child = [message],
        parseMessage = child[0],
        parseTitle = void 0,
        len = 0,
        data = void 0;

      if (_.isPlainObject(parseMessage)) {
        var
          body = parseMessage.body,
          title = parseMessage.title;

        parseMessage = body;
        parseTitle = title;
      }

      if (Array.isArray(parseMessage) || typeof parseMessage === 'object') {
        child = [];

        if (Array.isArray(parseMessage)) {
          len = parseMessage.length;
        } else if (typeof parseMessage === 'object') {
          len = Object.keys(parseMessage).length;
        }

        for (var i = 0; i < len; i++) {
          if (Array.isArray(parseMessage)) {
            data = parseMessage[i];
          } else if (typeof parseMessage === 'object') {
            data = parseMessage[Object.keys(parseMessage)[i]];
          }

          child.push(h('span', data));

          if (i !== len - 1) {
            child.push(h('br'));
          }
        }
      }

      if (props.title || parseTitle) {
        var title$1 = props.title;

        if (props.title) {
          title$1 = props.title;

          if (_.isFunction(props.title)) {
            title$1 = props.title({ col: col, row: row });
          }
        }

        if (parseTitle) {
          title$1 = parseTitle;
        }

        var
          titleComp = h('span', {
            staticClass: 's-tooltip-title'
          }, title$1),
          hrComp = h('hr');

        child = [titleComp, hrComp].concat(child);
      }

      return child
    },
    __isTooltip: function __isTooltip (evt, col) {
      return _.indexOf(evt.target.classList, 'group') === 1 ||
        col.type === 'checkbox' ||
        col.type === 'selectbox' ||
        col.type === 'button'
    },
    __cleanTooltip: function __cleanTooltip (tooltip) {
      clearTimeout(this.vlToolTipTimer);

      if (tooltip) {
        tooltip.__delayHide();
      } else {
        if (this.tooltipInstance) {
          this.tooltipInstance.__delayHide();
        }
      }

      this.isTooltipLock = true;
    }
  }
};

var ComponentEvents = {
  methods: {
    onMouseEnterHandler: function onMouseEnterHandler (ref) {
      var this$1 = this;
      var h = ref.h;
      var col = ref.col;
      var row = ref.row;
      var evt = ref.evt;
      var type = ref.type;
      var item = ref.item;
      var value = ref.value;
      var tooltip = ref.tooltip;

      if (this.__isTooltip(evt, col)) {
        return
      }

      if (row[col.field] === '' || row[col.field] === void 0 || row[col.field] === null) {
        return
      }

      this.isTooltipLock = false;

      clearTimeout(this.vlToolTipTimer);

      if (col.type !== 'virtual-list') {
        this.vlToolTipTimer = setTimeout(function () {
          this$1.__iconToggle('mouseover', col);

          var props = this$1.createToolTip(h, {
            col: col,
            row: row,
            target: 'basic',
            textValue: evt.target.innerText
          });

          if (props === void 0) {
            return
          }

          if (typeof props === 'object' && typeof props.then === 'function') {
            props.then(function (res) {
              props.message = this$1.__parseToolTipMessage(h, {
                message: res, props: props, col: col, row: row
              });

              if (this$1.tooltipInstance && !this$1.isTooltipLock) {
                this$1.tooltipInstance.__delayShow(Object.assign({}, {target: evt.target.childNodes[0]},
                  props));
              }
            });
          } else {
            if (this$1.tooltipInstance) {
              this$1.tooltipInstance.__delayShow(Object.assign({}, {target: evt.target.childNodes[0]},
                props));
            }
          }
        }, 500);
      } else {
        if (type === 'more' || !tooltip) {
          return
        }

        this.vlToolTipTimer = setTimeout(function () {
          var props = this$1.createToolTip(h, {
            target: 'virtual-list',
            item: item,
            col: col,
            row: row,
            value: value
          });

          if (props === void 0) {
            return
          }

          if (typeof props === 'object' && typeof props.then === 'function') {
            props.then(function (res) {
              props.message = this$1.__parseToolTipMessage(h, {
                message: res,
                props: props,
                row: row,
                col: col
              });

              if (!this$1.isTooltipLock) {
                tooltip.__delayShow(Object.assign({}, {target: evt.target},
                  props));
              }
            });
          } else {
            tooltip.__delayShow(Object.assign({}, {target: evt.target},
              props));
          }
        }, 500);
      }
    },
    onMouseLeaveHandler: function onMouseLeaveHandler (ref) {
      var col = ref.col;
      var tooltip = ref.tooltip;

      this.__cleanTooltip(tooltip);

      if (col.type !== 'virtual-list') {
        this.__iconToggle('mouseout', col);
      }
    },
    onContextMenuHandler: function onContextMenuHandler (ref) {
      var col = ref.col;
      var row = ref.row;

      this.contextRowItem = void 0;
      this.contextCellList = [];

      if (col.type === 'virtual-list') {
        if (!this.isVirtualListContext) {
          this.contextCell = [];
        }
        this.isVirtualListContext = false;
        this.contextCellList = row[col.field];
      } else {
        this.contextCell = row[col.field];
      }

      this.contextTarget = row;
      this.contextCol = col;

      // context-menu 다중 선택 지원
      var self = this;

      if (!self.selected) {
        self = this.$parent.$parent.$parent;
      }

      if (self.isNoSelected) {
        if (self.isNoSelected(row)) {
          return
        }
      }

      if (self.isMultiContext && self.isSelectedContext(row)) {
        if (self.selected.length > 1) {
          self.contextRow = self.selected;
        } else {
          self.contextRow = self.selected[0];
        }
      } else {
        self.contextRow = row;
        // (2023-03-15, wj_tams_dev01: V2 테이블 버그 수정)
        // single 모드에서 마우스 오른 클릭 시, selection이 해제(정확히는 array로 넘어오던 현상)되는 버그 수정함.
        // 설계 의도와 달리, single 모드에서 무조건 array로 selection 정보가 넘어오기에 실제 동작 상으로는 selection이 해제되는 버그가 있었음.
        // self.$emit('update:selected', [row]);
      }
    }
  }
};

/**
 * render-component
 *
 * @since 2019-07-05
 * @author kdydesign.kim
 */

var RenderComponent = {
  mixins: [
    RenderTooltip,
    ComponentEvents
  ],
  data: function data () {
    return {
      iconToggle: false
    }
  },
  computed: {
    computedDropDownList: function computedDropDownList () {
      return this.componentProps.options
        ? this.componentProps.options
        : []
    }
  },
  methods: {
	  __formatProps: function __formatProps (h, child) {
		  var isTagsProps = child.hasOwnProperty('tags');
		  var isStyleProps = child.hasOwnProperty('style');
		  var rChild = [];

		  // tag 옵션
		  if (isTagsProps) {
			  var arrValue = Array.from(child.tags);

			  _.forEach(arrValue, function (aValue, i) {
				  var renderTag = aValue.tags.tag;
				  var tagProps = aValue.tags;
          var comp = aValue.value;

          if (isStyleProps) {
            var isIcon = child.style.hasOwnProperty('icon');

            if (isIcon) {
              comp = [
                h(Icon, { 'class': child.style.icon }),
                aValue.value
              ];
            }
          }

				  rChild.push(h(renderTag, tagProps, comp));

          if (_.has(tagProps, 'join') && arrValue.length - 1 > i) {
            rChild.push(h(renderTag, ','));
          }
			  });
		  } else {
			  // style 옵션
			  if (isStyleProps) {
				  var isIcon = child.style.hasOwnProperty('icon');
				  var value = child.value;

				  if (isIcon) {
					  rChild = [
						  h(Icon, { 'class': child.style.icon }),
						  value
					  ];
				  } else {
					  rChild = value;
				  }

				  return { child: rChild, style: child.style }
			  }
		  }

		  return { child: rChild, style: child.style }
	  },
	  createTextBox: function createTextBox (h, ref, componentType) {
		  var this$1 = this;
		  var col = ref.col;
		  var row = ref.row;
		  var compClass = ref.compClass;

		  var child = [this.getCellValue(col, row)];

      if (this.__isIconProps({ col: col })) {
        var isMultiIcon = false;
        var iconComponent = null;

        var iconProps = col.props.icon;
        var iconSlot = iconProps.slot || 'before';
        var isInnerValue = iconProps.innerValue;

        if (iconProps.format) {
          var customClass = iconProps.format({ value: row[col.field], col: col, row: row });

          if (Array.isArray(customClass)) {
            isMultiIcon = true;

            customClass.forEach(function (icon) {
              var iconComponent = this$1.createIcon(h, {
                col: col,
                row: row,
                childValue: isInnerValue ? icon.text : '',
                customClass: icon.class
              });

              if (iconSlot === 'before') {
                child.unshift(iconComponent);
              }

              if (iconSlot === 'after') {
                child.push(iconComponent);
              }
            });
          } else {
            // 동적 스타일이고, 아이콘이 하나만 필요한 경우
            isMultiIcon = false;
            iconComponent = this.createIcon(h, {
              col: col,
              row: row,
              childValue: isInnerValue ? customClass.text : '',
              customClass: customClass.class
            });
          }
        } else {
          // 정적 스타일을 필요하는 컬럼인 경우
          isMultiIcon = false;
          iconComponent = this.createIcon(h, { col: col, row: row });
        }

        if (!isMultiIcon) {
          if (iconSlot === 'before') {
            child.unshift(iconComponent);
          }

          if (iconSlot === 'after') {
            child.push(iconComponent);
          }
        }
      }

      if (this.grouping.use && row[this.grouping.isGroupKey]) {
        if (typeof this.grouping.label === 'function') {
          child = [this.grouping.label({ row: row })];
        } else {
          var
            enabledTxt = this.$table.i18n.label.enabled,
            disabledTxt = this.$table.i18n.label.disabled;

          var
            groupId = row[this.grouping.key],
            enable = this.data.filter(function (o) { return o.use === 1 && o[this$1.grouping.key] === groupId; }).length,
            disable = this.data.filter(function (o) { return o.use === 0 && o[this$1.grouping.key] === groupId; }).length;

          var groupText = (row.name) + " (" + enabledTxt + ": " + enable + ", " + disabledTxt + ": " + disable + ")";

          child = [groupText];
        }
      }

      if (col.props.url) {
        child = this.createLinkBox(h, { col: col, row: row });
      }

		  var style = void 0;

		  // format에 옵션이 지정된 경우
		  if (child[0] && (_.isPlainObject(child[0]) || _.isArray(child[0]))) {
			  var formatProps = this.__formatProps(h, child[0]);

			  child[0] = formatProps.child;
			  style = formatProps.style;
		  }

      if (this.rowDragAndDrop) {
        if (this.rowDragAndDrop.handler) {
          child.unshift(h(Icon, {
            ref: 'dragHandle',
            'class': 'icon-object-type s-drag-handler',
            style: {
              fontSize: '20px'
            },
            props: {
              name: 'drag_handle'
            }
          }));
        }
      }

      var multiLineClass = void 0;

      if (componentType === 'multi-line') {
        var virtualListField = _.filter(this.columns, { type: 'virtual-list' });
        var rowData = row[virtualListField[0].field];
        var max = 0;

        if (rowData) {
          max = rowData.length;
        }

        for (var i = 1; i < virtualListField.length; i++) {
          var len = 0;
          var colName = virtualListField[i].field;

          if (_.has(row, colName) && _.isArray(row[colName])) {
            len = row[colName].length;
          } else {
            if (_.has(virtualListField[i].props, 'parseData')) {
              len = virtualListField[i].props.parseData({
                value: row[colName],
                row: row
              }).length || 0;
            }
          }

          max = Math.max(max, len);
        }

        var multiLineClamp = 1;

        if (max >= 5) {
          multiLineClamp = 6;
        } else {
          multiLineClamp = max;
        }

        multiLineClass = "cell-multi-line multi-line-clamp-" + multiLineClamp;
      }

      return h('span', {
        staticClass: this.grouping.use ? 'row no-wrap items-center' : '',
        'class': ['text-box', multiLineClass, compClass],
        style: style
      }, child)
    },
    createLinkBox: function createLinkBox (h, ref) {
      var col = ref.col;
      var row = ref.row;

      var child = [];

      var url = col.props.url;

      var linkProp = {
        domProps: {
          href: url,
          target: col.props.target || '_blank'
        }
      };

      if (typeof col.props.url === 'function') {
        url = 'javascript:void(0)';

        linkProp = _.assign(linkProp, {
          domProps: {
            href: url
          },
          on: {
            click: function () {
              var getUrl = col.props.url({ col: col, row: row });

              if (getUrl) {
                window.open(getUrl, col.props.target || '_blank');
                return false
              }
            }
          }
        });
      }

      child = [
        h('a', linkProp, this.getCellValue(col, row))
      ];

      return child
    },
    createCheckBox: function createCheckBox (h, ref) {
      var this$1 = this;
      var col = ref.col;
      var row = ref.row;

      var
        field = col.field,
        value = row[field];

      var props = Object.assign({}, col.props);

      if (typeof props.haForce === 'function') {
        props.haForce = props.haForce({ row: row });
      }

      props = Object.assign(props, {
        disable: this.__isDisabled(col.props, row)
      });

      var component = h(CheckBox, {
        'class': props.class,
        attrs: {
          disabled: this.__isDisabled(col.props, row)
        },
        props: Object.assign({}, {value: value,
          col: col},
          props),
        nativeOn: {
          dblclick: function (evt) {
            evt.stopPropagation();
            evt.preventDefault();
          }
        },
        on: {
          'update:value': function (value) { return this$1.$set(row, col.name, value); },
          input: function (value) {
            if (col.hasOwnProperty('input')) {
              col.input({ value: value, row: row });
            }
          },
          change: function (value) {
            if (col.hasOwnProperty('change')) {
              col.change({ value: value, row: row });
            }
          }
        }
      });

      return this.renderer(component, { col: col, row: row })
    },
    createSelectBox: function createSelectBox (h, ref) {
      var this$1 = this;
      var col = ref.col;
      var row = ref.row;

      var props = Object.assign({}, col.props);
      var disable = this.__isDisabled(props, row);

      props = Object.assign(props, { disable: disable });

      var component = h(SelectBox, {
        attrs: {
          disabled: disable
        },
        props: Object.assign({}, {value: this.getCellValue(col, row),
          row: row},
          props),
        on: {
          'update:value': function (value) { return this$1.$set(row, col.name, value); },
          input: function (value) {
            if (col.hasOwnProperty('input')) {
              col.input({ value: value, row: row });
            }
          },
          focus: function (value) {
            if (col.hasOwnProperty('focus')) {
              col.focus(value);
            }
          },
          change: function (value) {
            if (col.hasOwnProperty('change')) {
              col.change({ value: value, row: row });
            }
          }
        }
      });

      return this.renderer(component, { col: col, row: row })
    },
    createButtonField: function createButtonField (h, ref) {
      var this$1 = this;
      var col = ref.col;
      var row = ref.row;

      var child = [];
      var multiComp = _.get(col, ['multiComp'], [{ type: 'text' }]);

      if (!_.isArray(multiComp)) {
        multiComp = [{ type: 'text' }];
      }

      multiComp.forEach(function (comp) {
        if (comp.type === 'button') {
          var btnCol = _.assign(Object.assign({}, col), Object.assign({}, comp));
          var btnComp = this$1.createButton(h, void 0, 0, 'body', { col: btnCol, row: row });

          child.push(btnComp);
        }

        if (comp.type === 'text') {
          var strValue = this$1.getCellValue(col, row);
          var opt = {
            style: comp.style || 'margin-left: 5px'
          };

          child.push(h('span', opt, strValue));
        }
      });

      return h('span', {
        staticClass: 'button-field',
        'class': 'row no-wrap items-center text-box'
      }, child)
    },
    createButton: function createButton (h, prop, index, renderType, ref) {
      var this$1 = this;
      if ( ref === void 0 ) ref = {};
      var col = ref.col;
      var row = ref.row;

      var props = renderType === 'header' ? void 0 : Object.assign({}, col.props);
      var popOverComp = [];
      var buttonSlotComp = void 0;

      if (renderType === 'header') {
        props = Object.assign({}, prop.props);

        if (_.has(this.scopeSlot, ("button-" + (col.field)))) {
          // header button slot template
          buttonSlotComp = this.scopeSlot[("button-" + (col.field))]({ col: col, prop: prop });
        }
      } else {
        if (Array.isArray(col.props) || renderType === 'group') {
          props = Object.assign({}, prop);
        }
      }

      if (_.has(props, 'label')) {
        if (typeof props.label === 'function') {
          props.label = props.label({ row: row, col: col, value: row[col.field] });
        }
      }

      /**
       * Button의 Style의 값이 props에 반영되어 들어올 경우 Style 값을 우선하여 반영
       */
      var styleObj = {};

      if (_.has(props, 'style')) {
        var stylesArr = props.style.split(/;/g);

        _.forEach(stylesArr, function (styleStr) {
          var keyValArr = styleStr.split(':');

          if (keyValArr.length === 2) {
            styleObj[keyValArr[0]] = keyValArr[1];
          }
        });
      }

      if (!styleObj['margin-left']) {
        styleObj['margin-left'] = index > 0 ? '5px' : '0px';
      }

      if (buttonSlotComp) {
        popOverComp.push(h(PopOver, {
          'class': 's-popover-filter'
        }, [buttonSlotComp]));
      }

      var nativeOn = renderType === 'header' ? {} : {
        click: function (evt) { return stopAndPrevent(evt); }
      };

      var component = h(Button, {
        attrs: {
          disabled: this.__isDisabled(props, row)
        },
        'class': [
          { 's-header-group-btn': renderType === 'header' },
          props.class
        ],
        style: Object.assign({}, styleObj),
        props: props,
        nativeOn: {
          click: evt => stopAndPrevent(evt)
        },
        on: {
          click: function (evt) {
            if (renderType !== 'header') {
              stopAndPrevent(evt);
            }

            if (renderType === 'group') {
              this$1.__groupMoreEvt({ evt: evt, row: row });
            } else if (renderType === 'header') {
              if (_.has(prop, 'click')) {
                prop.click({ evt: evt, col: col });
              }
            } else if (Array.isArray(col.props)) {
              col.props[index].click({ evt: evt, row: row });
            } else {
              col.click({ evt: evt, row: row });
            }
          }
        }
      }, popOverComp);

      return this.renderer(component, { row: row, col: col })
    },
    createInput: function createInput (h, ref) {
      var this$1 = this;
      var col = ref.col;
      var row = ref.row;

      var validateFieldName = (col.field) + "_" + (row.__index);
      var inputProp = Object.assign({}, col.props);
      var scopeAttrs = void 0;
      var disable = this.__isDisabled(inputProp, row);
      var validateDirective = [];

      inputProp = Object.assign(inputProp, { disable: disable });

      if (inputProp.hasOwnProperty('validate')) {
        if (inputProp.validate) {
          this.$validator = this.validator || this.$validator;
        }

        var error = this.__getValidateError(inputProp.validate, validateFieldName);

        inputProp = Object.assign(inputProp, { error: error });

        validateDirective = [
          {
            name: 'validate',
            value: inputProp.validate
              ? inputProp.validate.rules
              : false
          }
        ];
      }

      var component = h(InputBox, {
        attrs: Object.assign({}, {name: validateFieldName,
          disabled: disable},
          scopeAttrs),
        props: Object.assign({}, {value: this.getCellValue(col, row)},
          inputProp),
        directives: validateDirective,
        on: {
          'update:value': function (value) { return this$1.$set(row, col.name, value); },
          input: function (value) {
            if (col.hasOwnProperty('input')) {
              col.input({ value: value, row: row });
            }
          },
          change: function (value) {
            if (col.hasOwnProperty('change')) {
              col.change({ value: value, row: row });
            }
          }
        }
      });

      return this.renderer(component, { col: col, row: row })
    },
    createIcon: function createIcon (h, ref) {
      var col = ref.col;
      var row = ref.row;
      var childValue = ref.childValue; if ( childValue === void 0 ) childValue = '';
      var customClass = ref.customClass; if ( customClass === void 0 ) customClass = '';

      if (this.__isCreateIcon({ col: col })) {
        var iconProps = col.props.icon || null;

        var customStyle = iconProps.style || null;
        var defaultClass = iconProps.class || '';

        var
          toggleProps = {},
          defaultProps = {
            class: (defaultClass + " " + customClass),
            props: Object.assign({}, {childValue: childValue,
              customStyle: customStyle},
              iconProps)
          };

        if (iconProps.toggle) {
          toggleProps = {
            style: {
              display: this.iconToggle ? '' : 'none'
            },
            nativeOn: {
              click: function (evt) {
                stopAndPrevent(evt);

                iconProps.click({
                  evt: evt,
                  value: row[col.field],
                  row: row,
                  col: col
                });
              }
            }
          };
        }

        if (_.isArray(iconProps)) {
          var el = [];

          for (var i = 0; i < iconProps.length; i++) {
            var icon = iconProps[i];

            customStyle = icon.style || null;
            defaultClass = icon.class || '';

            defaultProps = {
              class: (defaultClass + " " + customStyle),
              props: Object.assign({}, {childValue: childValue,
                customStyle: customStyle},
                icon)
            };

            el.push(h(Icon, Object.assign(defaultProps, toggleProps)));
          }

          return el
        }

        return h(Icon, Object.assign(defaultProps, toggleProps))
      }

      return h(Icon)
    },
    createButtonDropDown: function createButtonDropDown (h, prop, renderType, ref) {
      var this$1 = this;
      if ( ref === void 0 ) ref = {};
      var col = ref.col;
      var row = ref.row;

      var
        props = void 0,
        dropDownOpts = [],
        disable = false;

      if (renderType === 'header') {
        props = Object.assign({}, prop.props);
        dropDownOpts = props.options;

        if (_.has(props, 'disable')) {
          if (_.isFunction(props.disable)) {
            disable = props.disable({ row: row });
          } else {
            disable = props.disable;
          }
        }
      } else {
        props = this.componentProps;
        dropDownOpts = this.computedDropDownList;
      }

      var nativeOn = renderType === 'header' ? {} : {
        click: function (evt) { return stopAndPrevent(evt); }
      };

      var component = h(ButtonDropDown, {
        props: {
          authForce: props.authForce,
          haForce: props.haForce,
          disable: disable,
          size: 'md',
          color: 'dark',
          flat: 'flat',
          label: this.$slots.default[0].text
        },
        style: {
          fontSize: '13px !important'
        },
        nativeOn: nativeOn
      }, [
        h(List, {
            props: {
              link: true
            }
          },
          dropDownOpts.map(function (item) {
            return h(Item, {
              directives: [
                {
                  name: 'table-close-overlay',
                  value: true
                }
              ],
              nativeOn: {
                click: function (evt) {
                  prop.hasOwnProperty('click')
                    ? prop.click({
                      value: item.value,
                      evt: evt,
                      col: this$1.props.col || this$1.props.colsMap[this$1.$vnode.key]
                    })
                    : void 0;
                }
              }
            }, [
              h(ItemMain, {
                props: {
                  label: item.label
                }
              })
            ])
          }))
      ]);

      return this.renderer(component, { col: col, row: row })
    },
    createGroupRow: function createGroupRow (h, ref) {
      var this$1 = this;
      var col = ref.col;
      var row = ref.row;

      var groupBtnProps = {
        size: 'xs',
        color: 'grey-15',
        dense: true,
        outline: 'outline',
        icon: 'more_horiz',
        round: true,
        customClass: 'more-group',
        iconCustomClass: 'more-group-icon'
      };

      return h('div', {
        'class': 'relative-position row no-wrap items-center'
      }, [
        h('div', {
          'class': 'group-arrow-parent'
        }, [
          h('div', {
            staticClass: 'group-arrow-child',
            'class': { 'group-expand': row.__expand },
            on: {
              click: function (evt) {
                if (evt !== void 0) {
                  evt.stopPropagation();
                }

                row.__expand = !row.__expand;
                // this.__setGroupExpanded(row)

                this$1.$emit('groupExpand', {
                  groupLen: this$1.data.filter(function (o) { return (o.__expand || o.__expand === void 0) || o[this$1.grouping.isGroupKey]; }).length,
                  groupId: row[this$1.grouping.key],
                  isOpen: row.__expand
                });
              }
            }
          }, [
            h(Icon, {
              staticClass: 'transition-generic',
              'class': { 'group-arrow-rotate': row.__expand },
              props: {
                name: 'play_arrow'
              }
            })
          ])
        ]),
        this.createTextBox(h, { col: col, row: row }),
        this.grouping.button && !this.isTAMS(row)
          ? this.createButton(h, groupBtnProps, 0, 'group', { col: col, row: row })
          : void 0
      ])
    },
    createTreeIcon: function createTreeIcon (h, ref) {
      var this$1 = this;
      var col = ref.col;
      var row = ref.row;

      var level = row.__level;

      var iconChild = [
        h(Icon, {
          staticClass: 'transition-generic',
          'class': [{ 'group-arrow-rotate': !row.__tree_expand_icon }, 'q-tree__node-collapsible'],
          props: {
            name: 'play_arrow'
          }
        })
      ];

      if (!row.hasOwnProperty('children')) {
        iconChild = [];
      }

      return h('div', {
        staticClass: 'tree-group',
        style: {
          marginLeft: ((parseInt(level) * 15) + "px")
        },
        on: {
          click: function (evt) { return this$1.treeExpand(row); }
        }
      }, iconChild)
    },
    createVirtualList: function createVirtualList (h, ref) {
      var this$1 = this;
      var col = ref.col;
      var row = ref.row;

      var listData = row[col.field];

      if (Array.isArray(listData)) {
        if (listData.length === 0 && _.has(col.props, 'defaultData')) {
          if (Object.keys(col.props.defaultData).length > 0) {
            listData.push(col.props.defaultData);
          }
        }
      }

      if (typeof col.props.parseData === 'function') {
        var parseValue = [];
        var parseData = col.props.parseData({ value: listData, row: row });

        if (_.isPlainObject(parseData)) {
          parseValue.push(col.props.parseData({ value: listData, row: row }));
        } else {
          parseValue = col.props.parseData({ value: listData, row: row });
        }

        listData = parseValue;
      }

      return h(VirtualList, {
        props: Object.assign({}, {refTooltip: this.$refs.tooltip,
          cleanTooltip: this.__cleanTooltip,
          onMouseEnterHandler: this.onMouseEnterHandler,
          onMouseLeaveHandler: this.onMouseLeaveHandler,
          rowDragAndDrop: this.rowDragAndDrop,
          isTAMS: this.isTAMS(row),
          col: col,
          row: row,
          listData: listData},
          col.props),
        on: {
          virtualListEmitter: function (value) {
            this$1.isVirtualListContext = true;
            this$1.contextCell = value;
          },
          dragAndDropChange: function (value) { return this$1.$emit('dragAndDropChange', value); }
        }
      })
    },
    __isCreateIcon: function __isCreateIcon (ref) {
      var col = ref.col;

      return col.type === 'textbox' &&
        this.__isIconProps({ col: col })
    },
    __isIconProps: function __isIconProps (ref) {
      var col = ref.col;

      return col.hasOwnProperty('props') &&
        col.props.hasOwnProperty('icon')
    },
    __isIconToggle: function __isIconToggle (ref) {
      var col = ref.col;

      return this.__isIconProps({ col: col }) &&
        col.props.icon.toggle
    },
    __iconToggle: function __iconToggle (eventType, col) {
      if (this.__isIconToggle({ col: col })) {
        if (eventType === 'mouseover') {
          this.iconToggle = true;
        } else {
          this.iconToggle = false;
        }
      }
    },
    __getValidateError: function __getValidateError ($validate, validateFieldName) {
      if (!$validate) {
        return false
      } else if ($validate.scope) {
        return this.errors.has((($validate.scope) + "." + validateFieldName))
      }

      return this.errors.has(validateFieldName)
    },
    __compVisibled: function __compVisibled (props, ref) {
      var row = ref.row;
      var col = ref.col;

      if (_.has(props, 'compVisibled')) {
        var isVisible = false;

        if (typeof props.compVisibled === 'function') {
          isVisible = props.compVisibled({ row: row, col: col, value: row[col.field] });
        }

        if (isVisible) {
          return false
        }

        return true
      }

      return true
    },
    __isDisabled: function __isDisabled (props, row) {
      if (props.authForce || props.haForce) {
        if (props.disabled) {
          if (typeof props.disabled === 'function') {
            return props.disabled({ row: row })
          } else {
            return props.disabled
          }
        }

        if (props.authForce) {
          return !props.authForce
        }

        if (props.haForce) {
          return !props.haForce
        }
      } else {
        var disable = false;

        if (typeof this.rowDisable === 'function') {
          // row disable 우선 순위가 높음
          if (this.rowDisable(row)) {
            return true
          }
        }

        if (typeof props.disabled === 'function') {
          disable = props.disabled({ row: row });
        } else {
          disable = props.disabled;
        }

        return disable
      }

      return false
    },
    renderer: function renderer (comp, ref) {
      var col = ref.col;
      var row = ref.row;

      if (!this.__compVisibled(comp.data.props, { row: row, col: col })) {
        return []
      }

      return comp
    }
  }
};

/**
 * is
 *
 * @param v
 * @returns {boolean}
 *
 * Quasar 0.17.18
 */

function isDate (v) {
  return Object.prototype.toString.call(v) === '[object Date]'
}

function isNumber (v) {
  return typeof v === 'number' && isFinite(v)
}

function isString (v) {
  return typeof v === 'string'
}

/**
 * <th> Renderer
 *
 * @since 2019-06-18
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

var TableTh = {
  name: 'table-th',
  mixins: [RenderComponent],
  props: {
    props: Object,
    autoWidth: Boolean,
    headerType: [String, Array],
    componentProps: [Object, Array],
    globalSortable: Boolean,
    scopeSlot: Object
  },
  render: function render (h) {
    var this$1 = this;

    if (!this.props) {
      return h('th', {
        'class': { 's-table-col-auto-width': this.autoWidth }
      }, this.$slots.default)
    }

    var
      col,
      child = [];
    var
      name = this.$vnode.key;

    if (this.headerType) {
      var btnTextBox = this.headerType.length > 1
        ? void 0
        : h('div', [this.$slots.default]);

      if (isString(this.headerType)) {
        switch (this.headerType.toLowerCase()) {
          case 'dropdown':
            child.push(this.createButtonDropDown(h, this.componentProps, 'header'));
            break
          case 'button' :
            child.push(this.createButton(h, this.componentProps, 0, 'header', { col: this.props.col }));
            child.push(btnTextBox);
        }
      }

      if (Array.isArray(this.headerType)) {
        this.headerType.forEach(function (header) {
          switch (header.type.toLowerCase()) {
            case 'dropdown':
              child.push(this$1.createButtonDropDown(h, header, 'header', { col: this$1.props.col }));
              break
            case 'button' :
              child.push(this$1.createButton(h, header, 0, 'header', { col: this$1.props.col }, this$1.headerComponent));
              child.push(btnTextBox);
          }
        });
      }
    } else {
      child = [].concat(this.$slots.default);
    }

    if (name) {
      col = this.props.colsMap[name];
      if (!col) { return }
    } else {
      col = this.props.col;
    }

    var thClass, event, customClass = void 0;

    if (col) {
      thClass = col.__thClass;
      customClass = _.has(col, 'customClass') ? col.customClass : '';

      if (col.sortable && this.globalSortable) {
        var action = col.align === 'right'
          ? 'unshift'
          : 'push';

        child[action](
          h(Icon, {
            props: { name: this.$table.icon.table.arrowUp },
            staticClass: col.__iconClass
          })
        );

        event = {
          click: function () {
            this$1.props.sort(col);
          }
        };
      }
    }

    return h('th', {
      'class': [thClass, customClass],
      on: event
    }, [
      h('div', [
        child
      ])
    ])
  }
};

/**
 * <tr> Renderer
 *
 * @since 2019-06-18
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */
var TableTr = {
  name: 'table-tr',
  props: {
    props: Object
  },
  data: function data () {
    return {
      selected: false
    }
  },
  destroyed: function destroyed () {
    this.$el.remove();
  },
  render: function render (h) {
    var this$1 = this;

    var isGroupRow = false;
    var props = {
      on: {
        click: function (evt) { return this$1.$emit('click', evt); },
        dblclick: function (evt) { return this$1.$emit('dblclick', evt); }
      }
    };

    if (!this.props || this.props.header) {
      Object.assign(props, {});
    } else {
      props = {
        on: {
          click: function (evt) {
            if (isGroupRow || this$1.props.noSelected) {
              return
            }

            if (this$1.props.isSelection) {
              this$1.props.updateSelection([this$1.props.key], [this$1.props.row], evt);

              this$1.$emit('onRowClick', { row: this$1.props.row, evt: evt });
            }
          },
          dblclick: function (evt) {
            if (isGroupRow || this$1.props.isTAMS || this$1.props.noSelected) {
              return
            }

            this$1.$emit('onRowDblClick', { row: this$1.props.row, evt: evt });
          }
        }
      };

      var keys = this.props.key;

      if (this.props.grouping.use && this.$slots.default.length === 1) {
        isGroupRow = true;
        keys = "group_" + (this.props.row[this.props.grouping.key]);
      }

      Object.assign(props, {
        key: keys,
        attrs: {
          index: this.props.row.__index,
          group: isGroupRow,
          tams: this.props.isTAMS
        },
        domProps: {
          rowItem: this.props.row
        },
        'class': { 'selected': this.props.__trClass, 'group-row': isGroupRow }
      });
    }

    return h('tr', props, this.$slots.default)
  }
};

/**
 * table header
 *
 * @since 2019-07-02
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */
var TableHeader = {
  name: 'table-header',
  props: {
    headerVisible: Boolean,
    child: Array,
    cols: Array,
    height: String
  },
  render: function render (h) {
    return h('div', {
      'class': [
        's-table-header',
        's-table-header-scroll'
      ],
      style: {
        display: this.headerVisible ? '' : 'none'
      }
    }, [
      h('div', {
        staticClass: 's-table-handler'
      }, this.$slots.default),
      h('table', [
        h('colgroup', this.cols),
        h('tbody', this.child)
      ])
    ])
  }
};

/**
 * table header mixins
 *
 * @since 2019-07-02
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

var TableHeaderMixin = {
  props: {
    headerHeight: {
      type: [Number, String],
      default: 26
    },
    headerVisible: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    getHeaderHeight: function getHeaderHeight () {
      if (this.$children.length > 0) {
        var childIndex = this.windowResize ? 1 : 0;
        var header = this.$children[childIndex].$el;

        return header.offsetHeight
      }

      return this.headerHeight
    }
  },
  methods: {
    getTableHeader: function getTableHeader (h) {
      var child = [this.getTableHeaderRow(h)];

      return h(TableHeader, {
        props: {
          headerVisible: this.headerVisible,
          child: child,
          cols: this.getCols(h)
        }
      }, this.getResizeHandler(h))
    },
    getTableHeaderRow: function getTableHeaderRow (h) {
      var this$1 = this;

      var header = this.$scopedSlots.header;

      if (header) {
        return header({
          header: true,
          cols: this.computedCols,
          sort: this.sort,
          colsMap: this.computedColsMap
        })
      }

      var child = this.computedCols.map(function (col) {
        return h(TableTh, {
          key: col.name,
          props: {
            props: {
              col: col,
              cols: this$1.computedCols,
              sort: this$1.sort,
              colsMap: this$1.computedColsMap
            },
            headerType: col.headerType,
            componentProps: col.props,
            globalSortable: this$1.sortable,
            scopeSlot: this$1.$scopedSlots
          },
          style: col.style,
          'class': col.classes
        }, col.label)
      });

      return h(TableTr, child)
    }
  }
};

/**
 * Cell <td> Renderer
 *
 * @since: 2019-09-09
 * @author: kdydesign.kim
 */
var TdRenderer = {
  data: function data () {
    return {
      vlToolTipTimer: void 0,
      isTooltipLock: false
    }
  },
  computed: {
    isMultiContext: function isMultiContext () {
      return this.contextMenu && this.contextMenu.multiple
    }
  },
  methods: {
    isSelectedContext: function isSelectedContext (row) {
      return _.some(this.selected, row)
    },
    __isCellSelection: function __isCellSelection (col) {
      return this.isCellSelection && col.cellSelection
    },
    __isGroup: function __isGroup (row) {
      return this.grouping.use && row[this.grouping.isGroupKey]
    },
    __componentRender: function __componentRender (h, ref) {
      var this$1 = this;
      var col = ref.col;
      var row = ref.row;
      var treeView = ref.treeView;

      var componentType = col.type.toLowerCase();

      if (this.__isGroup(row)) {
        return this.createGroupRow(h, { col: col, row: row })
      }

      var
        value = row[col.field],
        isVisibled = typeof col.props.visibled === 'function'
          ? col.props.visibled({ value: value, row: row })
          : col.props.visibled;

      if (!isVisibled) {
        return void 0
      }

      var child = [];

      if (treeView) {
        child.push(this.createTreeIcon(h, { col: col, row: row }));
      }

      if (componentType === 'textbox' || componentType === 'multi-line') {
        child.push(this.createTextBox(h, { col: col, row: row }, componentType));

        if (this.__isIconToggle({ col: col })) {
          child.push(this.createIcon(h, { col: col, row: row }));
        }

        return child
      }

      if (componentType === 'checkbox') {
        return this.createCheckBox(h, { col: col, row: row })
      }

      if (componentType === 'selectbox') {
        return this.createSelectBox(h, { col: col, row: row })
      }

      if (componentType === 'button') {
        if (this.treeView.use) {
          child.push(this.createTextBox(h, { col: col, row: row, compClass: 'tree-view-text-box' }, componentType));
        }

        if (Array.isArray(col.props)) {
          col.props.forEach(function (prop, i) {
            child.push(this$1.createButton(h, prop, i, 'body', { col: col, row: row }));
          });
        } else {
          child.push(this.createButton(h, void 0, 0, 'body', { col: col, row: row }));
        }

        return child
      }

      if (componentType === 'button-field') {
        return this.createButtonField(h, { col: col, row: row })
      }

      if (componentType === 'input') {
        return this.createInput(h, { col: col, row: row })
      }

      if (componentType === 'virtual-list') {
        return this.createVirtualList(h, { col: col, row: row })
      }

      // default component
      return [this.createTextBox(h, { col: col, row: row }, componentType)]
    },
    cellRenderer: function cellRenderer (h, cellSelected, ref) {
      var this$1 = this;
      var col = ref.col;
      var row = ref.row;
      var treeView = ref.treeView;

      if (!this.props) {
        var component = this.__componentRender(h, { col: col, row: row, treeView: treeView });

        var
          child = [],
          fieldClass = void 0,
          rowDisable = false,
          colStyle = col.style;

        if (Array.isArray(component)) {
          child = component;
        } else {
          child.push(component);
        }

        // column.props.rowDisable과 body의 rowDisable은 같이 사용 못함
        if (this.rowDisabledField === void 0) {
          if (this.rowDisable) {
            rowDisable = this.rowDisable(row);
          }
        } else {
          rowDisable = !row[this.rowDisabledField];
        }

        // cell style
        if (this.cellStyle && this.cellStyle.data.length > 0) {
          var arrData = [];

          if (Array.isArray(this.cellStyle.data)) {
            arrData = this.cellStyle.data;
          } else {
            arrData = [this.cellStyle.data];
          }

          var key = this.rowKey;
          var isInclude = _.some(arrData, function (data) {
            return data[key] === row[key]
          });
          var isField = col.field === this.cellStyle.field;

          if (isInclude && isField) {
            colStyle = _.assign({}, colStyle, Object.assign({}, this.cellStyle.style));
          }
        }

        if (_.has(col, 'fieldClass')) {
          fieldClass = col.fieldClass;

          if (typeof fieldClass === 'function') {
            fieldClass = col.fieldClass({ col: col, row: row });
          }
        }

        return h('td', {
          attrs: {
            'draggable-handler': this.rowDraggableHandler && this.rowDraggableHandler === col.field
          },
          staticClass: col.__tdClass,
          style: colStyle,
          'class': [
            {
              's-table-col-auto-width': this.autoWidth,
              'disable': rowDisable,
              'cell-selected': cellSelected
            },
            fieldClass,
            row.__index % 2 === 0 ? 'even-row' : 'odd-row'
          ],
          on: {
            mouseenter: function (evt) { return this$1.onMouseEnterHandler({ h: h, col: col, row: row, evt: evt }); },
            mouseleave: function (evt) { return this$1.onMouseLeaveHandler({ col: col }); },
            contextmenu: function (evt) { return this$1.onContextMenuHandler({ col: col, row: row, evt: evt }); },
            click: function (evt) {
              if (this$1.isTAMS(row)) {
                return
              }

              if (this$1.__isCellSelection(col)) {
                this$1.cellKey = (row[this$1.rowKey]) + "_" + (col.field);

                this$1.__updateCellSelection(row[col.field]);

                this$1.$emit('onCellClick', { value: row[col.field], row: row, col: col });
              }
            }
          }
        }, child)
      }

      var oCol;
      var name = this.$vnode.key;

      if (name) {
        oCol = this.props.colsMap[name];
        if (!oCol) { return }
      } else {
        oCol = this.props.col;
      }

      return h('td', {
        'class': [
          oCol.__tdClass, {
            's-table-col-auto-width': this.autoWidth
          }]
      }, this.$slots.default)
    }
  }
};

/**
 * Row <tr> Renderer
 *
 * @since: 2019-09-09
 * @author: kdydesign.kim
 */

var TrRenderer = {
  methods: {
    rowRenderer: function rowRenderer (h, selected, child, key, row) {
      var this$1 = this;

      var isGroupRow = false;
      var keys = key;

      var props = {
        on: {
          click: function (evt) {
            if (this$1.isSelection === 'single' || this$1.isSelection === 'multiple') {
              this$1.$emit('click', evt);
            }
          },
          dblclick: function (evt) { return this$1.$emit('dblclick', evt); }
        }
      };

      if (!this.props || this.props.header) {
        Object.assign(props, {});
      } else {
        Object.assign(props, { 'class': this.props.__trClass });
      }

      if (this.grouping.use && child.length === 1) {
        isGroupRow = true;
        keys = "group_" + (row[this.grouping.key]);
      }

      return h('tr', {
        key: keys,
        attrs: {
          index: row.__index,
          group: isGroupRow,
          tams: this.isTAMS(row)
        },
        domProps: {
          rowItem: row
        },
        'class': { selected: selected, 'group-row': isGroupRow },
        on: {
          click: function (evt) {
            if (isGroupRow || this$1.isNoSelected(row)) {
              return
            }

            if (this$1.hasSelectionMode) {
              this$1.__updateSelection([key], [row], evt);

              this$1.$emit('onRowClick', { row: row, evt: evt });
            }
          },
          dblclick: function (evt) {
            if (isGroupRow || this$1.isTAMS(row) || this$1.isNoSelected(row)) {
              return
            }

            this$1.$emit('onRowDblClick', { row: row, evt: evt });
          }
        }
      }, child)
    }
  }
};

/**
 * debounce
 *
 * @since 2019-07-08
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */
function debounce (fn, wait, immediate) {
  if ( wait === void 0 ) wait = 250;

  var timeout;

  function debounced (/* ...args */) {
    var this$1 = this;

    var args = arguments;

    var later = function () {
      timeout = void 0;
      if (immediate !== true) {
        fn.apply(this$1, args);
      }
    };

    clearTimeout(timeout);
    if (immediate === true && timeout === void 0) {
      fn.apply(this, args);
    }
    timeout = setTimeout(later, wait);
  }

  debounced.cancel = function () {
    clearTimeout(timeout);
  };

  return debounced
}

/**
 * 2.0 virtual scroll 변경으로 인해 사용하지 않음
 *
 * table virtual scroll
 *
 * @since: 2019-08-27
 * @author: kdydesign.kim
 */

var TableVirtualScroll = {
  props: {
    // virtualScroll: Boolean,
    pageVirtualScroll: Boolean
  },
  data: function data () {
    return {
      HORIZONTAL_SCROLL_TOP: 0,
      itemHeight: 28,
      totalRows: 0,
      screenItemsLen: 0,
      lastRepaintY: 0,
      endPosition: 0,
      from: 0,
      final: 0
    }
  },
  mounted: function mounted () {
    if (this.pageVirtualScroll) {
      this.$refs.bodyContainer.addEventListener('scroll', debounce(this.__onScroll, 30));
    }
  },
  methods: {
    __onScroll: function __onScroll (evt) {
      var currentScrollTop = evt.target.scrollTop;

      if (this.HORIZONTAL_SCROLL_TOP !== currentScrollTop || evt.refresh) {
        var scrollTop = evt.target.scrollTop;

        if (!this.lastRepaintY || Math.abs(scrollTop - this.lastRepaintY) || evt.refresh) {
          var first = Math.floor(scrollTop / this.itemHeight);

          first = first < 0 ? 0 : first;

          if (this.pageVirtualScroll) {
            first = first < 0 ? 0 : first + (this.pageNumber - 1) * this.pageSize;
          }

          this.__renderVirtualNode(first, evt.refresh, evt.refreshType);

          this.lastRepaintY = scrollTop;
          this.HORIZONTAL_SCROLL_TOP = currentScrollTop;
        }

        evt.preventDefault && evt.preventDefault();
      }
    },
    __renderVirtualNode: function __renderVirtualNode (from, refresh, refreshType) {
      var bodyTable = this.$refs.bodyTable;
      var tbody = this.$el.querySelector('tbody');

      var finalItem = from + this.screenItemsLen;

      if (finalItem > this.totalRows) {
        finalItem = this.totalRows;

        if (refresh && (refreshType !== 'rowPerPage')) {
          finalItem = this.data.length;
        }
      }

      if (this.pageVirtualScroll) {
        bodyTable.style.marginTop = (Math.abs((this.pageNumber - 1) * this.pageSize - from) * this.itemHeight) + "px";
      } else {
        bodyTable.style.marginTop = (from * this.itemHeight) + "px";
      }

      // pagination 변경을 통해 구현이 가능하므로 불필요
      for (var j = 0, l = tbody.childNodes.length; j < l; j++) {
        this.data[j].__vs_visibled = true;
        this.$set(this.data[j], '__vs_visibled', true);
      }

      for (var i = from; i < finalItem; i++) {
        this.data[i].__vs_visibled = false;
        this.$set(this.data[i], '__vs_visibled', false);
      }

      this.from = from;
      this.final = finalItem;
    },
    getVsContainer: function getVsContainer (h) {
      var totalRows = this.data.length;

      var srcContainerHeight = this.itemHeight * this.totalRows;
      var tableHeight = this.$parent.height;

      if (this.$parent.windowResize) {
        // window-resize 사용자 element height 지정
        if (this.$parent.$el) {
          tableHeight = this.$parent.$el.clientHeight;
        }
      }

      if (this.pageVirtualScroll) {
        if (totalRows > (this.pageNumber) * this.pageSize) {
          totalRows = this.totalRows = (this.pageNumber) * this.pageSize;
          srcContainerHeight = this.itemHeight * this.pageSize;
        } else {
          var pageDataLen = (this.pageNumber - 1) * this.pageSize;

          if (totalRows - pageDataLen < this.pageSize && totalRows < pageDataLen) {
            totalRows = this.totalRows = (this.pageNumber) * this.pageSize;
            srcContainerHeight = this.itemHeight * (totalRows - pageDataLen);
          } else {
            srcContainerHeight = this.itemHeight * (totalRows - pageDataLen);
          }
        }
      } else {
        this.totalRows = this.data.length;
      }

      this.screenItemsLen = Math.ceil(tableHeight / this.itemHeight) + 1;
      this.endPosition = totalRows >= this.screenItemsLen ? this.screenItemsLen : totalRows;

      return h('div', {
        style: {
          opacity: 0,
          position: 'absolute',
          top: '0px',
          left: '0px',
          width: '1px',
          height: (srcContainerHeight + "px")
        }
      })
    }
  }
};

/**
 * body 영역 스크롤러
 *
 * @since: 2021-04-19
 * @author: kdydesign.kim
 */

function bodyScroller (h, resizeMode) {
  return resizeMode === 'overflow'
    ? h('div', { staticClass: 's-body-scroller' })
    : void 0
}

/**
 * table body
 *
 * @since 2019-06-18
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

var TableBody = {
  name: 'table-body',
  mixins: [
    TableVirtualScroll
  ],
  props: {
    data: Array,
    rowDragAndDrop: [Object, String],
    rowDnDRenderer: [Function, Object],
    props: Object,
    child: Array,
    cols: Array,
    height: [String, Number],
    pageSize: Number,
    pageNumber: Number,
    resizeMode: String
  },
  render: function render (h) {
    var this$1 = this;

    var createBody = h('tbody', {
      'class': 'connect-table-body',
      ref: 'bodyTbody'
    }, this.child);

    if (this.rowDragAndDrop) {
      if (this.rowDragAndDrop.targetType !== 'virtualList') {
        createBody = this.rowDnDRenderer;
      }
    }

    var child = [
      bodyScroller(h, this.resizeMode),

      this.pageVirtualScroll
        ? this.getVsContainer(h)
        : void 0,

      h('table', {
        ref: 'bodyTable'
      }, [
        h('colgroup', this.cols),
        createBody
      ])
    ];

    return h('div', {
      ref: 'bodyContainer',
      'class': [
        's-table-body',
        's-table-body-scroll'
      ],
      style: {
        height: this.height
      },
      on: {
        wheel: (evt) => evt.stopPropagation(),
        scroll: function () { return this$1.$emit('destroyTooltip'); }
      }
    }, child)
  }
};

/**
 * get-table-middle
 *
 * @since 2020-02-19
 * @author kdydesign.kim
 *
 * Quasar 1.9.2
 */

function getTableMiddle (h, conf, content) {
	var headerHeight = conf.headerVisible ? conf.headerHeight : 0;

	return h('div', Object.assign({}, conf,
		{style: {
			height: ((conf.height - headerHeight) + "px"),
			overflowY: 'scroll !important'
		},
		staticClass: 's-table__middle' + (conf.staticClass !== void 0 ? ' ' + conf.staticClass : '')}), [
		bodyScroller(h, conf.resizeMode),
		h('table', { staticClass: 's-table s-table-virtualscroll' }, content)
	])
}

/**
 * virtual-scroll
 *
 * @since 2020-02-19
 * @author kdydesign.kim
 *
 * Quasar 1.15.2
 */

var aggBucketSize = 1000;

var scrollToEdges = [
  'start',
  'center',
  'end',
  'start-force',
  'center-force',
  'end-force'
];

var slice = Array.prototype.slice;

function sumFn (acc, h) {
  return acc + h
}

function getScrollDetails (
  parent,
  child,
  stickyStart,
  stickyEnd
) {
  var
    parentCalc = parent === window ? document.scrollingElement || document.documentElement : parent,
    details = {
      scrollStart: 0,
      scrollViewSize: -stickyStart - stickyEnd,
      scrollMaxSize: 0,
      offsetStart: 0,
      offsetEnd: 0
    };

  if (parent === window) {
    details.scrollStart = window.pageYOffset || window.scrollY || document.body.scrollTop || 0;
    details.scrollViewSize += window.innerHeight;
  } else {
    details.scrollStart = parentCalc.scrollTop;
    details.scrollViewSize += parentCalc.clientHeight;
  }

  details.scrollMaxSize = parentCalc.scrollHeight;

  if (child !== parent) {
    var
      parentRect = parentCalc.getBoundingClientRect(),
      childRect = child.getBoundingClientRect();

    details.offsetStart += childRect.top - parentRect.top;
    details.offsetEnd -= childRect.height;

    if (parent !== window) {
      details.offsetStart += details.scrollStart;
    }
    details.offsetEnd += details.scrollMaxSize - details.offsetStart;
  }

  return details
}

function setScroll$1 (parent, scroll) {
  if (parent === window) {
    window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, scroll);
  } else {
    parent.scrollTop = scroll;
  }
}

function sumSize (sizeAgg, size, from, to) {
  if (from >= to) { return 0 }

  var
    lastTo = size.length,
    fromAgg = Math.floor(from / aggBucketSize),
    toAgg = Math.floor((to - 1) / aggBucketSize) + 1;

  var total = sizeAgg.slice(fromAgg, toAgg).reduce(sumFn, 0);

  if (from % aggBucketSize !== 0) {
    total -= size.slice(fromAgg * aggBucketSize, from).reduce(sumFn, 0);
  }
  if (to % aggBucketSize !== 0 && to !== lastTo) {
    total -= size.slice(to, toAgg * aggBucketSize).reduce(sumFn, 0);
  }

  return total
}

var commonVirtScrollProps = {
  height: {
    type: Number,
    default: 0
  },

  // 가상 목록에서 렌더링할 최소 항목 수
  virtualScrollSliceSize: {
    type: [Number, String],
    default: null
  },

  // 이전에 렌더링 할 가시 여역의 항목 수
  virtualScrollSliceRatioBefore: {
    type: [Number, String],
    default: 1
  },

  // 이후에 렌더링 할 가시 여역의 항목 수
  virtualScrollSliceRatioAfter: {
    type: [Number, String],
    default: 1
  },

  // row 항목의 크기
  virtualScrollItemSize: {
    type: [Number, String],
    default: 28
  },

  // header 고정이 있는 경우 header 크기
  virtualScrollStickySizeStart: {
    type: [Number, String],
    default: 0
  },

  // bottom 고정이 있는 경우 bottom 크기
  virtualScrollStickySizeEnd: {
    type: [Number, String],
    default: 0
  },

  tableColspan: [Number, String]
};

var id = 1;

function setOverflowAnchor (id, index) {
  if (setOverflowAnchor.isSupported === void 0) {
    setOverflowAnchor.isSupported = window.getComputedStyle(document.body).overflowAnchor !== void 0;
  }

  if (setOverflowAnchor.isSupported === false) {
    return
  }

  var ssId = id + '_ss';

  var styleSheet = document.getElementById(ssId);

  if (styleSheet === null) {
    styleSheet = document.createElement('style');
    styleSheet.type = 'text/css';
    styleSheet.id = ssId;
    document.head.appendChild(styleSheet);
  }

  if (styleSheet.qChildIndex !== index) {
    styleSheet.qChildIndex = index;
    styleSheet.innerHTML = "#" + id + " > *:nth-child(" + index + ") { overflow-anchor: auto }";
  }
}

var commonVirtPropsList = Object.keys(commonVirtScrollProps);

var VirtualScroll = {
  props: Object.assign({}, commonVirtScrollProps),

  data: function data () {
    return {
      virtualScrollSliceRange: { from: 0, to: 0 },
      id: 'qvs_' + id++
    }
  },

  watch: {
    needsSliceRecalc: function needsSliceRecalc () {
      this.__setVirtualScrollSize();
    },

    needsReset: function needsReset () {
      this.reset();
    }
  },

  computed: {
    needsReset: function needsReset () {
      var this$1 = this;

      return ['virtualScrollItemSizeComputed']
        .map(function (p) { return this$1[p]; }).join(';')
    },

    needsSliceRecalc: function needsSliceRecalc () {
      var this$1 = this;

      return this.needsReset + ';' + ['virtualScrollSliceRatioBefore', 'virtualScrollSliceRatioAfter']
        .map(function (p) { return this$1[p]; }).join(';')
    },

    colspanAttr: function colspanAttr () {
      return this.tableColspan !== void 0
        ? { colspan: this.tableColspan }
        : { colspan: 100 }
    },

    virtualScrollItemSizeComputed: function virtualScrollItemSizeComputed () {
      return this.virtualScrollItemSize === void 0
        ? 28
        : this.virtualScrollItemSize
    }
  },

  methods: {
    reset: function reset () {
      this.__resetVirtualScroll(this.prevToIndex, true);
    },

    refresh: function refresh (toIndex) {
      this.__resetVirtualScroll(toIndex === void 0 ? this.prevToIndex : toIndex);
    },

    scrollTo: function scrollTo (toIndex, edge) {
      var scrollEl = this.__getVirtualScrollTarget();

      if (scrollEl === void 0 || scrollEl === null || scrollEl.nodeType === 8) {
        return
      }

      var scrollDetails = getScrollDetails(
        scrollEl,
        this.__getVirtualScrollEl(),
        this.virtualScrollStickySizeStart,
        this.virtualScrollStickySizeEnd
      );

      this.__scrollViewSize !== scrollDetails.scrollViewSize && this.__setVirtualScrollSize(scrollDetails.scrollViewSize);

      this.__setVirtualScrollSliceRange(
        scrollEl,
        scrollDetails,
        Math.min(this.virtualScrollLength - 1, Math.max(0, parseInt(toIndex, 10) || 0)),
        0,
        scrollToEdges.indexOf(edge) > -1 ? edge : (this.prevToIndex > -1 && toIndex > this.prevToIndex ? 'end' : 'start')
      );
    },

    __onVirtualScrollEvt: function __onVirtualScrollEvt (evt) {
      // Drag 상태에서는 virtual-scroll 루틴 X
      if (this.$parent.isDraggable) {
        return
      }

      var scrollEl = this.__getVirtualScrollTarget();

      if (scrollEl === void 0 || scrollEl === null || scrollEl.nodeType === 8) {
        return
      }

      var
        scrollDetails = getScrollDetails(
          scrollEl,
          this.__getVirtualScrollEl(),
          this.virtualScrollStickySizeStart,
          this.virtualScrollStickySizeEnd
        ),
        listLastIndex = this.virtualScrollLength - 1,
        listEndOffset = scrollDetails.scrollMaxSize - scrollDetails.offsetStart - scrollDetails.offsetEnd - this.virtualScrollPaddingAfter;

      if (this.prevScrollStart === scrollDetails.scrollStart) {
        return
      }

      if (scrollDetails.scrollMaxSize <= 0) {
        this.__setVirtualScrollSliceRange(scrollEl, scrollDetails, 0, 0);

        return
      }

      this.__scrollViewSize !== scrollDetails.scrollViewSize && this.__setVirtualScrollSize(scrollDetails.scrollViewSize);

      this.__updateVirtualScrollSizes(this.virtualScrollSliceRange.from);

      var scrollMaxStart = Math.floor(scrollDetails.scrollMaxSize -
        Math.max(scrollDetails.scrollViewSize, scrollDetails.offsetEnd) -
        Math.min(this.virtualScrollSizes[listLastIndex], scrollDetails.scrollViewSize / 2));

      if (scrollMaxStart > 0 && Math.ceil(scrollDetails.scrollStart) >= scrollMaxStart) {
        this.__setVirtualScrollSliceRange(
          scrollEl,
          scrollDetails,
          listLastIndex,
          scrollDetails.scrollMaxSize - scrollDetails.offsetEnd - this.virtualScrollSizesAgg.reduce(sumFn, 0)
        );

        return
      }

      var
        toIndex = 0,
        listOffset = scrollDetails.scrollStart - scrollDetails.offsetStart,
        offset = listOffset;

      if (listOffset <= listEndOffset && listOffset + scrollDetails.scrollViewSize >= this.virtualScrollPaddingBefore) {
        listOffset -= this.virtualScrollPaddingBefore;
        toIndex = this.virtualScrollSliceRange.from;
        offset = listOffset;
      } else {
        for (var j = 0; listOffset >= this.virtualScrollSizesAgg[j] && toIndex < listLastIndex; j++) {
          listOffset -= this.virtualScrollSizesAgg[j];
          toIndex += aggBucketSize;
        }
      }

      if (listOffset > 0) {
        // scroll down
        while (listOffset > 0 && toIndex < listLastIndex) {
          listOffset -= this.virtualScrollSizes[toIndex];
          if (listOffset > -scrollDetails.scrollViewSize) {
            toIndex++;
            offset = listOffset;
          } else {
            offset = this.virtualScrollSizes[toIndex] + listOffset;
          }
        }
      } else {
        // scroll up
        while (listOffset < 0 && toIndex < listLastIndex) {
          listOffset += this.virtualScrollSizes[toIndex];

          if (listOffset < +scrollDetails.scrollViewSize) {
            toIndex--;

            if (toIndex < 0) {
              toIndex = 0;
            } else {
              offset = listOffset;
            }
          } else {
            offset = this.virtualScrollSizes[toIndex] + listOffset;
          }
        }
      }

      this.__setVirtualScrollSliceRange(
        scrollEl,
        scrollDetails,
        toIndex,
        offset
      );

      if (evt) {
        evt.preventDefault && evt.preventDefault();
      }
    },

    __setVirtualScrollSliceRange: function __setVirtualScrollSliceRange (scrollEl, scrollDetails, toIndex, offset, align) {
      var this$1 = this;

      var alignForce = typeof align === 'string' && align.indexOf('-force') > -1;
      var alignEnd = alignForce === true ? align.replace('-force', '') : align;
      var alignRange = alignEnd !== void 0 ? alignEnd : 'start';

      var
        from = Math.max(0, toIndex - this.virtualScrollSliceSizeComputed[alignRange]),
        to = from + this.virtualScrollSliceSizeComputed.total;

      if (to > this.virtualScrollLength) {
        to = this.virtualScrollLength;
        from = Math.max(0, to - this.virtualScrollSliceSizeComputed.total);
      }

      this.prevScrollStart = scrollDetails.scrollStart;

      var rangeChanged = from !== this.virtualScrollSliceRange.from || to !== this.virtualScrollSliceRange.to;

      if (rangeChanged === false && alignEnd === void 0) {
        this.__emitScroll(toIndex);

        return
      }

      var activeElement = document.activeElement;
      if (
        rangeChanged === true &&
        this.$refs.content !== void 0 &&
        this.$refs.content !== activeElement &&
        this.$refs.content.contains(activeElement) === true
      ) {
        var onBlurFn = function () {
          this$1.$refs.content.focus();
        };

        activeElement.addEventListener('blur', onBlurFn, true);

        requestAnimationFrame(function () {
          activeElement.removeEventListener('blur', onBlurFn, true);
        });
      }

      setOverflowAnchor(this.id, toIndex - from + 1);

      var sizeBefore = alignEnd !== void 0 ? this.virtualScrollSizes.slice(from, toIndex).reduce(sumFn, 0) : 0;

      if (rangeChanged === true) {
        var tempTo = to >= this.virtualScrollSliceRange.from && from <= this.virtualScrollSliceRange.to
          ? this.virtualScrollSliceRange.to
          : to;
        this.virtualScrollSliceRange = { from: from, to: tempTo };
        this.virtualScrollPaddingBefore = sumSize(this.virtualScrollSizesAgg, this.virtualScrollSizes, 0, from);
        this.virtualScrollPaddingAfter = sumSize(this.virtualScrollSizesAgg, this.virtualScrollSizes, this.virtualScrollSliceRange.to, this.virtualScrollLength);

        requestAnimationFrame(function () {
          if (this$1.virtualScrollSliceRange.to !== to && this$1.prevScrollStart === scrollDetails.scrollStart) {
            this$1.virtualScrollSliceRange = { from: this$1.virtualScrollSliceRange.from, to: to };
            this$1.virtualScrollPaddingAfter = sumSize(this$1.virtualScrollSizesAgg, this$1.virtualScrollSizes, to, this$1.virtualScrollLength);
          }
        });
      }

      requestAnimationFrame(function () {
        // if the scroll was changed give up
        // (another call to __setVirtualScrollSliceRange before animation frame)
        if (this$1.prevScrollStart !== scrollDetails.scrollStart) {
          return
        }

        if (rangeChanged === true) {
          this$1.__updateVirtualScrollSizes(from);
        }

        var
          sizeAfter = this$1.virtualScrollSizes.slice(from, toIndex).reduce(sumFn, 0),
          posStart = sizeAfter + scrollDetails.offsetStart + this$1.virtualScrollPaddingBefore,
          posEnd = posStart + this$1.virtualScrollSizes[toIndex];

        var scrollPosition = posStart + offset;

        if (alignEnd !== void 0) {
          var sizeDiff = sizeAfter - sizeBefore;
          var scrollStart = scrollDetails.scrollStart + sizeDiff;

          scrollPosition = alignForce !== true && scrollStart < posStart && posEnd < scrollStart + scrollDetails.scrollViewSize
            ? scrollStart
            : (
              alignEnd === 'end'
                ? posEnd - scrollDetails.scrollViewSize
                : posStart - (alignEnd === 'start' ? 0 : Math.round((scrollDetails.scrollViewSize - this$1.virtualScrollSizes[toIndex]) / 2))
            );
        }

        this$1.prevScrollStart = scrollPosition;

        setScroll$1(
          scrollEl,
          scrollPosition
        );

        this$1.__emitScroll(toIndex);
      });
    },

    __updateVirtualScrollSizes: function __updateVirtualScrollSizes (from) {
      var contentEl = this.$refs.content;

      if (contentEl !== void 0) {
        var
          children = slice.call(contentEl.children).filter(function (el) { return el.classList.contains('s-virtual-scroll--skip') === false; }),
          childrenLength = children.length,
          sizeFn = function (el) { return el.offsetHeight; };

        var
          index = from,
          size, diff;

        for (var i = 0; i < childrenLength;) {
          size = sizeFn(children[i]);
          i++;

          while (i < childrenLength && children[i].classList.contains('s-virtual-scroll--with-prev') === true) {
            size += sizeFn(children[i]);
            i++;
          }

          diff = size - this.virtualScrollSizes[index];

          if (diff !== 0) {
            this.virtualScrollSizes[index] += diff;
            this.virtualScrollSizesAgg[Math.floor(index / aggBucketSize)] += diff;
          }

          index++;
        }
      }
    },

    __resetVirtualScroll: function __resetVirtualScroll (toIndex, fullReset) {
      var this$1 = this;

      var defaultSize = 1 * this.virtualScrollItemSizeComputed;

      if (fullReset === true || Array.isArray(this.virtualScrollSizes) === false) {
        this.virtualScrollSizes = [];
      }

      var oldVirtualScrollSizesLength = this.virtualScrollSizes.length;

      this.virtualScrollSizes.length = this.virtualScrollLength;

      for (var i = this.virtualScrollLength - 1; i >= oldVirtualScrollSizesLength; i--) {
        this.virtualScrollSizes[i] = defaultSize;
      }

      var jMax = Math.floor((this.virtualScrollLength - 1) / aggBucketSize);

      this.virtualScrollSizesAgg = [];

      for (var j = 0; j <= jMax; j++) {
        var size = 0;
        var iMax = Math.min((j + 1) * aggBucketSize, this.virtualScrollLength);
        for (var i$1 = j * aggBucketSize; i$1 < iMax; i$1++) {
          size += this.virtualScrollSizes[i$1];
        }

        this.virtualScrollSizesAgg.push(size);
      }

      this.prevToIndex = -1;
      this.prevScrollStart = void 0;

      if (toIndex >= 0) {
        this.__updateVirtualScrollSizes(this.virtualScrollSliceRange.from);

        this.$nextTick(function () {
          this$1.scrollTo(toIndex);
        });
      } else {
        this.virtualScrollPaddingBefore = sumSize(this.virtualScrollSizesAgg, this.virtualScrollSizes, 0, this.virtualScrollSliceRange.from);
        this.virtualScrollPaddingAfter = sumSize(this.virtualScrollSizesAgg, this.virtualScrollSizes, this.virtualScrollSliceRange.to, this.virtualScrollLength);

        this.__onVirtualScrollEvt();
      }
    },

    __setVirtualScrollSize: function __setVirtualScrollSize (scrollViewSize) {
      if (scrollViewSize === void 0 && typeof window !== 'undefined') {
        var scrollEl = this.__getVirtualScrollTarget();

        if (scrollEl !== void 0 && scrollEl !== null && scrollEl.nodeType !== 8) {
          scrollViewSize = getScrollDetails(
            scrollEl,
            this.__getVirtualScrollEl(),
            this.virtualScrollStickySizeStart,
            this.virtualScrollStickySizeEnd
          ).scrollViewSize;
        }
      }

      this.__scrollViewSize = scrollViewSize;

      var multiplier = 1 + this.virtualScrollSliceRatioBefore + this.virtualScrollSliceRatioAfter;
      var view = scrollViewSize === void 0 || scrollViewSize <= 0
        ? 1
        : Math.ceil(scrollViewSize / this.virtualScrollItemSizeComputed);
      var baseSize = Math.max(
        10,
        view,
        Math.ceil(this.virtualScrollSliceSize / multiplier)
      );

      this.virtualScrollSliceSizeComputed = {
        total: baseSize + 5,
        start: 5,
        center: Math.ceil(baseSize / 2),
        end: 1,
        view: view
      };
    },

    __padVirtualScroll: function __padVirtualScroll (h, tag, content, DnDRenderer, DnDConfig) {
      var style = {
        '--s-virtual-scroll-item-height': this.virtualScrollItemSizeComputed + 'px'
      };

      var virtualContents = h(tag, {
        staticClass: 's-virtual-scroll__content',
        key: 'content',
        ref: 'content',
        attrs: { id: this.id, tabindex: -1 }
      }, content);

      if (DnDConfig) {
        if (DnDConfig.targetType !== 'virtualList') {
          virtualContents = DnDRenderer(h, content);
        }
      }

      return [
        h(tag, {
          staticClass: 's-virtual-scroll__padding',
          key: 'before',
          ref: 'before'
        }, [
          h('tr', [
            h('td', {
              style: Object.assign({}, {height: ((this.virtualScrollPaddingBefore) + "px")}, style),
              attrs: this.colspanAttr
            })
          ])
        ]),

        virtualContents,

        h(tag, {
          staticClass: 's-virtual-scroll__padding',
          key: 'after',
          ref: 'after'
        }, [
          h('tr', [
            h('td', {
              style: Object.assign({}, {height: ((this.virtualScrollPaddingAfter) + "px")}, style),
              attrs: this.colspanAttr
            })
          ])
        ])
      ]
    },

    __emitScroll: function __emitScroll (index) {
      if (this.prevToIndex !== index) {
        this.$emit('virtual-scroll', {
          index: index,
          from: this.virtualScrollSliceRange.from,
          to: this.virtualScrollSliceRange.to - 1,
          direction: index < this.prevToIndex ? 'decrease' : 'increase',
          ref: this
        });

        this.prevToIndex = index;
      }
    }
  },

  created: function created () {
    this.__setVirtualScrollSize();
  },

  beforeMount: function beforeMount () {
    this.__onVirtualScrollEvt = debounce(this.__onVirtualScrollEvt, 35);
    this.__setVirtualScrollSize();
  },

  beforeDestroy: function beforeDestroy () {
    var styleSheet = document.getElementById(this.id + '_ss');
    styleSheet !== null && styleSheet.remove();
  }
};

/**
 * slot
 *
 * @since 2020-02-19
 * @author kdydesign.kim
 *
 * Quasar 1.9.2
 */

/**
 * Source definitely exists,
 * so it's merged with the possible slot
 */
function mergeSlot (source, vm, slotName) {
  return vm.$scopedSlots[slotName] !== void 0
    ? source.concat(vm.$scopedSlots[slotName]())
    : source
}

/**
 * virtual-scroll
 *
 * @since 2020-02-19
 * @author kdydesign.kim
 *
 * Quasar 1.14.1
 */

var VirtualScroll$1 = {
  name: 'vdt-virtualscroll',

  mixins: [VirtualScroll],

  props: {
    items: {
      type: Array,
      default: function () { return []; }
    },

    itemsFn: Function,
    itemsSize: Number,

    scrollTarget: {
      default: void 0
    },

    getResizeHandler: Function,
    headerVisible: Boolean,

    cols: Array,

    // Drag&Drop Props
    rowDragAndDrop: [Object, String],
    rowDnDRenderer: [Function, Object],

    resizeMode: String
  },

  computed: {
    virtualScrollLength: function virtualScrollLength () {
      return this.itemsSize >= 0 && this.itemsFn !== void 0
        ? parseInt(this.itemsSize, 10)
        : (Array.isArray(this.items) ? this.items.length : 0)
    },

    virtualScrollScope: function virtualScrollScope () {
      var this$1 = this;

      if (this.virtualScrollLength === 0) {
        return []
      }

      var mapFn = function (item, i) { return ({
        index: this$1.virtualScrollSliceRange.from + i,
        item: item
      }); };

      if (this.itemsFn === void 0) {
        return this.items.slice(this.virtualScrollSliceRange.from, this.virtualScrollSliceRange.to).map(mapFn)
      }

      return this.itemsFn(this.virtualScrollSliceRange.from, this.virtualScrollSliceRange.to - this.virtualScrollSliceRange.from).map(mapFn)
    },

    classes: function classes () {
      return 's-virtual-scroll s-virtual-scroll--vertical' +
        (this.scrollTarget !== void 0 ? '' : ' scroll')
    },

    attrs: function attrs () {
      return this.scrollTarget !== void 0 ? void 0 : { tabindex: 0 }
    }
  },

  watch: {
    virtualScrollLength: function virtualScrollLength () {
      this.__resetVirtualScroll();
    },

    scrollTarget: function scrollTarget () {
      this.__unconfigureScrollTarget();
      this.__configureScrollTarget();
    },

    height: function height () {
      this.__resetVirtualScroll();
    }
  },

  methods: {
    __scrollLimits: function __scrollLimits (evt) {
      // q-scroll 하위에 데이터 테이블 사용시 wheel event 중복으로 인한 오류 제어
      evt.stopPropagation()

      // if (evt.deltaY > 0) {
      //   if (this.virtualScrollLength !== this.virtualScrollSliceRange.to) {
      //     evt.stopPropagation()
      //   }
      // } else {
      //   if (this.virtualScrollSliceRange.from > 0) {
      //     evt.stopPropagation()
      //   }
      // }
    },

    __getVirtualScrollEl: function __getVirtualScrollEl () {
      return this.$el
    },

    __getVirtualScrollTarget: function __getVirtualScrollTarget () {
      return this.__scrollTarget
    },

    __configureScrollTarget: function __configureScrollTarget () {
      var this$1 = this;

      this.__scrollTarget = getScrollTarget(this.$el, this.scrollTarget);
      this.__scrollTarget.addEventListener('scroll', this.__onVirtualScrollEvt, listenOpts.passive);

      var wheelEvent = ['DOMMouseScroll', 'mousewheel'];

      wheelEvent.forEach(function (evtName) {
        this$1.__scrollTarget.addEventListener(evtName, this$1.__scrollLimits, listenOpts.passive);
      });
    },

    __unconfigureScrollTarget: function __unconfigureScrollTarget () {
      var this$1 = this;

      if (this.__scrollTarget !== void 0) {
        this.__scrollTarget.removeEventListener('scroll', this.__onVirtualScrollEvt, listenOpts.passive);

        var wheelEvent = ['DOMMouseScroll', 'mousewheel'];

        wheelEvent.forEach(function (evtName) {
          this$1.__scrollTarget.removeEventListener(evtName, this$1.__scrollLimits, listenOpts.passive);
        });

        this.__scrollTarget = void 0;
      }
    }
  },

  beforeMount: function beforeMount () {
    this.__resetVirtualScroll();
  },

  mounted: function mounted () {
    this.__configureScrollTarget();
  },

  beforeDestroy: function beforeDestroy () {
    this.__unconfigureScrollTarget();
  },

  render: function render (h) {
    if (this.$scopedSlots.default === void 0) {
      console.error('virtual-scroll: default scoped slot is required for rendering', this);
      return
    }

    var child = this.__padVirtualScroll(
      h,
      'tbody',
      this.virtualScrollScope.map(this.$scopedSlots.default),
      this.rowDnDRenderer,
      this.rowDragAndDrop
    );

    if (this.$scopedSlots.before !== void 0) {
      child = this.$scopedSlots.before().concat(child);
    }

    child = mergeSlot(child, this, 'after');

    child.unshift(h('colgroup', this.cols));

    return getTableMiddle(h, {
      staticClass: this.classes,
      getResizeHandler: this.getResizeHandler,
      height: this.height,
      headerHeight: this.$parent.$children[0].$el.offsetHeight,
      headerVisible: this.headerVisible,
      resizeMode: this.resizeMode
    }, child)
  }
};

/**
 * table body mixins
 *
 * @since 2019-06-18
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

var TableBodyMixin = {
  mixins: [
    TdRenderer,
    TrRenderer,
    RenderComponent
  ],
  data: function data () {
    return {
      initBodyContainerHeight: 0,
      rowDisabledField: void 0
    }
  },
  computed: {
    bodyContainerHeight: function bodyContainerHeight () {
      var bodyContainerHeight = 0;
      var height = this.height;

      if (this.$children.length > 0) {
        bodyContainerHeight = (height - this.getHeaderHeight - 3) + "px";
      }

      return bodyContainerHeight
    },
    getBodyHeight: function getBodyHeight () {
      // panel resize
      if (this.bodyContainerHeight !== 0) {
        return this.bodyContainerHeight
      }

      if (this.windowResize) {
        if (this.$children.length > 0) {
          var bodyHeight = this.dynamicHeight - this.pageMargin - this.getHeaderHeight - 1;

          // 연산이 이상한것 같은데?
          if (this.dynamicHeight < this.minHeight) {
            bodyHeight = this.minHeight - this.getHeaderHeight - 1;
          }

          return (bodyHeight + "px")
        }
      }

      if (this.isPopup) {
        return ((this.height - this.getHeaderHeight + 20) + "px")
      }

      // basic
      return this.initBodyContainerHeight
    }
  },
  mounted: function mounted () {
    if (this.windowResize) {
      this.dynamicHeight = window.innerHeight;
    }

    this.initBodyContainerHeight = (this.height - this.getHeaderHeight - 1) + "px";
  },
  methods: {
    onVirtScroll: function onVirtScroll (info) {
      this.$emit('virtual-scroll', info);
    },
    resetVirtualScroll: function resetVirtualScroll () {
      this.hasVirtScroll === true && this.$refs.virtScroll.reset();
    },
    getTableBodyRow: function getTableBodyRow (h, row) {
      var this$1 = this;

      var
        key = row[this.rowKey],
        selected = this.isRowSelected(key);

      var child = this.computedCols.map(function (col, idx) {
        if (this$1.cellSelected === void 0) {
          this$1.cellKey = void 0;
        }

        var
          cellKey = (row[this$1.rowKey]) + "_" + (col.field),
          cellSelected = this$1.isCellSelected(cellKey);

        var opts = { row: row, col: col };

        if (this$1.treeView) {
          var treeColumn = _.has(this$1.treeView, 'targetColumn')
            ? this$1.treeView.targetColumn
            : this$1.computedCols[0].field;

          opts = _.assign(opts, {
            treeView: col.field === treeColumn
              ? (_.has(this$1.treeView, 'use') && this$1.treeView.use) || !_.has(this$1.treeView, 'use')
              : false
          });
        }

        if (!col.hasOwnProperty('type')) {
          opts.col = Object.assign(opts.col, {
            type: 'textbox'
          });
        }

        // column의 rowDisable
        if (col.props.hasOwnProperty('rowDisable')) {
          if (col.props.rowDisable) {
            this$1.rowDisabledField = col.field;
          }
        }

        return this$1.cellRenderer(h, cellSelected, opts)
      });

      if (this.grouping.use && row[this.grouping.isGroupKey]) {
        child = this.getGroups(child);
      }

      if (row.__vs_visibled) {
        return void 0
      }

      return this.rowRenderer(h, selected, child, key, row)
    },
    getVirtTableBody: function getVirtTableBody (h) {
      var this$1 = this;

      var body = this.$scopedSlots.body;
      var tableStyle = this.tableStyle;

      if (this.windowResize) {
        tableStyle = {
          height: this.getBodyHeight
        };
      }

      var virtSlots = {
        default: function (props) {
          if (body) {
            var key = props.item[this$1.rowKey];

            return body(this$1.getSlotBody({ key: key, row: props.item }))
          }

          return this$1.getTableBodyRow(h, props.item)
        }
      };

      return h(VirtualScroll$1, {
        ref: 'virtScroll',
        props: Object.assign({}, this.virtProps,
          {items: this.computedRows,
          tableColspan: this.computedCols.length,
          rowDragAndDrop: this.rowDragAndDrop,
          rowDnDRenderer: this.renderDraggable,
          resizeMode: this.resizeMode,
          getResizeHandler: this.getResizeHandler,
          headerVisible: this.headerVisible,
          cols: this.getCols(h)}),
        on: this.onVirtScroll,
        class: this.tableClass,
        style: tableStyle,
        scopedSlots: virtSlots
      })
    },
    getTableBody: function getTableBody (h) {
      var this$1 = this;

      var body = this.$scopedSlots.body;
      var child = this.computedRows.map(function (row) {
        if (body) {
          var key = row[this$1.rowKey];

          return body(this$1.getSlotBody({ key: key, row: row }))
        }

        return this$1.getTableBodyRow(h, row)
      });

      return h(TableBody, {
        ref: 'tableBody',
        props: {
          data: this.data,
          // virtualScroll: this.virtualScroll,
          pageVirtualScroll: this.pageVirtualScroll,
          rowDragAndDrop: this.rowDragAndDrop,
          rowDnDRenderer: this.renderDraggable(h, child),
          height: this.getBodyHeight,
          child: child,
          cols: this.getCols(h),
          pageSize: this.pageSize,
          resizeMode: this.resizeMode,
          pageNumber: this.getCurrentPageNumber
        },
        on: {
          destroyTooltip: function () { return this$1.__cleanTooltip(); }
        }
      })
    },
    getCellValue: function getCellValue (col, row) {
      var val = typeof col.field === 'function' ? col.field(row) : row[col.field];
      return col.format ? col.format({ value: val, row: row }) : val
    },
    getGroups: function getGroups (child) {
      var colspan = child.length;

      return child.slice(0, 1).map(function (td) {
        Object.assign(td.data, {
          staticClass: 'text-left',
          'class': 'group',
          attrs: {
            colspan: colspan
          }
        });

        return td
      })
    },
    getSlotBody: function getSlotBody (ref) {
      var key = ref.key;
      var row = ref.row;

      var selected = this.isRowSelected(key);

      return this.addBodyRowMeta({
        key: key,
        row: row,
        grouping: this.grouping,
        isTAMS: this.isTAMS(row),
        cols: this.computedCols,
        isSelection: this.hasSelectionMode,
        noSelected: this.isNoSelected(row),
        rowDisable: this.rowDisable(row),
        updateSelection: this.__updateSelection,
        colsMap: this.computedColsMap,
        __trClass: selected ? 'selected' : '',
        refTooltip: this.$refs.tooltip
      })
    },
    addBodyRowMeta: function addBodyRowMeta (data) {
      return data
    },
    scrollTo: function scrollTo (ref) {
      var index = ref.index;
      var duration = ref.duration; if ( duration === void 0 ) duration = 300;
      var position = ref.position;
      var edge = ref.edge; if ( edge === void 0 ) edge = 'center';

      if (this.hasVirtScroll) {
        this.$refs.virtScroll.scrollTo(index, edge);
        return
      }

      var target = this.$refs.tableBody.$el;

      var offset = 0;

      if (position === 'bottom') {
        offset = target.childNodes[0].clientHeight;
      } else if (position === 'top') {
        offset = 0;
      } else {
        offset = parseInt(position);
      }

      setScrollPosition(target, offset, duration);
    }
  }
};

/**
 * context-menu
 *
 * @since 2019-07-09
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

var ContextMenu = {
  name: 'context-menu',
  props: {
    disable: Boolean
  },
  methods: {
    hide: function hide (evt) {
      if (this.$refs.popup) {
        return this.$refs.popup.hide(evt)
      }
    },
    show: function show (evt) {
      var this$1 = this;

      if (this.disable) {
        return
      }

      if (!evt) {
        return
      }

      stopAndPrevent(evt);
      /*
        Opening with a timeout for
        Firefox workaround
       */
      setTimeout(function () {
        if (this$1.$refs.popup) {
          this$1.event = evt;
          this$1.$refs.popup.show(evt);
        }
      }, 100);
    },

    __desktopBodyHide: function __desktopBodyHide (evt) {
      if (!this.$el.contains(evt.target)) {
        this.hide(evt);
      }
    },
    __desktopOnShow: function __desktopOnShow () {
      document.body.addEventListener('contextmenu', this.__desktopBodyHide, true);
      document.body.addEventListener('click', this.__desktopBodyHide, true);
      this.$emit('show', this.event);
    },
    __desktopOnHide: function __desktopOnHide (evt) {
      document.body.removeEventListener('contextmenu', this.__desktopBodyHide, true);
      document.body.removeEventListener('click', this.__desktopBodyHide, true);
      this.$emit('hide', this.event, evt);
    }
  },
  render: function render (h) {
    return h(PopOver, {
      ref: 'popup',
      props: {
        anchorClick: false,
        touchPosition: true
      },
      on: {
        show: this.__desktopOnShow,
        hide: this.__desktopOnHide
      }
    }, this.$slots.default)
  },
  mounted: function mounted () {
    this.target = this.$el.parentNode;
    this.target.addEventListener('contextmenu', this.show);
  },
  beforeDestroy: function beforeDestroy () {
    this.target.removeEventListener('contextmenu', this.show);
  }
};

/**
 * context-menu
 *
 * @since 2019-07-02
 * @author kdydesign.kim
 */

var TableContextMenu = {
  name: 'table-context-menu',
  props: {
    child: Array
  },
  methods: {
    __getEmitParameter: function __getEmitParameter (evt) {
      var instance = this.$parent;
      var
        row = instance.contextRow,
        col = instance.contextCol;

      return { evt: evt, row: row, col: col }
    }
  },
  render: function render (h) {
    var this$1 = this;

    return h(ContextMenu, {
      on: {
        show: function (evt) {
          this$1.$emit('show', this$1.__getEmitParameter(evt));
        },
        hide: function (evt) {
          this$1.$emit('hide', this$1.__getEmitParameter(evt));
        }
      }
    }, this.child)
  }
};

/**
 * context-menu-mixins
 *
 * @since 2019-07-02
 * @author kdydesign.kim
 */

var TableContextMenu$1 = {
  props: {
    contextMenu: Object
  },
  data: function data () {
    return {
      contextRow: void 0,
      contextTarget: void 0,
      contextCell: void 0,
      contextCol: void 0,
      isVirtualListContext: false,
      contextCellList: []
    }
  },
  computed: {
    computedContextMenuMap: function computedContextMenuMap () {
      var contextMenu = Object.assign({}, this.contextMenu);

      if (this.contextMenu.link === void 0) {
        Object.assign(contextMenu, { link: true });
      }

      if (this.contextMenu.separator === void 0) {
        Object.assign(contextMenu, { separator: true });
      }

      if (this.contextMenu.closeOverlay === void 0) {
        Object.assign(contextMenu, { closeOverlay: true });
      }

      if (this.contextMenu.noBorder === void 0) {
        Object.assign(contextMenu, { noBorder: false });
      }

      return contextMenu
    }
  },
  methods: {
    getContextMenu: function getContextMenu (h) {
      var this$1 = this;

      var child = [this.getMenuList(h)];

      return h(TableContextMenu, {
        props: {
          child: child
        },
        on: {
          show: function (evt) { return this$1.contextMenu.show(evt); },
          hide: function (evt) { return this$1.contextMenu.hide(evt); }
        }
      })
    },
    getMenuList: function getMenuList (h) {
      var child = this.getListItem(h);

      return h(List, {
        props: {
          link: this.computedContextMenuMap.link,
          separator: this.computedContextMenuMap.separator,
          noBorder: this.computedContextMenuMap.noBorder
        }
      }, child)
    },
    getListItem: function getListItem (h) {
      var this$1 = this;

      var contextMenu = this.computedContextMenuMap.menuItem;
      var item = [];

      contextMenu.forEach(function (menu, idx) {
        var createItem = h(Item, {
          key: menu.key || idx,
          directives: [
            {
              name: 'table-close-overlay',
              value: this$1.computedContextMenuMap.closeOverlay
            }
          ],
          nativeOn: {
            click: function (evt) {
              this$1.contextMenu.click({ evt: evt, value: menu.value });
            }
          }
        }, [
          h(ItemMain, {
            props: {
              label: menu.label
            }
          })
        ]);

        item.push(createItem);
      });

      return item
    },
    getContextCellValue: function getContextCellValue (evt) {
      if (evt.target.nodeName === 'TH') {
        return void 0
      }
      if (evt.target.nodeName === 'DIV') {
        if (evt.target.parentNode.nodeName === 'TH') {
          return void 0
        }

        if (evt.target.classList.contains('s-table-body-scroll') ||
          evt.target.classList.contains('s-table-header-scroll')) {
          return void 0
        }
      }

      if (evt.target.classList.contains('virtual-list-more')) {
        return void 0
      }

      if (this.grouping.use && this.contextTarget[this.grouping.isGroupKey]) {
        return void 0
      }

      return {
        cell: this.contextCol.field, // field 정보
        cellItem: this.contextCell, // context-menu로 선택된 cell 정보
        cellList: this.contextCellList, // cell에 포함된 virtual-list 전체 정보
        rowItem: this.contextRow, // 선택된 row 정보
        contextTarget: this.contextTarget // context-menu evt로 선택된 row 정보 - 다중 context-menu
      }
    }
  }
};

/**
 * sort
 *
 * @param a
 * @param b
 * @returns {number}
 *
 * Quasar 0.17.18
 */

function sortDate (a, b) {
  return (new Date(a)) - (new Date(b))
}

/**
 * table sorting
 *
 * @since 2019-06-18
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

var Sort = {
  props: {
    sortMethod: {
      type: Function,
      default: function default$1 (data, sortBy, descending) {
        var col = this.columns.find(function (def) { return def.name === sortBy; });
        if (col === null || col.field === void 0) {
          return data
        }

        var
          dir = descending ? -1 : 1,
          val = typeof col.field === 'function'
            ? function (v) { return col.field(v); }
            : function (v) { return v[col.field]; };

        return data.sort(function (a, b) {
          var assign;

          var
            A = val(a),
            B = val(b);

          if (A === null || A === void 0) {
            return -1 * dir
          }
          if (B === null || B === void 0) {
            return 1 * dir
          }
          if (col.sort) {
            return col.sort(A, B) * dir
          }
          if (isNumber(A) && isNumber(B)) {
            return (A - B) * dir
          }
          if (isDate(A) && isDate(B)) {
            return sortDate(A, B) * dir
          }
          if (typeof A === 'boolean' && typeof B === 'boolean') {
            return (a - b) * dir
          }

          (assign = [A, B].map(function (s) { return (s + '').toLowerCase(); }), A = assign[0], B = assign[1]);

          return A < B
            ? -1 * dir
            : (A === B ? 0 : dir)
        })
      }
    }
  },
  computed: {
    columnToSort: function columnToSort () {
      var ref = this.computedPagination;
      var sortBy = ref.sortBy;

      if (sortBy) {
        return this.columns.find(function (def) { return def.name === sortBy; }) || null
      }
    }
  },
  methods: {
    sort: function sort (col /* String(col name) or Object(col definition) */) {
      if (col === Object(col)) {
        col = col.name;
      }

      var ref = this.computedPagination;
      var sortBy = ref.sortBy;
      var descending = ref.descending;

      if (sortBy !== col) {
        sortBy = col;
        descending = false;
      } else {
        if (this.binaryStateSort) {
          descending = !descending;
        } else {
          if (descending) {
            sortBy = null;
          } else {
            descending = true;
          }
        }
      }

      this.setPagination({ sortBy: sortBy, descending: descending, page: 1 });
    }
  }
};

/**
 * table row selection
 *
 * @since 2019-06-18
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */
var RowSelection = {
  props: {
    selection: {
      type: String,
      default: 'multiple',
      validator: function (v) { return ['single', 'multiple', 'none'].includes(v); }
    },
    selected: {
      type: [Array, Object],
      default: function () {}
    },
    cellSelected: {
      type: [Object, String, Number, Array],
      default: function () {}
    },
    cellSelection: {
      type: Boolean,
      default: false
    },
    noSelected: {
      type: Function,
      default: function () {
        return false
      }
    }
  },
  data: function data () {
    return {
      cellKey: void 0
    }
  },
  computed: {
    selectedKeys: function selectedKeys () {
      var this$1 = this;

      var keys = {};
      var selected = [];

      if (this.singleSelection && this.selected) {
        selected.push(this.selected);
      } else if (this.multipleSelection && this.selected) {
        selected = this.selected;
      } else {
        selected = [];
      }

      selected.map(function (row) { return row[this$1.rowKey]; }).forEach(function (key) {
        keys[key] = true;
      });

      return keys
    },
    hasSelectionMode: function hasSelectionMode () {
      return this.selection !== 'none'
    },
    isSelection: function isSelection () {
      return this.selection
    },
    isCellSelection: function isCellSelection () {
      return this.cellSelection
    },
    singleSelection: function singleSelection () {
      return this.selection === 'single'
    },
    multipleSelection: function multipleSelection () {
      return this.selection === 'multiple'
    },
    rowsSelectedNumber: function rowsSelectedNumber () {
      return this.selected.length
    }
  },
  methods: {
    isNoSelected: function isNoSelected (row) {
      return this.noSelected(row)
    },
    isRowSelected: function isRowSelected (key) {
      return this.selectedKeys[key] === true
    },
    isCellSelected: function isCellSelected (cellKey) {
      return this.cellKey === cellKey && this.cellSelected
    },
    clearSelection: function clearSelection () {
      this.$emit('update:selected', []);
    },
    __updateSelection: function __updateSelection (keys, rows, evt) {
      if (this.singleSelection) {
        this.$emit('update:selected', rows[0]);
      } else {
        this.__updateMultipleSelection(keys, rows, evt);
      }
    },
    __updateCellSelection: function __updateCellSelection (cell) {
      if (this.isCellSelection) {
        this.$emit('update:cellSelected', cell);
      }
    },
    __updateMultipleSelection: function __updateMultipleSelection (keys, rows, evt) {
      var this$1 = this;

      if (!this.selected) {
        return
      }

      if (evt.ctrlKey || evt.shiftKey) {
        if (evt.shiftKey) {
          var
            data = this.computedData,
            first = _.findIndex(data.rows, function (obj) {
              if (this$1.selected && this$1.selected.length > 0) {
                return obj[this$1.rowKey] === this$1.selected[this$1.selected.length - 1][this$1.rowKey]
              }
            }),
            last = _.findIndex(data.rows, function (obj) {
              if (this$1.selected && this$1.selected.length > 0) {
                return obj[this$1.rowKey] === rows[0][this$1.rowKey]
              }
            }),
            result = [];

          var noSelected = false;
          var isGroup = false;

          if (evt.currentTarget.classList.value || first < 0 || last < 0) {
            return
          }

          if (first > last) {
            for (var i = first - 1; i >= last; i--) {
              noSelected = !this.isNoSelected(data.rows[i]);
              isGroup = !data.rows[i][this.grouping.isGroupKey];

              if (!_.includes(this.selected, data.rows[i])) {
                if (isGroup && noSelected) {
                  result.push(data.rows[i]);
                }
              }
            }
          } else {
            for (var i$1 = first + 1; i$1 <= last; i$1++) {
              noSelected = !this.isNoSelected(data.rows[i$1]);
              isGroup = !data.rows[i$1][this.grouping.isGroupKey];

              if (!_.includes(this.selected, data.rows[i$1])) {
                if (isGroup && noSelected) {
                  result.push(data.rows[i$1]);
                }
              }
            }
          }

          this.$emit('update:selected', this.selected.concat(result));
        }

        if (evt.ctrlKey) {
          var adding = true;

          if (evt.currentTarget.classList.value) {
            adding = false;
          }

          this.$emit('update:selected', adding
            ? this.selected.concat(rows)
            : this.selected.filter(function (row) { return !keys.includes(row[this$1.rowKey]); })
          );
        }
      } else {
        this.$emit('update:selected', rows);
      }
    },
    selectedRow: function selectedRow (index) {
      var this$1 = this;

      var selectRow = [];
      var idx = [];

      if (Array.isArray(index)) {
        idx = index;
      } else {
        idx = [index];
      }

      if (this.singleSelection) {
        if (this.data[index]) {
          selectRow = this.data[index];
        }
      } else {
        idx.forEach(function (i) {
          if (this$1.data[i]) {
            selectRow.push(this$1.data[i]);
          }
        });
      }

      this.$emit('update:selected', selectRow);
    }
  }
};

/**
 * table row draggable
 *
 * @since 2019-08-05
 * @author kdydesign.kim
 *
 */
var RowDraggable = {
  props: {
    rowDraggable: {
      type: Boolean,
      default: false
    },
    rowDragAndDrop: {
      type: [Object, String],
      default: function () {}
    },
    rowDraggableHandler: {
      type: String,
      default: void 0
    }
  },
  computed: {
    __getDnDGroupOpts: function __getDnDGroupOpts () {
      return this.rowDragAndDrop
    }
  },
  mounted: function mounted () {
    var this$1 = this;

    if (this.rowDraggable && !this.authDisable) {
      this.isDraggable = false;

      var vueObj = this;
      var bodyEl = void 0;
      var targetIndex = void 0;

      if (this.hasVirtScroll) {
        bodyEl = $(this.$refs.virtScroll.$refs.content);
      } else {
        bodyEl = $(this.$refs.tableBody.$refs.bodyTbody);
      }

      bodyEl.sortable({
        containment: null,
        opacity: 1,
        revert: 0,
        distance: 0,
        scroll: false,
        cursor: 'move',
        axis: 'y',
        placeholder: 'vue-ui-sortable-placeholder',
        items: '> tr:not(tr:first[group], tr[tams=true])',
        cancel: 'tr[tams=true]',
        handle: 'td[draggable-handler="true"]',
        helper: function (e, ui) {
          ui.children().each(function () {
            $(this).width($(this).width());
            $(this).height($(this).height());
          });

          return ui
        },
        start: function (e, ui) {
          targetIndex = ui.item.index();

          vueObj.isDraggable = true;
          ui.placeholder.height(ui.helper.outerHeight());
        },
        stop: function (e, ui) {
          var
            moveRule = $(ui.item)[0].rowItem,
            pos = ui.position.top - ui.originalPosition.top > 0 ? 'down' : 'up';

          var moveIndex = ((this$1.getCurrentPageNumber - 1) * this$1.pageSize) + ui.item.index();

          if (this$1.hasVirtScroll) {
            moveIndex = this$1.$refs.virtScroll.virtualScrollSliceRange.from + ui.item.index();
          }

          this$1.$emit('draggable', {
            moveRule: moveRule,
            targetIndex: targetIndex,
            moveIndex: moveIndex,
            pos: pos
          });

          vueObj.isDraggable = false;
        }
      });
    }
  },
  beforeDestroy: function beforeDestroy () {
    if (this.rowDraggable && !this.authDisable) {
      var bodyEl = void 0;

      if (this.hasVirtScroll) {
        bodyEl = $(this.$refs.virtScroll.$refs.content);
      } else {
        bodyEl = $(this.$refs.tableBody.$refs.bodyTbody);
      }

      bodyEl.sortable('destroy');
    }
  },
  methods: {
    draggableCancel: function draggableCancel (ref) {
      var oldIdx = ref.oldIdx;
      var newIdx = ref.newIdx;

      var newRow = this.$refs.draggable.$el.childNodes[newIdx];
      var oldRow = this.$refs.draggable.$el.childNodes[oldIdx];

      newRow.parentNode.insertBefore(newRow, oldRow);
    },
    renderDraggable: function renderDraggable (h, child) {
      var this$1 = this;

      var dragHandle = void 0;

      if (this.rowDraggableHandler) {
        dragHandle = '.s-row-handler';
      }

      if (_.has(this.__getDnDGroupOpts, 'handler')) {
        if (this.__getDnDGroupOpts.handler) {
          dragHandle = '.s-drag-handler';
        }
      }

      return h('draggable', {
        ref: 'draggable',
        props: {
          tag: 'tbody',
          value: this.data,
          move: function (evt) {
            if (this$1.grouping.use) {
              if (evt.relatedContext.index === 0 &&
                evt.relatedContext.element[this$1.grouping.isGroupKey]) {
                return false
              }
            }

            if (evt.related.classList.contains('virtual-list-more-row')) {
              return false
            }

            return true
          }
        },
        attrs: {
          animation: 200,
          disabled: false,
          delay: 0,
          sort: false,
          chosenClass: '', // 'row-dnd-choose'
          dragoverBubble: true,
          ghostClass: 'row-dnd-ghost',
          dragClass: 'row-dnd-drag',
          handle: dragHandle,
          group: this.__getDnDGroupOpts
        },
        on: {
          choose: function (evt) { },
          clone: function (evt) { },
          start: function (evt) {
            evt.item.classList.add('row-dnd-choose');
          },
          unchoose: function (evt) { },
          change: function (evt) {
            if (evt.hasOwnProperty('added')) {
              var
                newIdx = evt.added.newIndex,
                cloneData = evt.added.element;

              this$1.data.splice(newIdx, 0, cloneData);
            }
          },
          update: function (evt) { },
          sort: function (evt) { },
          end: function (evt) {
            if (evt.pullMode !== 'clone') {
              var
                targetIndex = evt.oldIndex,
                moveIndex = evt.newIndex,
                moveRule = this$1.data[targetIndex];

              if (this$1.$listeners.hasOwnProperty('draggable')) {
                this$1.$listeners.draggable({
                  moveRule: moveRule,
                  targetIndex: targetIndex,
                  moveIndex: moveIndex,
                  pos: targetIndex > moveIndex ? 'up' : 'down'
                });
              }
            }

            evt.item.classList.remove('row-dnd-choose');
          },
          remove: function (evt) { },
          filter: function (evt) { },
          add: function (evt) { }
        }
      }, child)
    }
  },
  watch: {
    rowDraggable: function rowDraggable (value) {
      if (!value) {
        if ($(this.$refs.tableBody.$refs.bodyTbody).data('uiSortable')) {
          $(this.$refs.tableBody.$refs.bodyTbody).sortable('destroy');
        }
      } else {
        if ($(this.$refs.tableBody.$refs.bodyTbody).data('uiSortable')) {
          $(this.$refs.tableBody.$refs.bodyTbody).sortable('enable');
        }
      }
    }
  }
};

/**
 * group expand
 *
 * @since 2019-06-18
 * @author kdydesign.kim
 */

var Expand = {
  data: function data () {
    return {
      rowsExpanded: {},
      treeExpanded: {}
    }
  },
  computed: {
    __getGroupKey: function __getGroupKey () {
      return this.grouping.key || 'groupId'
    },
    __getGroups: function __getGroups () {
      var this$1 = this;

      return this.data.filter(function (row) { return row[this$1.grouping.isGroupKey]; })
    }
  },
  methods: {
    expand: function expand (expandType, keyValue) {
      this[toLowerCamelCase(expandType)](keyValue);
    },
    open: function open (keyValue) {
      this.$set(this.rowsExpanded, keyValue, true);
    },
    close: function close (keyValue) {
      this.$set(this.rowsExpanded, keyValue, false);
    },
    allOpen: function allOpen (keyValue) {
      var this$1 = this;

      this.__getGroups.forEach(function (row) {
        this$1.$set(this$1.rowsExpanded, row[this$1.__getGroupKey], true);
      });
    },
    allClose: function allClose (keyValue) {
      var this$1 = this;

      this.__getGroups.forEach(function (row) {
        this$1.$set(this$1.rowsExpanded, row[this$1.__getGroupKey], false);
      });
    }
  }
};

/**
 * tree table
 *
 * @since 2019-08-05
 * @author kdydesign.kim
 *
 */
var Tree = {
  props: {
    treeView: {
      type: [Boolean, Object],
      default: false
    }
  },
  computed: {
    getTargetColumn: function getTargetColumn () {
      return _.has(this.treeView, 'targetColumn')
        ? this.treeView.targetColumn
        : this.computedCols[0].field
    }
  },
  methods: {
    treeExpandAll: function treeExpandAll (expand) {
      var this$1 = this;

      _.forEach(this.computedRows, function (row) {
        this$1.treeExpand(row, expand);
      });
    },
    treeExpand: function treeExpand (row, expand) {
      var defaultExpand = expand === void 0 ? !row.__tree_expand_icon : !expand;

      row.__tree_expand_icon = defaultExpand;

      var hidingChildren = function (childData) {
        childData.__tree_expand = !defaultExpand;

        if (!childData.__tree_expand || expand !== void 0) {
          childData.__tree_expand_icon = defaultExpand;

          if (childData.hasOwnProperty('children')) {
            for (var i = 0; i < childData.children.length; i++) {
              var child = childData.children[i];

              hidingChildren(child);
            }
          }
        }
      };

      if (row.hasOwnProperty('children')) {
        for (var i = 0; i < row.children.length; i++) {
          var child = row.children[i];

          hidingChildren(child);
        }
      }
    }
  }
};

/**
 * group table
 *
 * @since 2019-08-05
 * @author kdydesign.kim
 *
 */
var Group = {
  props: {
    grouping: {
      type: Object,
      default: function () {
        return {
          use: false,
          label: void 0,
          button: false,
          click: function () { return ({}); }
        }
      }
    }
  },
  methods: {
    __groupMoreEvt: function __groupMoreEvt (ref) {
      var evt = ref.evt;
      var row = ref.row;

      if (this.grouping.hasOwnProperty('click')) {
        this.grouping.click({ evt: evt, row: row });
      }
    }
  }
};

/**
 * tooltip
 *
 * @since 2019-07-08
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

var ToolTip = {
  name: 'tool-tip',
  mixins: [ModelToggleMixin, CanRenderMixinMixin],
  data: function data () {
    return {
      anchor: 'top middle',
      self: 'bottom middle',
      offset: [10, 10],
      delay: 0,
      maxHeight: void 0,
      disable: false,
      message: void 0,
      staticStyle: void 0,
      targetNode: void 0
    }
  },
  watch: {
    $route: function $route () {
      this.hide();
    }
  },
  computed: {
    anchorOrigin: function anchorOrigin () {
      return parsePosition(this.anchor)
    },
    selfOrigin: function selfOrigin () {
      return parsePosition(this.self)
    }
  },
  methods: {
    __show: function __show () {
      clearTimeout(this.timer);

      if (this.targetNode.nodeName === void 0) {
        return
      }

      this.targetNode.appendChild(this.$el);
      this.scrollTarget = getScrollTarget(this.targetNode);
      this.scrollTarget.addEventListener('scroll', this.hide, listenOpts.passive);
      window.addEventListener('resize', this.__debouncedUpdatePosition, listenOpts.passive);

      this.__updatePosition();
      this.showPromise && this.showPromiseResolve();
    },
    __hide: function __hide () {
      this.__cleanup();
      this.hidePromise && this.hidePromiseResolve();
    },
    __cleanup: function __cleanup () {
      clearTimeout(this.timer);

      if (this.targetNode.nodeName === void 0 || !this.scrollTarget) {
        return
      }

      this.scrollTarget.removeEventListener('scroll', this.hide, listenOpts.passive);
      window.removeEventListener('resize', this.__debouncedUpdatePosition, listenOpts.passive);
      this.$el.remove();
    },
    __updatePosition: function __updatePosition () {
      setPosition({
        el: this.$el,
        animate: true,
        offset: this.offset,
        anchorEl: this.targetNode,
        anchorOrigin: this.anchorOrigin,
        selfOrigin: this.selfOrigin,
        maxHeight: this.maxHeight
      });
    },
    __setProps: function __setProps (ref) {
      var props = ref.props; if ( props === void 0 ) props = {};
      var message = ref.message;

      this.anchor = props.anchor || this.anchor;
      this.self = props.self || this.self;
      this.offset = props.offset || this.offset;
      this.delay = props.delay || this.delay;
      this.maxHeight = props.maxHeight || this.maxHeight;
      this.disable = props.disable || this.disable;
      this.staticStyle = props.staticStyle || this.staticStyle;
      this.message = props.message || message;
    },
    __delayShow: function __delayShow (ref) {
      var target = ref.target; if ( target === void 0 ) target = void 0;
      var props = ref.props;
      var message = ref.message;

      clearTimeout(this.timer);

      if (_.indexOf(target.classList, 's-table-container') > -1 && target.nodeName === 'DIV') {
        return
      }

      this.__setProps({ props: props, message: message });

      this.targetNode = target;
      this.timer = setTimeout(this.show, this.delay);
    },
    __delayHide: function __delayHide () {
      this.anchor = 'top middle';
      this.self = 'bottom middle';
      this.offset = [10, 10];
      // this.delay = 1000
      this.maxHeight = void 0;
      this.disable = false;
      this.message = void 0;
      this.staticStyle = void 0;

      clearTimeout(this.timer);
      this.hide();
    }
  },
  render: function render (h) {
    if (!this.canRender) { return }

    return h('div', {
      staticClass: 's-tooltip animate-popup',
      style: this.staticStyle
    }, [
      h('div', this.message)
    ])
  },
  beforeMount: function beforeMount () {
    var this$1 = this;

    this.__debouncedUpdatePosition = debounce(function () {
      this$1.__updatePosition();
    }, 70);
  },
  mounted: function mounted () {
    var this$1 = this;

    this.$nextTick(function () {
      /*
        The following is intentional.
        Fixes a bug in Chrome regarding offsetHeight by requiring browser
        to calculate this before removing from DOM and using it for first time.
      */
      this$1.$el.offsetHeight; // eslint-disable-line

      this$1.anchorEl = this$1.$el.parentNode;
      this$1.anchorEl.removeChild(this$1.$el);
      if (
        this$1.anchorEl.classList.contains('s-btn-inner') ||
        this$1.anchorEl.classList.contains('s-if-inner') ||
        this$1.anchorEl.classList.contains('no-pointer-events')
      ) {
        this$1.anchorEl = this$1.anchorEl.parentNode;
      }

      this$1.anchorEl.addEventListener('mouseenter', this$1.__delayShow);
      this$1.anchorEl.addEventListener('focus', this$1.__delayShow);
      this$1.anchorEl.addEventListener('mouseleave', this$1.__delayHide);
      this$1.anchorEl.addEventListener('blur', this$1.__delayHide);

      this$1.value && this$1.show();
    });
  },
  beforeDestroy: function beforeDestroy () {
    clearTimeout(this.timer);
    this.showing && this.__cleanup();
    if (!this.anchorEl) {
      return
    }

    this.anchorEl.removeEventListener('mouseenter', this.__delayShow);
    this.anchorEl.removeEventListener('focus', this.__delayShow);
    this.anchorEl.removeEventListener('mouseleave', this.__delayHide);
    this.anchorEl.removeEventListener('blur', this.__delayHide);
  }
};

/**
 * window resize observable
 *
 * @since: 2019-10-07
 * @author: kdydesign.kim
 *
 * Quasar 0.17.18
 */

var windowResizeObservable = {
  name: 'window-resize-observable',
  props: {
    debounce: {
      type: Number,
      default: 80
    }
  },
  render: function render () {},
  methods: {
    trigger: function trigger () {
      if (this.debounce === 0) {
        this.emit();
      } else if (!this.timer) {
        this.timer = setTimeout(this.emit, this.debounce);
      }
    },
    emit: function emit () {
      this.timer = null;

      this.$emit('resize', {
        height: window.innerHeight,
        width: window.innerWidth
      });
    }
  },
  mounted: function mounted () {
    window.addEventListener('resize', this.trigger, listenOpts.passive);
  },
  beforeDestroy: function beforeDestroy () {
    clearTimeout(this.timer);
    window.removeEventListener('resize', this.trigger, listenOpts.passive);
  }
};

/**
 * table store share
 *
 * @since: 2019-10-08
 * @author: kdydesign.kim
 */

var TableStore = {
  props: {
    haForce: {
      type: Boolean,
      default: false
    }
  },
  data: function data () {
    return {
      authDisable: false // true: 활성화, false: 비활성화
    }
  },
  created: function created () {
    if (this.$table.store) {
      var
        common = this.$table.store.state.common,
        blueMaxUiData = common.common.uiData,
        blueMaxLocale = common.locale.locale;

      if (blueMaxUiData) {
        var
          authLevel = blueMaxUiData.user.level,
          haMode = blueMaxUiData.ha.mode.toLowerCase();

        if (authLevel >= 2) {
          this.authDisable = false;
        } else {
          this.authDisable = true;
        }

        // HA 권한 제어(임시)
        if (haMode !== 'stand-alone') {
          var
            haMember = blueMaxUiData.ha.mmbr,
            uuid = blueMaxUiData.system.host_uuid,
            haState = haMember.find(function (mmbr) { return mmbr.mmbr_uuid === uuid; }).state;

          if (haState.toLowerCase() === 'backup' && !this.haForce) {
            this.authDisable = true;
          }
        } else {
          // Stand-ALone
          if (authLevel >= 2) {
            this.authDisable = false;
          } else {
            this.authDisable = true;
          }
        }
      }

      // locale
      this.$table.i18n.set(blueMaxLocale);
    }
  }
};

/**
 * table data load-strategies
 *
 * @since: 2019-12-12
 * @author: kdydesign.kim
 */

var LoadStrategies = {
  computed: {
    computedPageData: function computedPageData () {
      var this$1 = this;

      var cloneData = this.data.slice();

      var rows = cloneData.map(function (row, i) {
        row.__id = Number(_.uniqueId());
        row.__index = i;

        // group expand
        Object.defineProperty(row, '__expand', {
          get: function () { return this$1.rowsExpanded[row[this$1.__getGroupKey]] === void 0 || this$1.rowsExpanded[row[this$1.__getGroupKey]]; },
          set: function (val) { return this$1.$set(this$1.rowsExpanded, row[this$1.__getGroupKey], val); },
          configurable: true,
          enumerable: true
        });

        return row
      });

      if (rows.length === 0) {
        return {
          rowsNumber: 0,
          rows: []
        }
      }

      var ref = this.computedPagination;
      var sortBy = ref.sortBy;
      var descending = ref.descending;
      var rowsPerPage = ref.rowsPerPage;

      if (this.columnToSort) {
        rows = this.sortMethod(rows, sortBy, descending);
      }

      if (this.grouping.use) {
        rows = rows.filter(function (row) { return row.__expand || row[this$1.grouping.isGroupKey]; });
      }

      var rowsNumber = rows.length;

      if (rowsPerPage) {
        rows = rows.slice(this.firstRowIndex, this.lastRowIndex);
      }

      return { rowsNumber: rowsNumber, rows: rows }
    },

    computedVirtualScrollData: function computedVirtualScrollData () {
      var this$1 = this;

      var cloneData = this.data.slice();

      var rows = cloneData.map(function (row, i) {
        row.__id = Number(_.uniqueId());
        row.__index = i;

        // group expand
        Object.defineProperty(row, '__expand', {
          get: function () { return this$1.rowsExpanded[row[this$1.__getGroupKey]] === void 0 || this$1.rowsExpanded[row[this$1.__getGroupKey]]; },
          set: function (val) { return this$1.$set(this$1.rowsExpanded, row[this$1.__getGroupKey], val); },
          configurable: true,
          enumerable: true
        });

        return row
      });

      if (rows.length === 0) {
        return {
          rowsNumber: 0,
          rows: []
        }
      }

      var ref = this.computedPagination;
      var sortBy = ref.sortBy;
      var descending = ref.descending;

      if (this.columnToSort) {
        rows = this.sortMethod(rows, sortBy, descending);
      }

      return {
        rowsNumber: rows.length,
        rows: rows
      }
    },

    computedPageVirtualScrollData: function computedPageVirtualScrollData () {
      var this$1 = this;

      var cloneData = this.data.slice();

      if (this.$refs.tableBody) {
        var start = this.$refs.tableBody.$data.from;
        var end = this.$refs.tableBody.$data.final;

        if (start === 0 && end === 0) {
          end = this.$refs.tableBody.$data.endPosition;
        }

        cloneData = cloneData.slice(start, end);
      }

      var rows = cloneData.map(function (row, i) {
        row.__id = Number(_.uniqueId());

        var start = 0;

        if (this$1.$refs.tableBody) {
          start = this$1.$refs.tableBody.$data.from;
        }

        row.__index = (i += start++);

        return row
      });

      if (rows.length === 0) {
        return {
          rowsNumber: 0,
          rows: []
        }
      }

      var ref = this.computedPagination;
      var sortBy = ref.sortBy;
      var descending = ref.descending;

      if (this.columnToSort) {
        rows = this.sortMethod(rows, sortBy, descending);
      }

      var rowsNumber = this.data.length;

      return { rowsNumber: rowsNumber, rows: rows }
    },

    computedTreeData: function computedTreeData () {
      var this$1 = this;

      var cloneData = this.data.slice();

      // root(전체) 데이터
      var rows = cloneData.map(function (row) {
        Object.defineProperty(row, '__tree_expand', {
          get: function () { return this$1.treeExpanded[row.__index] === void 0 || this$1.treeExpanded[row.__index]; },
          set: function (val) { return this$1.$set(this$1.treeExpanded, row.__index, val); },
          configurable: true,
          enumerable: true
        });

        return row
      });

      if (rows.length === 0) {
        return {
          rowsNumber: 0,
          rows: []
        }
      }

      var ref = this.computedPagination;
      var sortBy = ref.sortBy;
      var descending = ref.descending;
      var rowsPerPage = ref.rowsPerPage;

      if (this.columnToSort) {
        rows = this.sortMethod(rows, sortBy, descending);
      }

      var rowsNumber = rows.length;

      if (rowsPerPage) {
        var treeData = [];
        var index = 0;

        rows = rows.slice(this.firstRowIndex, this.lastRowIndex);

        var flattenTreeData = function (subData) {
          subData.__index = index++;
          subData.__level = subData.level;
          subData.__id = Number(_.uniqueId());

          treeData.push(subData);

          if (subData.hasOwnProperty('children')) {
            var loop = function ( j ) {
              subData.children[j].__level = subData.children[j].level;

              Object.defineProperty(subData.children[j], '__tree_expand', {
                get: function () { return this$1.treeExpanded[subData.children[j].__index] === void 0 || this$1.treeExpanded[subData.children[j].__index]; },
                set: function (val) { return this$1.$set(this$1.treeExpanded, subData.children[j].__index, val); },
                configurable: true,
                enumerable: true
              });

              flattenTreeData(subData.children[j]);
            };

            for (var j = 0; j < subData.children.length; j++) loop( j );
          }
        };

        for (var i = 0; i < rows.length; i++) {
          flattenTreeData(rows[i]);
        }

        rows = treeData;
      }

      return { rowsNumber: rowsNumber, rows: rows }
    }
  }
};

/**
 * Table Container (Main Table)
 *
 * @since 2019-06-18
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

var commonVirtPropsObj = {};

commonVirtPropsList.forEach(function (p) { commonVirtPropsObj[p] = {}; });

var MainTable = {
  name: 'main-table',
  mixins: [
    RowSelection,
    RowDraggable,
    TableHeaderMixin,
    TableBodyMixin,
    TableContextMenu$1,
    Pagination,
    ColumnSelection,
    ColumnResize,
    Expand,
    Sort,
    Tree,
    Group,
    TableStore,
    LoadStrategies
  ],
  props: Object.assign({}, {data: {
      type: Array,
      default: function () { return []; }
    },
    rowKey: {
      type: String,
      default: '__id'
    },
    width: {
      type: [Number, String],
      default: '100%'
    },
    height: {
      type: [Number, String],
      default: '100%'
    },
    minHeight: {
      type: [Number, String, Boolean],
      default: 600
    },
    windowResize: {
      type: Boolean,
      default: false
    },
    pageMargin: {
      type: Number,
      default: 0
    },
    sortable: {
      type: Boolean,
      default: true
    },
    storageResize: {
      type: Boolean,
      default: false
    },
    storageId: {
      type: String,
      default: void 0
    },
    columns: Array,
    virtualScroll: Boolean,
    pageVirtualScroll: Boolean,
    tams: {
      type: Boolean,
      default: true
    },
    cellStyle: Object,
    tableStyle: [String, Array, Object]},
    commonVirtPropsObj,
    {isPopup: Boolean,
    rowDisable: {
      type: Function,
      default: function () {
        return false
      }
    },
    binaryStateSort: Boolean,
    validator: Object}),
  data: function data () {
    return {
      dynamicHeight: this.height
    }
  },
  computed: {
    hasVirtScroll: function hasVirtScroll () {
      return this.virtualScroll === true
    },
    computedData: function computedData () {
      if (this.treeView.use) {
        return this.computedTreeData
      }

      if (this.hasVirtScroll) {
        return this.computedVirtualScrollData
      }

      if (this.pageVirtualScroll) {
        return this.computedPageVirtualScrollData
      }

      return this.computedPageData
    },
    computedRows: function computedRows () {
      var this$1 = this;

      if (this.treeView.use) {
        return this.computedData.rows.filter(function (row) { return row.__tree_expand; })
      }

      if (this.hasVirtScroll) {
        return this.computedData.rows.filter(function (row) { return row.__expand || row[this$1.grouping.isGroupKey]; })
      }

      if (this.pageVirtualScroll) {
        return this.computedData.rows
      }

      return this.computedData.rows.filter(function (row) { return row.__expand || row[this$1.grouping.isGroupKey]; })
    },
    computedRowsNumber: function computedRowsNumber () {
      return this.computedData.rowsNumber
    },
    getContainerSize: function getContainerSize () {
      var height = this.height;

      if (this.windowResize) {
        height = window.innerHeight - this.pageMargin;

        // 연산이 이상한것 같은데?
        if (this.dynamicHeight < this.minHeight) {
          height = this.minHeight;
        }
      }

      var size = {
        width: this.width,
        height: height
      };

      if (typeof this.width === 'number') {
        size = Object.assign(size, {
          width: ((this.width) + "px")
        });
      }

      if (typeof this.dynamicHeight === 'number') {
        size = Object.assign(size, {
          height: (height + "px")
        });
      }

      return size
    },
    isUsedStorage: function isUsedStorage () {
      return this.storageResize && this.storageId
    },
    virtProps: function virtProps () {
      var this$1 = this;

      var props = {};

      commonVirtPropsList
        .forEach(function (p) {
          props[p] = this$1[p];
        });

      if (this.windowResize) {
        props.height = parseInt(this.getBodyHeight);
      }

      return props
    }
  },
  created: function created () {
    if (this.treeView.use) {
      this.treeExpandAll(this.treeView.expandAll);
    }
  },
  methods: {
    refreshTable: function refreshTable () {
      this.resetResizeHandler();

      if (this.hasVirtScroll) {
        this.$refs.virtScroll.refresh(0);
      }
    },
    cancelSortable: function cancelSortable () {
      var bodyEl = void 0;

      if (this.hasVirtScroll) {
        bodyEl = $(this.$refs.virtScroll.$refs.content);
      } else {
        bodyEl = $(this.$refs.tableBody.$refs.bodyTbody);
      }

      bodyEl.sortable('cancel');
    },
    isTAMS: function isTAMS (row) {
      return row.fw_set_id === 0
    },
    getCols: function getCols (h) {
      var this$1 = this;

      return this.computedCols.map(function (colProp, i) {
        var colWidth = colProp.width;

        if (colProp.visible !== false || !_.has(colProp, 'visible')) {
          if (this$1.isUsedStorage) {
            colWidth = this$1.getLocalStorageCols(colProp.field, i) || colProp.width;
          }

          return h('col', {
            key: ("col-" + (colProp.field) + "-" + i),
            attrs: {
              width: colWidth,
              field: colProp.field
            }
          })
        }

        return void 0
      })
    },
    getLocalStorageCols: function getLocalStorageCols (field, index) {
      var storageColWidthList = JSON.parse(localStorage.getItem(this.storageId));

      if (storageColWidthList !== null) {
        if (_.has(_.find(storageColWidthList, { field: field }), 'width')) {
          return ((_.find(storageColWidthList, { field: field }).width) + "px")
        }
      }

      return void 0
    },
    getBody: function getBody (h) {
      if (this.hasVirtScroll) {
        return this.getVirtTableBody(h)
      }

      return this.getTableBody(h)
    },
    getHeader: function getHeader (h) {
      return this.getTableHeader(h)
    },
    getContext: function getContext (h) {
      return this.contextMenu && !this.$slots['context-menu']
        ? this.getContextMenu(h)
        : this.$slots['context-menu']
    },
    getWindowResizeObservable: function getWindowResizeObservable (h) {
      var this$1 = this;

      return h(windowResizeObservable, {
        on: {
          resize: function (ref) {
            var width = ref.width;
            var height = ref.height;

            if (height <= 600 && this$1.minHeight !== false) ; else {
              this$1.dynamicHeight = height;
            }
          }
        }
      })
    }
  },
  beforeDestroy: function beforeDestroy () {
    _.forEach(this.data, function (row) {
      delete row.__expand;
      delete row.__tree_expand;
      delete row.__vs_visibled;
      delete row.__tree_expand_icon;
      // Object.defineProperty(row, '__expand', { value: null })
      // Object.defineProperty(row, '__tree_expand', { value: null })
    });
  },
  render: function render (h) {
    return h('div', {
      'class': 's-table-container',
      style: this.getContainerSize
    }, [
      this.windowResize
        ? this.getWindowResizeObservable(h)
        : void 0,
      this.getHeader(h),
      this.getBody(h),
      this.getContext(h),
      h(ToolTip, {
        ref: 'tooltip'
      })
    ])
  },
  watch: {
    isPopup: function isPopup (value) {
      if (value) {
        this.refreshTable();
      }
    }
  }
};

/**
 * <td> Renderer
 *
 * @since 2019-06-18
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */

var TableTd = {
  name: 'table-td',
  mixins: [RenderComponent],
  props: {
    colType: {
      type: String,
      default: 'textbox'
    },
    componentProps: [Object, Array],
    row: Object,
    col: Object,
    props: Object,
    isCellSelection: Boolean,
    autoWidth: Boolean,
    grouping: Object,
    treeView: [Boolean, Object]
  },
  computed: {
    computedIsCellSelection: function computedIsCellSelection () {
      return this.isCellSelection && this.col.cellSelection
    }
  },
  methods: {
    __isGroup: function __isGroup () {
      return this.grouping.use && this.row[this.grouping.isGroupKey]
    }
  },
  destroyed: function destroyed () {
    this.$el.remove();
  },
  render: function render (h) {
    var this$1 = this;

    if (!this.props) {
      return h('td', {
        'class': {
          'q-table-col-auto-width': this.autoWidth
        }
      }, this.$slots.default)
    }

    var col;
    var row = this.props.row;
    var rowDisable = this.props.rowDisable;
    var name = this.$vnode.key;

    if (name) {
      col = this.props.colsMap[name];
      if (!col) { return }
    } else {
      col = this.props.col;
    }

    return h('td', {
      'class': [
        col.__tdClass,
        {
          's-table-col-auto-width': this.autoWidth,
          'disable': rowDisable
        }
      ],
      on: {
        mouseenter: function (evt) { return this$1.onMouseEnterHandler({ h: h, col: col, row: row, evt: evt }); },
        mouseleave: function (evt) { return this$1.onMouseLeaveHandler({ col: col, evt: evt }); },
        contextmenu: function (evt) { return this$1.onContextMenuHandler({ col: col, row: row, evt: evt }); }
      }
    }, this.$slots.default)
  }
};

/**
 * material-icon
 *
 * @since 2019-07-01
 * @author kdydesign.kim
 *
 * quasar 0.17.18
 */
var materialIcons = {
  name: 'material-icons',
  type: {
    positive: 'check_circle',
    negative: 'warning',
    info: 'info',
    warning: 'priority_high'
  },
  arrow: {
    up: 'arrow_upward',
    right: 'arrow_forward',
    down: 'arrow_downward',
    left: 'arrow_back'
  },
  chevron: {
    left: 'chevron_left',
    right: 'chevron_right'
  },

  pullToRefresh: {
    arrow: 'arrow_downward',
    refresh: 'refresh'
  },
  search: {
    icon: 'search',
    clear: 'cancel',
    clearInverted: 'clear'
  },
  carousel: {
    left: 'chevron_left',
    right: 'chevron_right',
    quickNav: 'lens',
    thumbnails: 'view_carousel'
  },
  checkbox: {
    checked: {
      ios: 'check_circle',
      mat: 'check_box'
    },
    unchecked: {
      ios: 'radio_button_unchecked',
      mat: 'check_box_outline_blank'
    },
    indeterminate: {
      ios: 'remove_circle_outline',
      mat: 'indeterminate_check_box'
    }
  },
  chip: {
    close: 'cancel'
  },
  chipsInput: {
    add: 'send'
  },
  collapsible: {
    icon: 'arrow_drop_down'
  },
  datetime: {
    arrowLeft: 'chevron_left',
    arrowRight: 'chevron_right'
  },
  editor: {
    bold: 'format_bold',
    italic: 'format_italic',
    strikethrough: 'strikethrough_s',
    underline: 'format_underlined',
    unorderedList: 'format_list_bulleted',
    orderedList: 'format_list_numbered',
    subscript: 'vertical_align_bottom',
    superscript: 'vertical_align_top',
    hyperlink: 'link',
    toggleFullscreen: 'fullscreen',
    quote: 'format_quote',
    left: 'format_align_left',
    center: 'format_align_center',
    right: 'format_align_right',
    justify: 'format_align_justify',
    print: 'print',
    outdent: 'format_indent_decrease',
    indent: 'format_indent_increase',
    removeFormat: 'format_clear',
    formatting: 'text_format',
    fontSize: 'format_size',
    align: 'format_align_left',
    hr: 'remove',
    undo: 'undo',
    redo: 'redo',
    header: 'format_size',
    code: 'code',
    size: 'format_size',
    font: 'font_download'
  },
  fab: {
    icon: 'add',
    activeIcon: 'close'
  },
  input: {
    showPass: 'visibility',
    hidePass: 'visibility_off',
    showNumber: 'keyboard',
    hideNumber: 'keyboard_hide',
    clear: 'cancel',
    clearInverted: 'clear',
    dropdown: 'arrow_drop_down'
  },
  pagination: {
    first: 'first_page',
    prev: 'keyboard_arrow_left',
    next: 'keyboard_arrow_right',
    last: 'last_page'
  },
  radio: {
    checked: {
      ios: 'check',
      mat: 'radio_button_checked'
    },
    unchecked: {
      ios: '',
      mat: 'radio_button_unchecked'
    }
  },
  rating: {
    icon: 'grade'
  },
  stepper: {
    done: 'check',
    active: 'edit',
    error: 'warning'
  },
  tabs: {
    left: 'chevron_left',
    right: 'chevron_right'
  },
  table: {
    arrowUp: 'arrow_upward',
    warning: 'warning',
    prevPage: 'chevron_left',
    nextPage: 'chevron_right'
  },
  tree: {
    icon: 'play_arrow'
  },
  uploader: {
    done: 'done',
    clear: 'cancel',
    clearInverted: 'clear',
    add: 'add',
    upload: 'cloud_upload',
    expand: 'keyboard_arrow_down',
    file: 'insert_drive_file'
  }
};

/**
 * export material icon set
 *
 * @since 2019-07-01
 * @author kdydesign.kim
 */

var Icons = {
  __installed: false,
  install: function install ($table, Vue, iconSet) {
    var this$1 = this;

    this.set = function (iconDef) {
      if ( iconDef === void 0 ) iconDef = materialIcons;

      iconDef.set = this$1.set;

      if ($table.icon) {
        $table.icon = iconDef;
      } else {
        Vue.util.defineReactive($table, 'icon', iconDef);
      }

      this$1.name = iconDef.name;
      this$1.def = iconDef;
    };

    this.set(iconSet);
  }
};

/**
 * close-overlay
 *
 * @since 2019-07-09
 * @author kdydesign.kim
 *
 * Quasar 0.17.18
 */
var TableCloseOverlay = {
  name: 'table-close-overlay',
  bind: function bind (el, binding, vnode) {
    var
      handler = function (ev) {
        if (!binding.value) {
          return
        }

        var vm = vnode.componentInstance;

        while ((vm = vm.$parent)) {
          var name = vm.$options.name;
          if (name === 'popover' || name === 'modal') {
            vm.hide(ev);
            break
          }
        }
      },
      handlerKey = function (ev) {
        if (ev.keyCode === 13) {
          handler(ev);
        }
      };

    el.__qclose = { handler: handler, handlerKey: handlerKey };
    el.addEventListener('click', handler);
    el.addEventListener('keyup', handlerKey);
  },
  unbind: function unbind (el) {
    var ctx = el.__qclose;

    if (!ctx) { return }

    el.removeEventListener('click', ctx.handler);
    el.removeEventListener('keyup', ctx.handlerKey);

    delete el.__qclose;
  }
};

/* eslint-disable no-useless-escape */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-mixed-operators */

function getMatch (userAgent, platformMatch) {
  var match = /(edge|edga|edgios)\/([\w.]+)/.exec(userAgent) ||
    /(opr)[\/]([\w.]+)/.exec(userAgent) ||
    /(vivaldi)[\/]([\w.]+)/.exec(userAgent) ||
    /(chrome|crios)[\/]([\w.]+)/.exec(userAgent) ||
    /(iemobile)[\/]([\w.]+)/.exec(userAgent) ||
    /(version)(applewebkit)[\/]([\w.]+).*(safari)[\/]([\w.]+)/.exec(userAgent) ||
    /(webkit)[\/]([\w.]+).*(version)[\/]([\w.]+).*(safari)[\/]([\w.]+)/.exec(userAgent) ||
    /(firefox|fxios)[\/]([\w.]+)/.exec(userAgent) ||
    /(webkit)[\/]([\w.]+)/.exec(userAgent) ||
    /(opera)(?:.*version|)[\/]([\w.]+)/.exec(userAgent) ||
    /(msie) ([\w.]+)/.exec(userAgent) ||
    (userAgent.indexOf('trident') >= 0 && /(rv)(?::| )([\w.]+)/.exec(userAgent)) ||
    (userAgent.indexOf('compatible') < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(userAgent)) ||
    [];

  return {
    browser: match[5] || match[3] || match[1] || '',
    version: match[2] || match[4] || '0',
    versionNumber: match[4] || match[2] || '0',
    platform: platformMatch[0] || ''
  }
}

function getPlatformMatch (userAgent) {
  return /(ipad)/.exec(userAgent) ||
    /(win)/.exec(userAgent) ||
    /(mac)/.exec(userAgent) ||
    /(linux)/.exec(userAgent) ||
    /(cros)/.exec(userAgent) ||
    /(playbook)/.exec(userAgent) ||
    /(bb)/.exec(userAgent) ||
    /(blackberry)/.exec(userAgent) ||
    []
}

var hasTouch = 'ontouchstart' in window || window.navigator.maxTouchPoints > 0;

function getPlatform (UA) {
  var
    userAgent = UA.toLowerCase(),
    platformMatch = getPlatformMatch(userAgent),
    matched = getMatch(userAgent, platformMatch),
    browser = {};

  if (matched.browser) {
    browser[matched.browser] = true;
    browser.version = matched.version;
    browser.versionNumber = parseInt(matched.versionNumber, 10);
  }

  if (matched.platform) {
    browser[matched.platform] = true;
  }

  browser.desktop = true;

  if (
    browser.chrome ||
    browser.opr ||
    browser.safari ||
    browser.vivaldi
  ) {
    browser.webkit = true;
  }

  // IE11 has a new token so we will assign it msie to avoid breaking changes
  if (browser.rv || browser.iemobile) {
    matched.browser = 'ie';
    browser.ie = true;
  }

  // Blackberry browsers are marked as Safari on BlackBerry
  if (browser.safari && browser.blackberry || browser.bb) {
    matched.browser = 'blackberry';
    browser.blackberry = true;
  }

  // Playbook browsers are marked as Safari on Playbook
  if (browser.safari && browser.playbook) {
    matched.browser = 'playbook';
    browser.playbook = true;
  }

  // Opera 15+ are identified as opr
  if (browser.opr) {
    matched.browser = 'opera';
    browser.opera = true;
  }

  // Stock Android browsers are marked as Safari on Android.
  if (browser.safari && browser.android) {
    matched.browser = 'android';
    browser.android = true;
  }

  // Kindle browsers are marked as Safari on Kindle
  if (browser.safari && browser.kindle) {
    matched.browser = 'kindle';
    browser.kindle = true;
  }

  // Kindle Silk browsers are marked as Safari on Kindle
  if (browser.safari && browser.silk) {
    matched.browser = 'silk';
    browser.silk = true;
  }

  if (browser.vivaldi) {
    matched.browser = 'vivaldi';
    browser.vivaldi = true;
  }

  // Assign the name and platform variable
  browser.name = matched.browser;
  browser.platform = matched.platform;

  return browser
}

var userAgent = navigator.userAgent || navigator.vendor || window.opera;

// We export "client" for hydration error-free parts,
// like touch directives who do not (and must NOT) wait
// for the client takeover;
// Do NOT import this directly in your app, unless you really know
// what you are doing.
var client = {
  userAgent: userAgent,
  is: getPlatform(userAgent),
  has: {
    touch: hasTouch,
    webStorage: (function () {
      try {
        if (window.localStorage) {
          return true
        }
      } catch (e) {}
      return false
    })()
  },
  within: {
    iframe: window.self !== window.top
  }
};

var directions = ['left', 'right', 'up', 'down', 'horizontal', 'vertical'];

var modifiersAll = {
  left: true,
  right: true,
  up: true,
  down: true,
  horizontal: true,
  vertical: true,
  all: true
};

function getModifierDirections (mod) {
  var dir = {};

  directions.forEach(function (direction) {
    if (mod[direction]) {
      dir[direction] = true;
    }
  });

  if (Object.keys(dir).length === 0) {
    return modifiersAll
  }

  if (dir.horizontal === true) {
    dir.left = dir.right = true;
  }
  if (dir.vertical === true) {
    dir.up = dir.down = true;
  }
  if (dir.left === true && dir.right === true) {
    dir.horizontal = true;
  }
  if (dir.up === true && dir.down === true) {
    dir.vertical = true;
  }
  if (dir.horizontal === true && dir.vertical === true) {
    dir.all = true;
  }

  return dir
}

var getTouchTarget = (
  window.navigator.vendor.toLowerCase().indexOf('apple') > -1
)
  ? function () { return document; }
  : function (target) { return target; };

function shouldStart (evt, ctx) {
  return ctx.event === void 0 &&
    evt.target !== void 0 &&
    evt.target.draggable !== true &&
    typeof ctx.handler === 'function' &&
    evt.target.nodeName.toUpperCase() !== 'INPUT' &&
    (evt.qClonedBy === void 0 || evt.qClonedBy.indexOf(ctx.uid) === -1)
}

function clearSelection () {
  if (window.getSelection !== void 0) {
    var selection = window.getSelection();
    if (selection.empty !== void 0) {
      selection.empty();
    } else if (selection.removeAllRanges !== void 0) {
      selection.removeAllRanges();
      selection.addRange(document.createRange());
    }
  } else if (document.selection !== void 0) {
    document.selection.empty();
  }
}

function getChanges (evt, ctx, isFinal) {
  var pos = position(evt);
  var
    dir,
    distX = pos.left - ctx.event.x,
    distY = pos.top - ctx.event.y,
    absX = Math.abs(distX),
    absY = Math.abs(distY);

  var direction = ctx.direction;

  if (direction.horizontal === true && direction.vertical !== true) {
    dir = distX < 0 ? 'left' : 'right';
  } else if (direction.horizontal !== true && direction.vertical === true) {
    dir = distY < 0 ? 'up' : 'down';
  } else if (direction.up === true && distY < 0) {
    dir = 'up';
    if (absX > absY) {
      if (direction.left === true && distX < 0) {
        dir = 'left';
      } else if (direction.right === true && distX > 0) {
        dir = 'right';
      }
    }
  } else if (direction.down === true && distY > 0) {
    dir = 'down';
    if (absX > absY) {
      if (direction.left === true && distX < 0) {
        dir = 'left';
      } else if (direction.right === true && distX > 0) {
        dir = 'right';
      }
    }
  } else if (direction.left === true && distX < 0) {
    dir = 'left';
    if (absX < absY) {
      if (direction.up === true && distY < 0) {
        dir = 'up';
      } else if (direction.down === true && distY > 0) {
        dir = 'down';
      }
    }
  } else if (direction.right === true && distX > 0) {
    dir = 'right';
    if (absX < absY) {
      if (direction.up === true && distY < 0) {
        dir = 'up';
      } else if (direction.down === true && distY > 0) {
        dir = 'down';
      }
    }
  }

  var synthetic = false;

  if (dir === void 0 && isFinal === false) {
    if (ctx.event.isFirst === true || ctx.event.lastDir === void 0) {
      return {}
    }

    dir = ctx.event.lastDir;
    synthetic = true;

    if (dir === 'left' || dir === 'right') {
      pos.left -= distX;
      absX = 0;
      distX = 0;
    } else {
      pos.top -= distY;
      absY = 0;
      distY = 0;
    }
  }

  return {
    synthetic: synthetic,
    payload: {
      evt: evt,
      touch: ctx.event.mouse !== true,
      mouse: ctx.event.mouse === true,
      position: pos,
      direction: dir,
      isFirst: ctx.event.isFirst,
      isFinal: isFinal === true,
      duration: Date.now() - ctx.event.time,
      distance: {
        x: absX,
        y: absY
      },
      offset: {
        x: distX,
        y: distY
      },
      delta: {
        x: pos.left - ctx.event.lastX,
        y: pos.top - ctx.event.lastY
      }
    }
  }
}

function destroy (el) {
  var ctx = el.__stouchpan;
  if (ctx !== void 0) {
    // emit the end event when the directive is destroyed while active
    // this is only needed in TouchPan because the rest of the touch directives do not emit an end event
    // the condition is also checked in the start of function but we avoid the call
    ctx.event !== void 0 && ctx.end();

    cleanEvt(ctx, 'main');
    cleanEvt(ctx, 'temp');

    client.is.firefox === true && preventDraggable(el, false);
    ctx.styleCleanup !== void 0 && ctx.styleCleanup();

    delete el.__stouchpan;
  }
}

var uid = 0;

var TouchMovePan = {
  name: 'touch-move-pan',

  bind: function bind (el, ref) {
    var value = ref.value;
    var modifiers = ref.modifiers;

    if (el.__stouchpan !== void 0) {
      destroy(el);
      el.__stouchpan_destroyed = true;
    }

    // early return, we don't need to do anything
    if (modifiers.mouse !== true && client.has.touch !== true) {
      return
    }

    function handleEvent (evt, mouseEvent) {
      if (modifiers.mouse === true && mouseEvent === true) {
        stopAndPrevent(evt);
      } else {
        modifiers.stop === true && stop(evt);
        modifiers.prevent === true && prevent(evt);
      }
    }

    var ctx = {
      uid: 'qvtp_' + (uid++),
      handler: value,
      modifiers: modifiers,
      direction: getModifierDirections(modifiers),

      noop: noop,

      mouseStart: function mouseStart (evt) {
        if (shouldStart(evt, ctx) && leftClick(evt)) {
          addEvt(ctx, 'temp', [
            [document, 'mousemove', 'move', 'notPassiveCapture'],
            [document, 'mouseup', 'end', 'passiveCapture']
          ]);

          ctx.start(evt, true);
        }
      },

      touchStart: function touchStart (evt) {
        if (shouldStart(evt, ctx)) {
          var target = getTouchTarget(evt.target);

          addEvt(ctx, 'temp', [
            [target, 'touchmove', 'move', 'notPassiveCapture'],
            [target, 'touchcancel', 'end', 'passiveCapture'],
            [target, 'touchend', 'end', 'passiveCapture']
          ]);

          ctx.start(evt);
        }
      },

      start: function start (evt, mouseEvent) {
        client.is.firefox === true && preventDraggable(el, true);
        ctx.lastEvt = evt;

        var pos = position(evt);

        /*
         * Stop propagation so possible upper v-touch-pan don't catch this as well;
         * If we're not the target (based on modifiers), we'll re-emit the event later
         */
        if (mouseEvent === true || modifiers.stop === true) {
          /*
           * are we directly switching to detected state?
           * clone event only otherwise
           */
          if (
            ctx.direction.all !== true &&
            (mouseEvent !== true || ctx.direction.mouseAllDir !== true)
          ) {
            var clone = evt.type.indexOf('mouse') > -1
              ? new MouseEvent(evt.type, evt)
              : new TouchEvent(evt.type, evt);

            evt.defaultPrevented === true && prevent(clone);
            evt.cancelBubble === true && stop(clone);

            clone.qClonedBy = evt.qClonedBy === void 0
              ? [ctx.uid]
              : evt.qClonedBy.concat(ctx.uid);
            clone.qKeyEvent = evt.qKeyEvent;
            clone.qClickOutside = evt.qClickOutside;

            ctx.initialEvent = {
              target: evt.target,
              event: clone
            };
          }

          stop(evt);
        }

        ctx.event = {
          x: pos.left,
          y: pos.top,
          time: Date.now(),
          mouse: mouseEvent === true,
          detected: false,
          isFirst: true,
          isFinal: false,
          lastX: pos.left,
          lastY: pos.top
        };
      },

      move: function move (evt) {
        if (ctx.event === void 0) {
          return
        }

        ctx.lastEvt = evt;

        var isMouseEvt = ctx.event.mouse === true;
        var start = function () {
          handleEvent(evt, isMouseEvt);

          if (modifiers.preserveCursor !== true) {
            document.documentElement.style.cursor = 'grabbing';
          }
          isMouseEvt === true && document.body.classList.add('no-pointer-events--children');
          document.body.classList.add('non-selectable');
          clearSelection();

          ctx.styleCleanup = function (withDelayedFn) {
            ctx.styleCleanup = void 0;

            if (modifiers.preserveCursor !== true) {
              document.documentElement.style.cursor = '';
            }
            document.body.classList.remove('non-selectable');

            if (isMouseEvt === true) {
              var remove = function () {
                document.body.classList.remove('no-pointer-events--children');
              };

              if (withDelayedFn !== void 0) {
                setTimeout(function () {
                  remove();
                  withDelayedFn();
                }, 50);
              } else { remove(); }
            } else if (withDelayedFn !== void 0) {
              withDelayedFn();
            }
          };
        };

        if (ctx.event.detected === true) {
          ctx.event.isFirst !== true && handleEvent(evt, ctx.event.mouse);

          var ref = getChanges(evt, ctx, false);
          var payload = ref.payload;
          var synthetic = ref.synthetic;

          if (payload !== void 0) {
            if (ctx.handler(payload) === false) {
              ctx.end(evt);
            } else {
              if (ctx.styleCleanup === void 0 && ctx.event.isFirst === true) {
                start();
              }

              ctx.event.lastX = payload.position.left;
              ctx.event.lastY = payload.position.top;
              ctx.event.lastDir = synthetic === true ? void 0 : payload.direction;
              ctx.event.isFirst = false;
            }
          }

          return
        }

        if (
          ctx.direction.all === true ||
          (isMouseEvt === true && ctx.modifiers.mouseAllDir === true)
        ) {
          start();
          ctx.event.detected = true;
          ctx.move(evt);
          return
        }

        var
          pos = position(evt),
          distX = pos.left - ctx.event.x,
          distY = pos.top - ctx.event.y,
          absX = Math.abs(distX),
          absY = Math.abs(distY);

        if (absX !== absY) {
          if (
            (ctx.direction.horizontal === true && absX > absY) ||
            (ctx.direction.vertical === true && absX < absY) ||
            (ctx.direction.up === true && absX < absY && distY < 0) ||
            (ctx.direction.down === true && absX < absY && distY > 0) ||
            (ctx.direction.left === true && absX > absY && distX < 0) ||
            (ctx.direction.right === true && absX > absY && distX > 0)
          ) {
            ctx.event.detected = true;
            ctx.move(evt);
          } else {
            ctx.end(evt, true);
          }
        }
      },

      end: function end (evt, abort) {
        if (ctx.event === void 0) {
          return
        }

        cleanEvt(ctx, 'temp');
        client.is.firefox === true && preventDraggable(el, false);

        if (abort === true) {
          ctx.styleCleanup !== void 0 && ctx.styleCleanup();

          if (ctx.event.detected !== true && ctx.initialEvent !== void 0) {
            ctx.initialEvent.target.dispatchEvent(ctx.initialEvent.event);
          }
        } else if (ctx.event.detected === true) {
          ctx.event.isFirst === true && ctx.handler(getChanges(evt === void 0 ? ctx.lastEvt : evt, ctx).payload);

          var ref = getChanges(evt === void 0 ? ctx.lastEvt : evt, ctx, true);
          var payload = ref.payload;
          var fn = function () { ctx.handler(payload); };

          if (ctx.styleCleanup !== void 0) {
            ctx.styleCleanup(fn);
          } else {
            fn();
          }
        }

        ctx.event = void 0;
        ctx.initialEvent = void 0;
        ctx.lastEvt = void 0;
      }
    };

    el.__stouchpan = ctx;

    modifiers.mouse === true && addEvt(ctx, 'main', [
      [el, 'mousedown', 'mouseStart', ("passive" + (modifiers.mouseCapture === true ? 'Capture' : ''))]
    ]);

    client.has.touch === true && addEvt(ctx, 'main', [
      [el, 'touchstart', 'touchStart', ("passive" + (modifiers.capture === true ? 'Capture' : ''))],
      [el, 'touchmove', 'noop', 'notPassiveCapture']
    ]);
  },

  update: function update (el, ref) {
    var oldValue = ref.oldValue;
    var value = ref.value;

    var ctx = el.__stouchpan;
    if (ctx !== void 0 && oldValue !== value) {
      typeof value !== 'function' && ctx.end();
      ctx.handler = value;
    }
  },

  unbind: function unbind (el) {
    if (el.__stouchpan_destroyed === void 0) {
      destroy(el);
    } else {
      delete el.__stouchpan_destroyed;
    }
  }
};

/**
 * export install
 *
 * @since 2019-06-18
 * @author kdydesign.kim
 */

function install (_Vue, opts) {
  if ( opts === void 0 ) opts = {};

  if (this.__installed) {
    return
  }

  this.__installed = true;

  var $table = {};

  // plugin
  Icons.install($table, _Vue, opts.iconSet);
  store.install($table, _Vue, opts.store);
  i18n.install($table, _Vue, opts.i18n);

  // components
  _Vue.component('vue-table', MainTable);
  _Vue.component('vue-table-tr', TableTr);
  _Vue.component('vue-table-th', TableTh);
  _Vue.component('vue-table-td', TableTd);
  _Vue.component('vue-table-virl', VirtualList);
  _Vue.component('draggable', Draggable);

  // directives
  _Vue.directive('ripple', Ripple);
  _Vue.directive('table-close-overlay', TableCloseOverlay);
  _Vue.directive('touch-move-pan', TouchMovePan);

  // set prototype
  _Vue.prototype.$table = $table;
}

/**
 * export
 *
 * @since 2019-06-18
 * @author kdydesign.kim
 */

var index = {
  install: install,
  store: store,
  i18n: i18n
};

export default index;
export { MainTable, TableTd, TableTh, TableTr };
